webpackJsonp([0],{

/***/ "+GEd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about-img2.01f857a.png";

/***/ }),

/***/ "+dhH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_utils__ = __webpack_require__("JaHG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isB1Visible: true,
      isB2Visible: false,
      isB3Visible: false,
      isB4Visible: false
    };
  },

  computed: {},
  methods: {},
  created: function created() {
    var _this = this;

    $(window).on('scroll', function () {
      _this.isB1Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#design-b1');
      _this.isB2Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#design-b2');
      _this.isB3Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#design-b3');
      _this.isB4Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#design-b4');
    });
  }
});

/***/ }),

/***/ "+hbr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-design-b2.dba76cd.jpg";

/***/ }),

/***/ "+j1+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_design_vue__ = __webpack_require__("EieD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51f0bf84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_design_vue__ = __webpack_require__("MGcR");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("EbSX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_design_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51f0bf84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_design_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\views\\robot\\3s\\design.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-51f0bf84", Component.options)
  } else {
    hotAPI.reload("data-v-51f0bf84", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+mNl":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("V8SB");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("70241b3e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-021a1df4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./info.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-021a1df4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./info.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "//XY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-info-b3.3b58855.jpg";

/***/ }),

/***/ "/HRF":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.robot-design .w {\n  position: relative;\n  height: 100%;\n}\n.robot-design .w .p1 {\n  font-size: 40px;\n}\n.robot-design .w .p2 {\n  font-size: 16px;\n}\n.robot-design.robot2s {\n  color: #fff;\n}\n.robot-design.robot2s #design-b1 {\n  background-image: url(" + escape(__webpack_require__("b64E")) + ");\n  padding-top: 150px;\n  text-align: center;\n}\n.robot-design.robot2s #design-b2 {\n  background-image: url(" + escape(__webpack_require__("BDu5")) + ");\n}\n.robot-design.robot2s #design-b2 .p1,\n.robot-design.robot2s #design-b2 .p2 {\n  position: absolute;\n}\n.robot-design.robot2s #design-b2 .p1 {\n  left: 760px;\n  bottom: 370px;\n}\n.robot-design.robot2s #design-b2 .p2 {\n  left: 930px;\n  bottom: 377px;\n}\n.robot-design.robot2s #design-b3 {\n  background-image: url(" + escape(__webpack_require__("BEoZ")) + ");\n}\n.robot-design.robot2s #design-b3 .w {\n  padding: 100px 0 0 10px;\n}\n.robot-design.robot2s #design-b4 {\n  background-image: url(" + escape(__webpack_require__("Xz3Y")) + ");\n}\n.robot-design.robot2s #design-b4 .w {\n  text-align: center;\n  padding-top: 100px;\n}\n.robot-design.robot2s #design-b4 .p2 {\n  line-height: 1.8;\n  margin-bottom: 90px;\n}\n.robot-design .banner {\n  height: 1000px;\n  min-width: 1200px;\n  background-size: auto 100%;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n.is-mobile .robot2s #design-b1,\n.is-mobile .robot2s #design-b2,\n.is-mobile .robot2s #design-b3,\n.is-mobile .robot2s #design-b4 {\n  width: 100%;\n  min-width: inherit;\n  height: 34.375rem;\n}\n.is-mobile .robot2s #design-b1 {\n  background-image: url(" + escape(__webpack_require__("q6H2")) + ");\n  padding-top: 4.6875rem;\n}\n.is-mobile .robot2s #design-b2 {\n  background-image: url(" + escape(__webpack_require__("C0Lz")) + ");\n}\n.is-mobile .robot2s #design-b2 .p1 {\n  top: 22.8125rem;\n  left: 7.8125rem;\n}\n.is-mobile .robot2s #design-b2 .p2 {\n  top: 23.5625rem;\n  left: 13.75rem;\n}\n.is-mobile .robot2s #design-b3 {\n  background-image: url(" + escape(__webpack_require__("AM7t")) + ");\n}\n.is-mobile .robot2s #design-b3 .w {\n  padding: 3.125rem 6.25rem 0 0;\n  text-align: right;\n}\n.is-mobile .robot2s #design-b4 {\n  background-image: url(" + escape(__webpack_require__("WAnI")) + ");\n}\n.is-mobile .robot2s #design-b4 .w {\n  padding: 2.5rem 0 0 1.25rem;\n  text-align: left;\n}\n.is-mobile .robot2s #design-b4 .w .p2 {\n  margin: 0;\n}\n.is-mobile .robot-design .w .p1 {\n  font-size: 1.4375rem;\n}\n.is-mobile .robot-design .w .p2 {\n  font-size: 0.75rem;\n}\n", ""]);

// exports


/***/ }),

/***/ "/Hx1":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAkCAMAAADfNcjQAAAAh1BMVEVMaXFmZmZmZmZlZWVlZWVlZWVmZmZoaGhlZWVpaWllZWVlZWVlZWVlZWVlZWVmZmZmZmZmZmZlZWVmZmZjY2NmZmZlZWVlZWVfX19lZWVmZmZkZGRlZWVmZmZlZWVmZmZlZWVmZmZmZmZmZmZmZmZmZmZlZWVlZWVlZWVmZmZlZWVmZmZmZmYP7B49AAAALHRSTlMAFF7XIZP6A/QKZewa/bJEcN48/BCAVYsGNKIumcH3eoRrquPHzdNNJvHnut0ziVsAAAHaSURBVHjadVPbloIwEBukWioIIqCCUEHxgub/v2/pSEXZ3by0DWmazFHq4Syf2psr+g9HDfgentISm+faoRE76HIjnQsyyywBr34b5ugOZhVaB5Y7zDXO0XCYY22dstE2OGE18BUEMQRc+sBM48ibx8KGu+JuFjVvUo7aYWbW5DymZUIA3dpcihLP3ED8NkX9ilgmCJXpj+pLsMXctnBR7YmkixuR31lBzX0Y6YXFN2PhQr1uFUkiDDkz58BHTiRjCDphw8VX8Ldm4yLOeZrhYJph+Up4GpxC+AHR/rFy+qq9LMLJ8JnpaGdbEFGJ3lAhJrXwJVdaWoHydM80yHiMRE9E/MSOLFqIPiz3iNF/Ysc7rmRxhWOmshsEqacdZjdW4BptxlPRPoc6cq/qHcL0Cc0FgZbdH4rn2tAH1idpnufpFxx4kywimmCHm1nEwgv4Ed1XzYvwmFqBWMpBGJJRJLiUCYBuO3FSMZjKW8Br8hKoJ4oIneDNobmbY4fsV5qLohF5h8krskIoPy1XXfCtcFwU8suypG+IM4r9eEy7hZoo7jEqhyz4lzZBcBn/kCRb5DSFKoAyeG1DXCX9xvYBXR6I7i1cQX8hrT3Aj4F2jDOVNG2yuq7fhX4AYRosplT3WG0AAAAASUVORK5CYII="

/***/ }),

/***/ "/mVd":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("gTka");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0d856766", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ae5b5c6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ae5b5c6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "/usn":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAAAAXNSR0IArs4c6QAAAktJREFUSEu1lb+LE0EUx78vuik0RLCxOZUoaGcjyFkoQa3sVNYmyM5sQkQQf1RicXJaXWFxWAguxHkLQZDANf4B8SxEEbVRG8VC7AR/xKgY4z7ZIzly+XWz8W6bmdl57/t57+3MW8IEj+d5F8IwvJXElZIYx7a+7+8VkdcA9hlj3tj6JwZ5nnc7lUqdAxAYY86uC8h13a2ZTOYDgM0AfjSbzR21Wu2zDSxRRkqpK0Q01xUWkavMvLweB7QG5fP5jblc7h2AnT2CHx3H2RUEwZ/VsrIG+b5/WkTu9wuKSIGZ760ZSGv9GMDBIYJPjTHTVqBCoZBNp9NTALZHUTRFREvzeBSR7jw7Ruw3gAaAbwC+d8Z43RCRBhG9Wiqd1voagOurRTXh/iciOrT8jdYDFmcjIkfCMHy+4jCsJUxEfgE4zswP40oMnDql1AwR3ZiwTF23toicZOYH3RdDj/d/wiIAnjGm2hvsyHs0IUwAXDLGDHT2sRdWKVUlokKCMlaNMWeG2Y8Faa0XAJywBYnIAjOfSgxSSr0nopwtCMBbY8yeRKByubyl1Wp9ISLrfgjgr+M42SAIfvbDRooUi8XDURQtjsimLiJZIto/pMkeYOZn1iCl1EUimu9zqMetyhiz6Lruhkwmc7nTujb1/KOKzHzXGqS1jo11x6GeSqVmK5XKo34Bz/N2E9EdIjoa74nIPDPHAax4RpZOa/0CwNcoimbDMBwA9AtpreOgborIS2Y+Zg1SSk0z85MEJw6lUmlbu92eYebz1qAkABvbfzSZ2vPL2Q2vAAAAAElFTkSuQmCC"

/***/ }),

/***/ "/z3w":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dialog2.f9cf08f.png";

/***/ }),

/***/ "07wV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner-about.adfb989.jpg";

/***/ }),

/***/ "0bzJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "1Acb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_utils__ = __webpack_require__("JaHG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isTabsVisible: true,
      robot3Show: DB.robot3Show
    };
  },

  computed: {},
  methods: {
    handleTab: function handleTab(index) {
      this.tab = index;
    }
  },
  created: function created() {
    var _this = this;

    if (this.robot3Show) {
      $(window).on('scroll', function () {
        _this.isTabsVisible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#tabs');
      });
    }
  }
});

/***/ }),

/***/ "1juE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-info-b3.566a498.png";

/***/ }),

/***/ "216z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cp-robot" },
    [
      _c("div", { attrs: { id: "link-robot2s" } }),
      _c("transition", { attrs: { name: "fadeUp" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isTabsVisible,
                expression: "!isTabsVisible"
              }
            ],
            staticClass: "tabs fixed"
          },
          [
            _c("router-link", { attrs: { to: "/robot2s/info" } }, [
              _vm._v("功能")
            ]),
            _c("router-link", { attrs: { to: "/robot2s/design" } }, [
              _vm._v("设计")
            ]),
            _c("router-link", { attrs: { to: "/robot2s/spec" } }, [
              _vm._v("技术规格")
            ])
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "tabs", attrs: { id: "tabs" } },
        [
          _c("router-link", { attrs: { to: "/robot2s/info" } }, [
            _vm._v("功能")
          ]),
          _c("router-link", { attrs: { to: "/robot2s/design" } }, [
            _vm._v("设计")
          ]),
          _c("router-link", { attrs: { to: "/robot2s/spec" } }, [
            _vm._v("技术规格")
          ])
        ],
        1
      ),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ae5b5c6", esExports)
  }
}

/***/ }),

/***/ "21Pe":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "26dS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("iFcm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a4bed13_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("ZfXq");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("P2Hj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a4bed13_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\views\\home.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5a4bed13", Component.options)
  } else {
    hotAPI.reload("data-v-5a4bed13", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2fre":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "robot-info robot3" }, [
    _c("div", { attrs: { id: "info-b1" } }, [
      _c("div", { staticClass: "bg-mask", class: { zoomIn: _vm.isB1Visible } }),
      _c("div", { staticClass: "w" }, [
        _c(
          "div",
          { staticClass: "p1 delay3", class: { fadeUp: _vm.isB1Visible } },
          [_vm._v("维拉3，定义AI智慧生活")]
        ),
        _c(
          "div",
          { staticClass: "p2 delay4", class: { fadeUp: _vm.isB1Visible } },
          [_vm._v("既能认识环境与人，又能连接万物")]
        ),
        _c(
          "div",
          { staticClass: "p3 delay5", class: { fadeUp: _vm.isB1Visible } },
          [_vm._v("自身环境认知 | 人体动态识别 | 万物互联中枢")]
        ),
        _c(
          "div",
          {
            staticClass: "p2 price delay6",
            class: { fadeUp: _vm.isB1Visible }
          },
          [_vm._v("¥39,999元/套")]
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b2" } }, [
      _c("div", { staticClass: "w" }, [
        _c(
          "div",
          { staticClass: "p1 delay1", class: { fadeUp: _vm.isB2Visible } },
          [_vm._v("全新升级的语音交互")]
        ),
        _c(
          "div",
          { staticClass: "p2 delay2", class: { fadeUp: _vm.isB2Visible } },
          [_vm._v("宛若与一位伙伴在交流")]
        ),
        _c(
          "div",
          { staticClass: "p3 delay3", class: { fadeUp: _vm.isB2Visible } },
          [
            _c("p", [
              _vm._v(
                "经过精挑细选，为机器人赋予1种近乎真人般的语音。强大的语音识别引擎，能够轻松听到5米范围内的指令。"
              )
            ]),
            _c("p", [
              _vm._v(
                "遴选业界优秀麦克风，打造360度覆盖的6麦阵列，在你和维拉说话的时候，“他”时刻都能够判别你在哪个方位，回应更贴心。"
              )
            ])
          ]
        ),
        _c("div", { staticClass: "p4" }, [
          _c(
            "div",
            {
              staticClass: "item delay4",
              class: { fadeDown: _vm.isB2Visible }
            },
            [_c("p", [_vm._v("精选语音")]), _vm._m(0)]
          ),
          _c(
            "div",
            {
              staticClass: "item delay5",
              class: { fadeDown: _vm.isB2Visible }
            },
            [_c("p", [_vm._v("远场识别")]), _vm._m(1)]
          ),
          _c(
            "div",
            {
              staticClass: "item delay6",
              class: { fadeDown: _vm.isB2Visible }
            },
            [_c("p", [_vm._v("阵列支持")]), _vm._m(2)]
          )
        ])
      ])
    ]),
    _c("div", { attrs: { id: "info-b3" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB3Visible } }, [
          _vm._v("黑科技的一次完美体现")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1", class: { fadeUp: _vm.isB3Visible } },
          [_vm._v("如家人般，熟悉家中每个角落")]
        ),
        _c(
          "div",
          { staticClass: "p3 delay2", class: { fadeUp: _vm.isB3Visible } },
          [_vm._v("一键自主建图 | 随性定义位置 | 静默更新地图")]
        ),
        _c("div", {
          staticClass: "loading",
          class: { animation: _vm.isB3Visible }
        }),
        _vm.isMobile
          ? _c("img", {
              staticClass: "map",
              class: { animation: _vm.isB3Visible },
              attrs: {
                src: __webpack_require__("Is2o")
              }
            })
          : _c("img", {
              staticClass: "map",
              class: { animation: _vm.isB3Visible },
              attrs: { src: __webpack_require__("JRP5") }
            })
      ])
    ]),
    _c("div", { attrs: { id: "info-b4" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB4Visible } }, [
          _vm._v("多模式人体认知")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1", class: { fadeUp: _vm.isB4Visible } },
          [_vm._v("懂你的一言一行，更懂你的心")]
        ),
        _c(
          "div",
          { staticClass: "p3 delay2", class: { fadeUp: _vm.isB4Visible } },
          [
            _c("img", {
              attrs: { src: __webpack_require__("qu5y") }
            })
          ]
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b5" } }, [
      _c(
        "div",
        { staticClass: "p1 deplay1", class: { fadeUp: _vm.isB5Visible } },
        [
          _c("img", {
            staticClass: "img1",
            attrs: { src: __webpack_require__("vfxQ") }
          }),
          _c("img", {
            staticClass: "img2",
            attrs: { src: __webpack_require__("/z3w") }
          }),
          _c("img", {
            staticClass: "img3",
            attrs: { src: __webpack_require__("6uBu") }
          })
        ]
      ),
      _c(
        "div",
        {
          staticClass: "info-b5-robot3 delay4",
          class: { "info-b5-robot3-animation": _vm.isB5Visible }
        },
        [
          _c("img", {
            staticClass: "img4",
            class: { fadeDown: _vm.isB5Visible },
            attrs: { src: __webpack_require__("rmhC") }
          })
        ]
      )
    ]),
    _c("div", { attrs: { id: "info-b6" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB6Visible } }, [
          _c("img", {
            attrs: { src: __webpack_require__("LFzW") }
          })
        ]),
        _c(
          "div",
          { staticClass: "p2 delay3", class: { fadeUp: _vm.isB6Visible } },
          [_vm._v("为机器人赋予灵魂")]
        ),
        _c(
          "div",
          { staticClass: "list" },
          _vm._l(4, function(n) {
            return _c("div", {
              staticClass: "item",
              class: ["delay" + n, "img" + n, { fadeDown: _vm.isB6Visible }]
            })
          })
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b7" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB7Visible } }, [
          _vm._v("连接爱，连接家")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1", class: { fadeUp: _vm.isB7Visible } },
          [_vm._v("享受每一次与家人的见面")]
        ),
        _c(
          "div",
          { staticClass: "p3 delay2", class: { fadeUp: _vm.isB7Visible } },
          [_vm._v("远程看家 | 跟随视频 | 亲情陪伴")]
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b8" } })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("b", [_vm._v("1")]), _vm._v("种")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("b", [_vm._v("5")]), _vm._v("米")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("b", [_vm._v("6")]), _vm._v("麦")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bf87b9d", esExports)
  }
}

/***/ }),

/***/ "3FFM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("1Acb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b826b08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("miFu");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("zfwD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b826b08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\views\\robot\\3s\\index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6b826b08", Component.options)
  } else {
    hotAPI.reload("data-v-6b826b08", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3FrR":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAMAAADNlS1EAAAAUVBMVEVRUVFQUFBRUVFSUlJQUFBRUVFQUFBMaXFPT09RUVFQUFBQUFBOTk5QUFBRUVFPT09QUFBQUFBQUFBQUFBQUFBPT09SUlJRUVFSUlJQUFBRUVF4u9kYAAAAGnRSTlNwv1cM0IAwAGCQ8egClqYg02jkod1DPs9HheIIO/YAAACESURBVHjabc1HDsMwDERRqpmOinva3P+ggYUIIET9zYBvQ+K7gH+hng3nWodca+jvEnwNqQ7BPLoMCMStzDWS+Jo0Zj/AHRpdHGCBxgkbSghPidkcNkbEVaKFZf6AWKA7cJ7uemeJ1pgLX0z9dwIKa0xugJY1Gta4rwN0LHGZuxYQBv0A7rYTRHCtn3AAAAAASUVORK5CYII="

/***/ }),

/***/ "3hqC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-info-b1.10a0090.jpg";

/***/ }),

/***/ "5HKf":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.robot-spec {\n  padding: 40px 0;\n}\n.robot-spec .row {\n  border-bottom: 1px solid #eae9e9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.robot-spec .row .col1 {\n  width: 320px;\n  height: 100%;\n  text-align: center;\n  font-size: 18px;\n  color: #666;\n}\n.robot-spec .row .col1 i {\n  display: inline-block;\n  width: 30px;\n  height: 30px;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n.robot-spec .row .col1 .icon-camera {\n  background-image: url(" + escape(__webpack_require__("qe9x")) + ");\n}\n.robot-spec .row .col1 .icon-voicebox {\n  background-image: url(" + escape(__webpack_require__("H1CN")) + ");\n}\n.robot-spec .row .col1 .icon-mic {\n  background-image: url(" + escape(__webpack_require__("7H/s")) + ");\n}\n.robot-spec .row .col1 .icon-screen {\n  background-image: url(" + escape(__webpack_require__("q4Cb")) + ");\n}\n.robot-spec .row .col1 .icon-hardware {\n  background-image: url(" + escape(__webpack_require__("oMgk")) + ");\n}\n.robot-spec .row .col1 .icon-move {\n  background-image: url(" + escape(__webpack_require__("KEER")) + ");\n}\n.robot-spec .row .col1 .icon-wifi {\n  background-image: url(" + escape(__webpack_require__("sqz6")) + ");\n}\n.robot-spec .row .col1 .icon-battery {\n  background-image: url(" + escape(__webpack_require__("3FrR")) + ");\n}\n.robot-spec .row .col1 .icon-sensor {\n  background-image: url(" + escape(__webpack_require__("c1sd")) + ");\n}\n.robot-spec .row .params {\n  flex: 1;\n  padding: 50px 0 50px 65px;\n  color: #999;\n  font-size: 14px;\n  border-left: 1px solid #eae9e9;\n}\n.robot-spec .row .params .param {\n  display: flex;\n  line-height: 40px;\n}\n.robot-spec .row .params .param .col2 {\n  width: 180px;\n}\n.robot-spec .row .params .param .col3 {\n  flex: 1;\n}\n", ""]);

// exports


/***/ }),

/***/ "5qVc":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.robot-info .w {\n  position: relative;\n}\n.robot-info .w .p1 {\n  font-size: 40px;\n  color: #333;\n}\n.robot-info .w .p2 {\n  font-size: 16px;\n  color: #666;\n}\n.robot-info .w .p3 {\n  font-size: 14px;\n  color: #999;\n}\n.robot-info.robot3 #info-b1 {\n  position: relative;\n  min-width: 1200px;\n  height: 800px;\n  overflow: hidden;\n}\n.robot-info.robot3 #info-b1 .bg-mask {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: url(" + escape(__webpack_require__("F0uX")) + ") no-repeat center;\n  background-size: auto 100%;\n}\n.robot-info.robot3 #info-b1 .w {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  padding-top: 100px;\n}\n.robot-info.robot3 #info-b1 .p2 {\n  font-size: 24px;\n  padding-top: 10px;\n  padding-bottom: 26px;\n}\n.robot-info.robot3 #info-b1 .price {\n  font-size: 17px;\n}\n.robot-info.robot3 #info-b2 {\n  min-width: 1200px;\n  background: #f5f7f9;\n  height: 800px;\n  background: url(" + escape(__webpack_require__("vo70")) + ") no-repeat 60% center;\n  background-size: auto 100%;\n}\n.robot-info.robot3 #info-b2 .w {\n  padding: 168px 0 0 60px;\n}\n.robot-info.robot3 #info-b2 .p1,\n.robot-info.robot3 #info-b2 .p2,\n.robot-info.robot3 #info-b2 .p3,\n.robot-info.robot3 #info-b2 .p4 {\n  color: #fff;\n}\n.robot-info.robot3 #info-b2 .p3 {\n  padding: 60px 0;\n  width: 560px;\n}\n.robot-info.robot3 #info-b2 .p3 p {\n  text-indent: 2em;\n  line-height: 1.7;\n}\n.robot-info.robot3 #info-b2 .p4 .item {\n  vertical-align: top;\n  display: inline-block;\n  margin-right: 30px;\n  width: 165px;\n  height: 165px;\n  border-radius: 100%;\n  text-align: center;\n  border: 2px solid #43e1ac;\n}\n.robot-info.robot3 #info-b2 .p4 .item p {\n  padding: 30px 0 0px;\n}\n.robot-info.robot3 #info-b2 .p4 .item span {\n  color: #43e1ac;\n}\n.robot-info.robot3 #info-b2 .p4 .item span b {\n  font-size: 72px;\n  font-weight: normal;\n}\n.robot-info.robot3 #info-b3 {\n  min-width: 1200px;\n  height: 800px;\n  background: url(" + escape(__webpack_require__("//XY")) + ") no-repeat center;\n  background-size: auto 100%;\n}\n.robot-info.robot3 #info-b3 .w {\n  position: relative;\n  padding-top: 70px;\n  text-align: center;\n}\n.robot-info.robot3 #info-b3 .p1 {\n  color: #fff;\n}\n.robot-info.robot3 #info-b3 .p2 {\n  color: #fff;\n  padding: 10px 0 20px;\n}\n.robot-info.robot3 #info-b3 .p3 {\n  color: #ccc;\n}\n.robot-info.robot3 #info-b3 .loading {\n  position: absolute;\n  transform-origin: center;\n  top: 250px;\n  left: 50%;\n  margin-left: -220px;\n  width: 440px;\n  height: 440px;\n  opacity: 0;\n  background: url(" + escape(__webpack_require__("sh7B")) + ") no-repeat center;\n}\n.robot-info.robot3 #info-b3 .loading.animation {\n  animation: loading 1s 1s forwards;\n}\n.robot-info.robot3 #info-b3 .map {\n  position: absolute;\n  opacity: 0;\n  top: 250px;\n  left: 60px;\n}\n.robot-info.robot3 #info-b3 .map.animation {\n  animation: map 0.5s 2s forwards;\n}\n.robot-info.robot3 #info-b4 {\n  min-width: 1200px;\n  height: 800px;\n  background: url(" + escape(__webpack_require__("h8ir")) + ") no-repeat center;\n  background-size: auto 100%;\n}\n.robot-info.robot3 #info-b4 .w {\n  text-align: center;\n  padding-top: 100px;\n}\n.robot-info.robot3 #info-b4 .p3 {\n  margin-top: 20px;\n}\n.robot-info.robot3 #info-b5 {\n  min-width: 1200px;\n  height: 800px;\n  background: url(" + escape(__webpack_require__("Mf4/")) + ") no-repeat center;\n  background-size: auto 100%;\n  overflow: hidden;\n}\n.robot-info.robot3 #info-b5 .p1 {\n  display: flex;\n  margin-left: -330px;\n}\n.robot-info.robot3 #info-b5 .p1 .img1 {\n  width: 308px;\n  height: 63px;\n  margin-top: 138px;\n  margin-left: 1726px;\n}\n.robot-info.robot3 #info-b5 .p1 .img2 {\n  width: 170px;\n  height: 64px;\n  margin-top: 216px;\n  margin-left: -220px;\n}\n.robot-info.robot3 #info-b5 .p1 .img3 {\n  width: 142px;\n  height: 64px;\n  margin-top: 302px;\n  margin-left: -200px;\n}\n.robot-info.robot3 #info-b5 .info-b5-robot3 {\n  width: 353px;\n  height: 352px;\n  opacity: 0;\n  background: url(" + escape(__webpack_require__("ztg+")) + ") no-repeat center;\n  background-size: auto 100%;\n  margin-left: 806px;\n  margin-top: 80px;\n}\n.robot-info.robot3 #info-b5 .info-b5-robot3 .img4 {\n  width: 286px;\n  height: 63px;\n  margin-top: -48px;\n  margin-left: 175px;\n}\n.robot-info.robot3 #info-b6 {\n  min-width: 1200px;\n  height: 800px;\n  background: url(" + escape(__webpack_require__("g1w2")) + ") no-repeat center;\n  background-size: auto 100%;\n}\n.robot-info.robot3 #info-b6 .w {\n  position: relative;\n  padding-top: 80px;\n  text-align: center;\n}\n.robot-info.robot3 #info-b6 .p2 {\n  color: #fff;\n}\n.robot-info.robot3 #info-b6 .list {\n  margin: 140px 0 0 50px;\n}\n.robot-info.robot3 #info-b6 .list .item {\n  display: inline-block;\n  width: 500px;\n  height: 200px;\n  background-repeat: no-repeat;\n  background-position: left top;\n}\n.robot-info.robot3 #info-b6 .list .item:nth-child(1) {\n  background-image: url(" + escape(__webpack_require__("gLza")) + ");\n}\n.robot-info.robot3 #info-b6 .list .item:nth-child(2) {\n  background-image: url(" + escape(__webpack_require__("Wp+A")) + ");\n}\n.robot-info.robot3 #info-b6 .list .item:nth-child(3) {\n  background-image: url(" + escape(__webpack_require__("p2bX")) + ");\n}\n.robot-info.robot3 #info-b6 .list .item:nth-child(4) {\n  background-image: url(" + escape(__webpack_require__("6JXn")) + ");\n}\n.robot-info.robot3 #info-b7 {\n  min-width: 1200px;\n  height: 800px;\n  background: url(" + escape(__webpack_require__("t8zM")) + ") no-repeat center;\n  background-size: auto 100%;\n}\n.robot-info.robot3 #info-b7 .w {\n  padding: 210px 0 0 190px;\n}\n.robot-info.robot3 #info-b7 .p2 {\n  margin-bottom: 20px;\n}\n.robot-info.robot3 #info-b8 {\n  min-width: 1200px;\n  height: 777px;\n  background: url(" + escape(__webpack_require__("M2Cl")) + ") no-repeat center;\n  background-size: auto 100%;\n}\n.is-mobile .robot3 #info-b1,\n.is-mobile .robot3 #info-b2,\n.is-mobile .robot3 #info-b3,\n.is-mobile .robot3 #info-b4,\n.is-mobile .robot3 #info-b5,\n.is-mobile .robot3 #info-b6,\n.is-mobile .robot3 #info-b7,\n.is-mobile .robot3 #info-b8 {\n  width: 100%;\n  min-width: inherit;\n  height: 34.375rem;\n}\n.is-mobile .robot3 #info-b1 .bg-mask {\n  background-image: url(" + escape(__webpack_require__("RNlF")) + ");\n}\n.is-mobile .robot3 #info-b1 .w {\n  padding: 3.125rem 0 0 0;\n}\n.is-mobile .robot3 #info-b1 .p2 {\n  font-size: 0.9375rem;\n}\n.is-mobile .robot3 #info-b2 {\n  background-image: url(" + escape(__webpack_require__("oukn")) + ");\n}\n.is-mobile .robot3 #info-b2 .w {\n  padding: 1.25rem 1.25rem 0;\n}\n.is-mobile .robot3 #info-b2 .p3 {\n  width: 100%;\n  padding: 1.5625rem 0;\n  font-size: 0.6875rem;\n}\n.is-mobile .robot3 #info-b2 .p4 {\n  text-align: center;\n}\n.is-mobile .robot3 #info-b2 .p4 .item {\n  width: 5.15625rem;\n  height: 5.15625rem;\n  margin: 0;\n}\n.is-mobile .robot3 #info-b2 .p4 .item:nth-child(2) {\n  margin: 0 1.875rem;\n}\n.is-mobile .robot3 #info-b2 .p4 .item p {\n  padding: 0.9375rem 0 0;\n  font-size: 0.75rem;\n}\n.is-mobile .robot3 #info-b2 .p4 .item span b {\n  font-size: 1.875rem;\n}\n.is-mobile .robot3 #info-b3 {\n  background-image: url(" + escape(__webpack_require__("laoQ")) + ");\n}\n.is-mobile .robot3 #info-b3 .w {\n  padding: 2.5rem 0 0 0;\n}\n.is-mobile .robot3 #info-b3 .loading {\n  top: 12.5rem;\n  left: 4.84375rem;\n  margin-left: 0;\n  width: 13.75rem;\n  height: 13.75rem;\n  background-size: cover;\n}\n.is-mobile .robot3 #info-b3 .map {\n  width: 11.6875rem;\n  top: 10.625rem;\n  left: 5.875rem;\n}\n.is-mobile .robot3 #info-b4 {\n  background-image: url(" + escape(__webpack_require__("PzVH")) + ");\n}\n.is-mobile .robot3 #info-b4 .w {\n  padding-top: 3.125rem;\n}\n.is-mobile .robot3 #info-b4 .w .p3 img {\n  width: 55%;\n}\n.is-mobile .robot3 #info-b5 {\n  background-image: url(" + escape(__webpack_require__("mCE0")) + ");\n}\n.is-mobile .robot3 #info-b5 .p1 {\n  display: flex;\n  margin-left: 0px;\n}\n.is-mobile .robot3 #info-b5 .p1 .img1 {\n  width: 137px;\n  height: 28px;\n  margin-top: 186px;\n  margin-left: 231px;\n}\n.is-mobile .robot3 #info-b5 .p1 .img2 {\n  width: 76px;\n  height: 28px;\n  margin-top: 221px;\n  margin-left: -98px;\n}\n.is-mobile .robot3 #info-b5 .p1 .img3 {\n  width: 63px;\n  height: 28px;\n  margin-top: 259px;\n  margin-left: -87px;\n}\n.is-mobile .robot3 #info-b5 .info-b5-robot3 {\n  width: 180px;\n  height: 180px;\n  opacity: 0;\n  background: url(" + escape(__webpack_require__("ztg+")) + ") no-repeat center;\n  background-size: auto 100%;\n  margin-left: 58px;\n  margin-top: 102px;\n}\n.is-mobile .robot3 #info-b5 .info-b5-robot3 .img4 {\n  width: 127px;\n  height: 28px;\n  margin-top: -12px;\n  margin-left: 104px;\n}\n.is-mobile .robot3 #info-b6 {\n  background-image: url(" + escape(__webpack_require__("UyPP")) + ");\n}\n.is-mobile .robot3 #info-b6 .w {\n  padding: 3.125rem 0 0;\n}\n.is-mobile .robot3 #info-b6 .p1 img {\n  width: 90%;\n}\n.is-mobile .robot3 #info-b6 .list {\n  margin: 1.25rem 0 0 2.8125rem;\n}\n.is-mobile .robot3 #info-b6 .list .item {\n  width: 100%;\n  height: 4.0625rem;\n  margin: 0 0 2.5rem;\n  background-size: auto 100%;\n}\n.is-mobile .robot3 #info-b7 {\n  background-image: url(" + escape(__webpack_require__("XYsi")) + ");\n}\n.is-mobile .robot3 #info-b7 .w {\n  padding: 3.125rem 0 0 0;\n  text-align: center;\n}\n.is-mobile .robot3 #info-b8 {\n  background-image: url(" + escape(__webpack_require__("ZA49")) + ");\n}\n.is-mobile .robot-info .w .p1 {\n  font-size: 1.4375rem;\n}\n.is-mobile .robot-info .w .p2 {\n  font-size: 0.75rem;\n}\n", ""]);

// exports


/***/ }),

/***/ "67jl":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("GvyR");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("beeba766", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e7a7bc1a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e7a7bc1a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "6E3d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-img6.2b5b84a.png";

/***/ }),

/***/ "6JXn":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "6fJm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-footer w" },
    [
      _c("div", { staticClass: "links" }, [
        _c("div", { staticClass: "col robot" }, [
          _c("h3", [_vm._v("产品信息")]),
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.routeGo("/robot3s/info")
                }
              }
            },
            [_vm._v("维拉3S")]
          ),
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.routeGo("/robot3/info")
                }
              }
            },
            [_vm._v("维拉3")]
          ),
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.routeGo("/robot2s/info")
                }
              }
            },
            [_vm._v("维拉2S")]
          )
        ]),
        _c("div", { staticClass: "col service" }, [
          _c("h3", [_vm._v("售后服务")]),
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.routeGo("/service#maintenance")
                }
              }
            },
            [_vm._v("售后电话")]
          ),
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.routeGo("/service#maintenance")
                }
              }
            },
            [_vm._v("报修方式")]
          )
        ]),
        _c("div", { staticClass: "col about" }, [
          _c("h3", [_vm._v("关于我们")]),
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.routeGo("/about#company-profile")
                }
              }
            },
            [_vm._v("公司简介")]
          ),
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.routeGo("/about#contact-us")
                }
              }
            },
            [_vm._v("联系我们")]
          ),
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.routeGo("/news")
                }
              }
            },
            [_vm._v("新闻动态")]
          )
        ]),
        _c(
          "div",
          { staticClass: "col cocern" },
          [
            _c("h3", [_vm._v("关注我们")]),
            _c(
              "a",
              { staticClass: "weixin", on: { click: _vm.showWeixinPop } },
              [
                _c("span", [_vm._v("官方微信")]),
                !_vm.isMobile
                  ? _c("img", {
                      staticClass: "qr-img",
                      attrs: { src: __webpack_require__("Qk9D") }
                    })
                  : _vm._e()
              ]
            ),
            _vm.isMobile
              ? _c(
                  "a",
                  {
                    staticClass: "weibo",
                    attrs: { href: "//weibo.com/u/3772228124" }
                  },
                  [_vm._v("新浪微博")]
                )
              : _c(
                  "a",
                  {
                    staticClass: "weibo",
                    attrs: {
                      href: "//weibo.com/u/3772228124",
                      target: "_black"
                    }
                  },
                  [_vm._v("新浪微博")]
                ),
            _vm.isMobile ? [_vm._m(0)] : [_vm._m(1)]
          ],
          2
        ),
        _vm._m(2)
      ]),
      _vm._m(3),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.weixinPopShow
          ? _c(
              "div",
              {
                staticClass: "weixin-pop",
                on: {
                  click: function($event) {
                    _vm.weixinPopShow = 0
                  }
                }
              },
              [
                _c("img", {
                  attrs: { src: __webpack_require__("Qk9D") }
                })
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "app",
        attrs: {
          href: "http://www.flyingwings.com.cn/download/app/",
          target: "_black"
        }
      },
      [_c("span", [_vm._v("APP下载")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "app" }, [
      _c("span", [_vm._v("APP下载")]),
      _c("img", {
        staticClass: "qr-img",
        attrs: { src: __webpack_require__("cX4e") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col tel" }, [
      _c("h3", [_vm._v("公司总机")]),
      _c("a", { attrs: { href: "tel:193 0215 5869" } }, [
        _vm._v("193 0215 5869")
      ]),
      _c("p", [_vm._v("工作日9:00-18:00")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copyright" }, [
      _vm._v("Copyright © 2013-2022 Flyingwings Co.,Ltd. "),
      _c(
        "a",
        { attrs: { href: "https://beian.miit.gov.cn/", target: "_blank" } },
        [_vm._v("沪ICP备12048554号")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46c3e992", esExports)
  }
}

/***/ }),

/***/ "6uBu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dialog3.fd1dff8.png";

/***/ }),

/***/ "7+3b":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.robot-design.robot3 .w {\n  position: relative;\n  height: 100%;\n}\n.robot-design.robot3 .w .p1 {\n  font-size: 42px;\n  line-height: 1.8;\n}\n.robot-design.robot3 .w .p2 {\n  font-size: 16px;\n}\n.robot-design.robot3 #design-b1 {\n  background-image: url(" + escape(__webpack_require__("jlZZ")) + ");\n  background-color: #fff;\n}\n.robot-design.robot3 #design-b1 .w {\n  padding: 350px 0 0 100px;\n}\n.robot-design.robot3 #design-b1 .p1 b {\n  display: inline-block;\n}\n.robot-design.robot3 #design-b1 .p1 span {\n  display: inline-block;\n  font-size: 33px;\n  padding-left: 30px;\n}\n.robot-design.robot3 #design-b2 {\n  background-image: url(" + escape(__webpack_require__("cmYL")) + ");\n  background-color: #000;\n  color: #fff;\n  text-align: center;\n  padding-top: 90px;\n}\n.robot-design.robot3 #design-b3 {\n  background-image: url(" + escape(__webpack_require__("hjXl")) + ");\n}\n.robot-design.robot3 #design-b3 .w {\n  padding: 370px 0 0 120px;\n}\n.robot-design.robot3 #design-b4 {\n  background-image: url(" + escape(__webpack_require__("s+NX")) + ");\n  color: #fff;\n}\n.robot-design.robot3 #design-b4 .w {\n  padding: 200px 0 0 700px;\n  text-align: center;\n}\n.robot-design.robot3 #design-b4 .p3 {\n  margin: 20px 0;\n}\n.robot-design.robot3 #design-b4 .face-gif {\n  position: absolute;\n  top: 288px;\n  left: 157px;\n}\n.robot-design.robot3 #design-b4 .face-list .item {\n  display: inline-block;\n  vertical-align: top;\n  margin: 0 15px;\n}\n.robot-design.robot3 #design-b4 .face-list .item.active .icon,\n.robot-design.robot3 #design-b4 .face-list .item:hover .icon {\n  background-color: #2e2e2e;\n  transform: scale(0.8) rotate(360deg);\n}\n.robot-design.robot3 #design-b4 .face-list .item .icon {\n  width: 88px;\n  height: 88px;\n  transition: all 0.5s;\n  margin-bottom: 10px;\n  border-radius: 100%;\n  border: 1px solid #2e2e2e;\n  background-repeat: no-repeat;\n  background-position: 1px 1px;\n}\n.robot-design.robot3 #design-b4 .face-list .item .icon.laugh {\n  background-image: url(" + escape(__webpack_require__("vcm0")) + ");\n}\n.robot-design.robot3 #design-b4 .face-list .item .icon.angry {\n  background-image: url(" + escape(__webpack_require__("prrE")) + ");\n}\n.robot-design.robot3 #design-b4 .face-list .item .icon.cry {\n  background-image: url(" + escape(__webpack_require__("qry4")) + ");\n}\n.robot-design.robot3 #design-b4 .face-list .item p {\n  font-size: 14px;\n}\n.robot-design.robot3 .banner {\n  height: 800px;\n  min-width: 1200px;\n  background-size: auto 100%;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n.is-mobile .robot3 #design-b1,\n.is-mobile .robot3 #design-b2,\n.is-mobile .robot3 #design-b3,\n.is-mobile .robot3 #design-b4 {\n  width: 100%;\n  min-width: inherit;\n  height: 34.375rem;\n}\n.is-mobile .robot3 #design-b1 {\n  background-image: url(" + escape(__webpack_require__("N9SH")) + ");\n}\n.is-mobile .robot3 #design-b1 .w {\n  padding: 3.125rem 0 0 0;\n  text-align: center;\n}\n.is-mobile .robot3 #design-b1 .p1 span {\n  display: block;\n  font-size: 1.0625rem;\n  padding: 0 0 0.625rem;\n}\n.is-mobile .robot3 #design-b2 {\n  background-image: url(" + escape(__webpack_require__("+hbr")) + ");\n  padding-top: 4.375rem;\n}\n.is-mobile .robot3 #design-b3 {\n  background-image: url(" + escape(__webpack_require__("tIE6")) + ");\n}\n.is-mobile .robot3 #design-b3 .w {\n  padding: 14.0625rem 0 0 1.5625rem;\n}\n.is-mobile .robot3 #design-b4 {\n  background-image: url(" + escape(__webpack_require__("ZtUs")) + ");\n}\n.is-mobile .robot3 #design-b4 .w {\n  padding: 1.875rem 0 0;\n}\n.is-mobile .robot3 #design-b4 .p3 {\n  margin: 0.625rem 0;\n}\n.is-mobile .robot3 #design-b4 .face-gif {\n  top: 17.96875rem;\n  left: 6.5625rem;\n  width: 10.625rem;\n}\n.is-mobile .robot3 #design-b4 .face-list .item {\n  margin: 0 0.625rem;\n}\n.is-mobile .robot3 #design-b4 .face-list .item .icon {\n  width: 2.75rem;\n  height: 2.75rem;\n  background-size: cover;\n}\n.is-mobile .robot3 #design-b4 .face-list .item p {\n  font-size: 0.625rem;\n}\n.is-mobile .robot-design .w .p1 {\n  font-size: 1.4375rem;\n}\n.is-mobile .robot-design .w .p2 {\n  font-size: 0.75rem;\n}\n", ""]);

// exports


/***/ }),

/***/ "7EJk":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "7H/s":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAaCAMAAABigZc2AAAAaVBMVEVMaXFQUFBQUFBRUVFRUVFRUVFQUFBRUVFRUVFQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBbW1tRUVFQUFBQUFBQUFBRUVFQUFBPT09PT09PT09QUFBVVVVQUFBTU1NPT09RUVFQUFBRUVHZ4CnrAAAAInRSTlMALPtIl/QfoP6m7EJlsNTgwgHKuCTlhuZTFlC6D9A0Ol2O0w9vdwAAANpJREFUeNqVkcmSgzAMRGXjRRgMgbAkIdv0/3/kCHARwi19kFpPpZLLolWdDwi+o50yiypWsNkHORvmKgvWbcxA0AxhNlZXyVT1xnSeTK43Bp+Mx5IKd2CuIDYHZljqA/P4ifH2Fl6YPRONbWLtSHS29Ogb8vxc0FMGmv5BA16kdK0EqVoremEgxTJcso5/UXMpoyztHOKKE4NPhXQx77uO+i3p3t0lvnV/JZEKyN36tzmCotVO4NYMpmVM7nOPaAHYmNFeTYmyoYNuuH3VF+/9hEniZXe3pPVu/1ikDmXu13D4AAAAAElFTkSuQmCC"

/***/ }),

/***/ "7xkP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-info-b5.89d489f.jpg";

/***/ }),

/***/ "86us":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-img4.0fb1ece.png";

/***/ }),

/***/ "9/wf":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("XZo4");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1d5a9dec", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6d356b33\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./info.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6d356b33\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./info.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "9BV7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-img2.a9ffa84.png";

/***/ }),

/***/ "9Lro":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_service_vue__ = __webpack_require__("Un2h");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0f8379e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_service_vue__ = __webpack_require__("bp4M");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("XLau")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_service_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0f8379e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_service_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\views\\service.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c0f8379e", Component.options)
  } else {
    hotAPI.reload("data-v-c0f8379e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9MU5":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5HKf");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("238999df", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7c1a6e21\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./spec.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7c1a6e21\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./spec.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "9ezh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-info-b5.8152be2.png";

/***/ }),

/***/ "A+vi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_utils__ = __webpack_require__("JaHG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isTabsVisible: true,
      robot3Show: DB.robot3Show
    };
  },

  computed: {},
  methods: {
    handleTab: function handleTab(index) {
      this.tab = index;
    }
  },
  created: function created() {
    var _this = this;

    if (this.robot3Show) {
      $(window).on('scroll', function () {
        _this.isTabsVisible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#tabs');
      });
    }
  }
});

/***/ }),

/***/ "ADrp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-info-b3.645d7b8.jpg";

/***/ }),

/***/ "AM7t":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-design-b3.cbee1de.jpg";

/***/ }),

/***/ "BAqv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about-img1.79fb3a0.png";

/***/ }),

/***/ "BDu5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-design-b2.0e000ec.jpg";

/***/ }),

/***/ "BEoZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-design-b3.72e6aed.jpg";

/***/ }),

/***/ "BFZJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_info_vue__ = __webpack_require__("bVsh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bf87b9d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_info_vue__ = __webpack_require__("2fre");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("k+El")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bf87b9d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\views\\robot\\3\\info.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7bf87b9d", Component.options)
  } else {
    hotAPI.reload("data-v-7bf87b9d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BpUE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      weixinPopShow: false
    };
  },

  computed: {},
  methods: {
    showWeixinPop: function showWeixinPop() {
      if (this.isMobile) this.weixinPopShow = 1;
    },
    routeGo: function routeGo(path) {
      console.log(this.$route.fullPath);
      if (this.$route.fullPath === path) {
        location.reload();
      } else {
        this.$router.push(path);
      }
    }
  },
  created: function created() {}
});

/***/ }),

/***/ "C0Lz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-design-b2.a392d0b.jpg";

/***/ }),

/***/ "CzOb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showNav: false,
      currentPath: '/home',
      navList: [{ path: '/home', title: '首页' }, { path: '/robot3s/info', title: '维拉3S' }, { path: '/robot3/info', title: '维拉3' }, { path: '/robot2s/info', title: '维拉2S' }, { path: '/about', title: '关于我们' }, { path: '/news', title: '新闻动态' }, { path: '/service', title: '服务' }]
    };
  },

  computed: {},
  methods: {
    selectNav: function selectNav(item) {
      this.currentPath = item.path;
      this.$router.push({ path: item.path });
      this.showNav = false;
    },
    isActive: function isActive(path) {
      return this.$route.fullPath.split('/')[1].split('#')[0] === path.split('/')[1].split('#')[0];
    }
  },
  created: function created() {}
});

/***/ }),

/***/ "D2nS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      list: DB.newsList,
      count: 0,
      pageCount: 1,
      currentPage: 1,
      pageSize: DB.newsPageSize
    };
  },

  computed: {
    currentList: function currentList() {
      var list = this.list;
      var start = this.pageSize * (this.currentPage - 1);
      var end = this.pageSize * this.currentPage;

      return this.list.slice(start, end);
    },
    canPrev: function canPrev() {
      return this.currentPage > 1;
    },
    canNext: function canNext() {
      return this.currentPage < this.pageCount;
    }
  },
  methods: {
    handelPrev: function handelPrev() {
      if (this.canPrev) this.currentPage--;
    },
    handelNext: function handelNext() {
      if (this.canNext) this.currentPage++;
    },
    handelPage: function handelPage(n) {
      this.currentPage = n;
    },
    getData: function getData() {
      var list = DB.newsList;
      this.count = list.length;
      this.pageCount = Math.ceil(this.count / this.pageSize);
    }
  },
  created: function created() {
    this.getData();
  }
});

/***/ }),

/***/ "D6xO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-img4.e215e28.png";

/***/ }),

/***/ "EG1Y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-info-b1.bd3f9f6.png";

/***/ }),

/***/ "EbSX":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("V8LD");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("18df4b78", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-51f0bf84\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./design.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-51f0bf84\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./design.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "EieD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_utils__ = __webpack_require__("JaHG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      robot3Show: DB.robot3Show,
      isB1Visible: true,
      isB2Visible: false,
      isB3Visible: false,
      isB4Visible: false,
      isB5Visible: false,
      isB6Visible: false,
      isB7Visible: false,
      isB8Visible: false
    };
  },

  computed: {},
  methods: {},
  created: function created() {
    var _this = this;

    $(window).on('scroll', function () {
      _this.isB1Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#design-b1');
      _this.isB2Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#design-b2');
      _this.isB3Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#design-b3');
      _this.isB4Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#design-b4');
      _this.isB5Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#design-b5');
      _this.isB6Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#design-b6');
      _this.isB7Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#design-b7');
      _this.isB8Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#design-b8');
    });
  }
});

/***/ }),

/***/ "F0uX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-info-b1.e6189b5.jpg";

/***/ }),

/***/ "FBzZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__ = __webpack_require__("fY6B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23b71e09_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__ = __webpack_require__("Z3A+");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("pH+L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23b71e09_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\views\\about.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-23b71e09", Component.options)
  } else {
    hotAPI.reload("data-v-23b71e09", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FFS0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_utils__ = __webpack_require__("JaHG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      robot3Show: DB.robot3Show,
      isB1Visible: true,
      isB2Visible: false,
      isB3Visible: false,
      isB4Visible: false,
      isB5Visible: false
    };
  },

  computed: {},
  methods: {},
  created: function created() {
    var _this = this;

    $(window).on('scroll', function () {
      _this.isB1Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b1');
      _this.isB2Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b2');
      _this.isB3Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b3');
      _this.isB4Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b4');
      _this.isB5Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b5');
    });
  }
});

/***/ }),

/***/ "FJd1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_info_vue__ = __webpack_require__("FFS0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_021a1df4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_info_vue__ = __webpack_require__("IuYu");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("+mNl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_021a1df4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\views\\robot\\3s\\info.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-021a1df4", Component.options)
  } else {
    hotAPI.reload("data-v-021a1df4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FYrh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about-img3.d9d490d.png";

/***/ }),

/***/ "FZ4f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-img5.eadf44f.png";

/***/ }),

/***/ "Fq+V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "robot-design robot2s" }, [
    _c("div", { staticClass: "banner", attrs: { id: "design-b1" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB1Visible } }, [
          _vm._v("极光流线型设计")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1", class: { fadeUp: _vm.isB1Visible } },
          [_vm._v("处处彰显科技感")]
        )
      ])
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b2" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB2Visible } }, [
          _vm._v("V 字蓝光")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay2", class: { fadeUp: _vm.isB2Visible } },
          [_vm._v("闪耀光芒")]
        )
      ])
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b3" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB3Visible } }, [
          _vm._v("36种拟人化表情")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1", class: { fadeUp: _vm.isB3Visible } },
          [_vm._v("贴心动人")]
        )
      ])
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b4" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB4Visible } }, [
          _vm._v("绝美音质")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1 mt10", class: { fadeUp: _vm.isB4Visible } },
          [_vm._v("听音乐如临现场")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-636db903", esExports)
  }
}

/***/ }),

/***/ "GvyR":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.cp-robot .tabs {\n  width: 100%;\n  text-align: center;\n  height: 48px;\n  line-height: 48px;\n  border-top: 1px solid #eae9e9;\n  box-shadow: 0 3px 10px #eae9e9;\n}\n.cp-robot .tabs.fixed {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: rgba(255,255,255,0.8);\n  z-index: 10;\n}\n.cp-robot .tabs a {\n  display: inline-block;\n  margin: 0 18px;\n  cursor: pointer;\n  font-size: 14px;\n}\n.cp-robot .tabs a.router-link-active {\n  color: #3bc0bc;\n}\n.cp-robot #robot3-default-banner {\n  min-width: 1200px;\n  height: 800px;\n  background: url(" + escape(__webpack_require__("U/rx")) + ") no-repeat center;\n  background-size: auto 100%;\n  text-align: center;\n}\n.cp-robot #robot3-default-banner .w {\n  padding-top: 306px;\n}\n.cp-robot #robot3-default-banner .p1 {\n  color: #fff;\n  font-size: 40px;\n}\n.cp-robot #robot3-default-banner .p2 {\n  margin-top: 120px;\n  font-size: 24px;\n  color: #4ce2af;\n}\n.is-mobile #robot3-default-banner {\n  min-width: 100%;\n  background-image: url(" + escape(__webpack_require__("iVUu")) + ");\n  height: 34.375rem;\n}\n.is-mobile #robot3-default-banner .w {\n  padding-top: 12.5rem;\n}\n.is-mobile #robot3-default-banner .p1 {\n  font-size: 1.25rem;\n}\n.is-mobile #robot3-default-banner .p2 {\n  margin-top: 3.75rem;\n  font-size: 0.625rem;\n}\n", ""]);

// exports


/***/ }),

/***/ "H1CN":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAZCAMAAADpC5XfAAAAXVBMVEVMaXFQUFBQUFBRUVFMTExQUFBVVVVRUVFNTU1RUVFQUFBRUVFRUVFQUFBSUlJQUFBRUVFQUFBPT09PT09NTU1RUVFQUFBQUFBQUFBTU1NQUFBRUVFQUFBSUlJRUVFWFt0kAAAAHnRSTlMAzUvADvwEgAnzmDdVrC95WdUpUhOIuI5uGhya5z5VsDHsAAAArUlEQVR42oXSyQ6EIBRE0QIBwXkeu+v/P7MjMUhsE+/y7N6AjP9lYJLeSwimarG4MsuQHlq5LtLVfb3i3qvavM/tTe3oSLrRxqoEyz7vSwoVaakbHDW6vLTiCPhmdkFrrqdurIPuDjhze9BZmxONnoM2lKdKNkHtp1UeVfuxQSEpKgCV0DKerXBsp5auQKwY6klM9fC2M1OY2ArrNWcX4aalVyjEKaR8vvHzP/wAhMoS7DRrs4UAAAAASUVORK5CYII="

/***/ }),

/***/ "HCx1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_utils__ = __webpack_require__("JaHG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isTabsVisible: true
    };
  },

  computed: {},
  methods: {
    handleTab: function handleTab(index) {
      this.tab = index;
    }
  },
  created: function created() {
    var _this = this;

    $(window).on('scroll', function () {
      _this.isTabsVisible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#tabs');
    });
  }
});

/***/ }),

/***/ "HOPK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cp-robot" },
    [
      _vm.robot3Show
        ? [
            _c("transition", { attrs: { name: "fadeUp" } }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isTabsVisible,
                      expression: "!isTabsVisible"
                    }
                  ],
                  staticClass: "tabs fixed"
                },
                [
                  _c("router-link", { attrs: { to: "/robot3/info" } }, [
                    _vm._v("功能")
                  ]),
                  _c("router-link", { attrs: { to: "/robot3/design" } }, [
                    _vm._v("设计")
                  ]),
                  _c("router-link", { attrs: { to: "/robot3/spec" } }, [
                    _vm._v("技术规格")
                  ])
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "tabs", attrs: { id: "tabs" } },
              [
                _c("router-link", { attrs: { to: "/robot3/info" } }, [
                  _vm._v("功能")
                ]),
                _c("router-link", { attrs: { to: "/robot3/design" } }, [
                  _vm._v("设计")
                ]),
                _c("router-link", { attrs: { to: "/robot3/spec" } }, [
                  _vm._v("技术规格")
                ])
              ],
              1
            ),
            _c("router-view")
          ]
        : [
            _c("div", { attrs: { id: "robot3-default-banner" } }, [
              _c("div", { staticClass: "w" }, [
                _vm.isMobile
                  ? _c("div", { staticClass: "p1 fadeUp" }, [
                      _vm._v("11.15日"),
                      _c("br"),
                      _vm._v("深圳新品发布会")
                    ])
                  : _c("div", { staticClass: "p1 fadeUp" }, [
                      _vm._v("11.15日·深圳新品发布会")
                    ]),
                _c("div", { staticClass: "p2 fadeDown delay1" })
              ])
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e7a7bc1a", esExports)
  }
}

/***/ }),

/***/ "Hnad":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/map.9465851.png";

/***/ }),

/***/ "HsVw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-img2.f1f6f0c.png";

/***/ }),

/***/ "HzeT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.22daba5.png";

/***/ }),

/***/ "I3h8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-info-b3.b03463c.jpg";

/***/ }),

/***/ "IjzZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-header w", class: { "show-nav": _vm.showNav } },
    [
      _c("router-link", { staticClass: "logo", attrs: { to: "home" } }),
      _vm.isMobile && _vm.showNav
        ? _c("div", {
            staticClass: "close",
            on: {
              click: function($event) {
                _vm.showNav = false
              }
            }
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "nav" },
        [
          _vm._l(_vm.navList, function(item, index) {
            return _c(
              "a",
              {
                class: [
                  { "router-link-active": _vm.isActive(item.path) },
                  "delay" + index
                ],
                on: {
                  click: function($event) {
                    _vm.selectNav(item)
                  }
                }
              },
              [_vm._v(_vm._s(item.title))]
            )
          }),
          _c(
            "a",
            {
              staticClass: "delay6",
              attrs: { href: "http://en.flyingwings.cn/" }
            },
            [_vm._v("English")]
          )
        ],
        2
      ),
      _vm.isMobile && !_vm.showNav
        ? _c("div", {
            staticClass: "menu",
            on: {
              click: function($event) {
                _vm.showNav = true
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-045f21ae", esExports)
  }
}

/***/ }),

/***/ "Is2o":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-info-b3-img1.b21430d.png";

/***/ }),

/***/ "IuYu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "robot-info robot3s" }, [
    _c("div", { attrs: { id: "info-b1" } }, [
      _c("div", { staticClass: "bg-mask", class: { zoomIn: _vm.isB1Visible } }),
      _c("div", { staticClass: "ww" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            { staticClass: "p1 delay3", class: { fadeUp: _vm.isB1Visible } },
            [_vm._v("维拉3S    科技与康养完美结合")]
          ),
          _c(
            "div",
            { staticClass: "p2 delay4", class: { fadeUp: _vm.isB1Visible } },
            [_vm._v("首款面向健康养老的智慧康养服务机器人")]
          ),
          _c(
            "div",
            { staticClass: "p3 delay5", class: { fadeUp: _vm.isB1Visible } },
            [_vm._v("安全看护  ｜  健康管理  ｜  精神陪护")]
          )
        ]),
        _c("div", { staticClass: "right" }, [
          _c(
            "div",
            { staticClass: "p4 delay5", class: { fadeUp: _vm.isB1Visible } },
            [
              _c("img", {
                staticClass: "img",
                attrs: { src: __webpack_require__("/usn") }
              }),
              _c("span", [_vm._v("上海市专精特新产品")])
            ]
          ),
          _c(
            "div",
            { staticClass: "p4 delay5", class: { fadeUp: _vm.isB1Visible } },
            [
              _c("img", {
                staticClass: "img",
                attrs: { src: __webpack_require__("/usn") }
              }),
              _c("span", [_vm._v("上海市重大高端智能装备")])
            ]
          ),
          _c(
            "div",
            { staticClass: "p4 delay5", class: { fadeUp: _vm.isB1Visible } },
            [
              _c("img", {
                staticClass: "img",
                attrs: { src: __webpack_require__("/usn") }
              }),
              _c("span", [_vm._v("上海市人工智能创新产品")])
            ]
          )
        ])
      ])
    ]),
    _c("div", { attrs: { id: "info-b2" } }, [
      _c("div", { staticClass: "ww" }, [
        _c(
          "div",
          { staticClass: "p1 delay1", class: { fadeUp: _vm.isB2Visible } },
          [_vm._v("认识人 / 家")]
        ),
        _c(
          "div",
          { staticClass: "p2 delay2", class: { fadeUp: _vm.isB2Visible } },
          [_vm._v("随叫随到  主动跟随服务 ")]
        ),
        _c(
          "div",
          { staticClass: "p0 delay3", class: { fadeUp: _vm.isB2Visible } },
          [_vm._v("如家人般  熟悉家中每一个角落")]
        ),
        _c(
          "div",
          { staticClass: "p3 deplay4", class: { fadeUp: _vm.isB2Visible } },
          [_vm._v("人脸识别  ｜  自主建图  ｜  自主导航")]
        ),
        _c("div", { staticClass: "p4" }, [
          _c(
            "div",
            {
              staticClass: "item delay5",
              class: { fadeDown: _vm.isB2Visible }
            },
            [
              _c("img", {
                attrs: { src: __webpack_require__("u+ZD") }
              }),
              _c("br"),
              _c("span", [_vm._v("人脸识别")])
            ]
          ),
          _c(
            "div",
            {
              staticClass: "item delay6",
              class: { fadeDown: _vm.isB2Visible }
            },
            [
              _c("img", {
                attrs: { src: __webpack_require__("kggS") }
              }),
              _c("br"),
              _c("span", [_vm._v("人体识别")])
            ]
          ),
          _c(
            "div",
            {
              staticClass: "item delay7",
              class: { fadeDown: _vm.isB2Visible }
            },
            [
              _c("img", {
                attrs: { src: __webpack_require__("ySqE") }
              }),
              _c("br"),
              _c("span", [_vm._v("步态识别")])
            ]
          )
        ])
      ])
    ]),
    _c("div", { attrs: { id: "info-b3" } }, [
      _c("div", { staticClass: "ww" }, [
        _c(
          "div",
          { staticClass: "p1 delay1", class: { fadeUp: _vm.isB3Visible } },
          [_vm._v("安全居家")]
        ),
        _c(
          "div",
          { staticClass: "p2 delay2", class: { fadeUp: _vm.isB3Visible } },
          [_vm._v("机器人自主移动寻人 前往事发现场")]
        ),
        _c(
          "div",
          { staticClass: "p0 delay3", class: { fadeUp: _vm.isB3Visible } },
          [_vm._v("视频通话联系家人紧急救援")]
        ),
        _c(
          "div",
          { staticClass: "p3 deplay4", class: { fadeUp: _vm.isB3Visible } },
          [_vm._v("跌倒求助  ｜  语音呼救  ｜  安全监测")]
        ),
        _c("div", { staticClass: "p4" }, [
          _c(
            "div",
            {
              staticClass: "item delay5",
              class: { fadeDown: _vm.isB3Visible }
            },
            [
              _c("img", {
                attrs: { src: __webpack_require__("NTse") }
              })
            ]
          )
        ])
      ])
    ]),
    _c("div", { attrs: { id: "info-b4" } }, [
      _c("div", { staticClass: "ww" }, [
        _c(
          "div",
          { staticClass: "p1 delay1", class: { fadeUp: _vm.isB4Visible } },
          [_vm._v("健康管理")]
        ),
        _c(
          "div",
          { staticClass: "p2 delay2", class: { fadeUp: _vm.isB4Visible } },
          [_vm._v("机器人主动用药提醒  健康服务")]
        ),
        _c(
          "div",
          { staticClass: "p0 delay3", class: { fadeUp: _vm.isB4Visible } },
          [_vm._v("智能导诊多轮对话  家庭全科医生")]
        ),
        _c(
          "div",
          { staticClass: "p3 deplay4", class: { fadeUp: _vm.isB4Visible } },
          [_vm._v("用药提醒  ｜  智能导诊  ｜  健康百科 ")]
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b5" } }, [
      _c("div", { staticClass: "ww" }, [
        _c(
          "div",
          { staticClass: "p1 delay1", class: { fadeUp: _vm.isB5Visible } },
          [_vm._v("精神陪伴")]
        ),
        _c(
          "div",
          { staticClass: "p2 delay2", class: { fadeUp: _vm.isB5Visible } },
          [_vm._v("远程视频与家人亲情互动")]
        ),
        _c(
          "div",
          { staticClass: "p0 delay3", class: { fadeUp: _vm.isB5Visible } },
          [_vm._v(" 陪伴闲聊 播放影音娱乐节目")]
        ),
        _c(
          "div",
          { staticClass: "p3 deplay4", class: { fadeUp: _vm.isB5Visible } },
          [_vm._v("亲情关怀  ｜  日常闲聊  ｜  休闲娱乐 ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-021a1df4", esExports)
  }
}

/***/ }),

/***/ "JRP5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-info-b3-img1.2278c4b.png";

/***/ }),

/***/ "JaHG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isMobileFun; });
var isVisible = function isVisible(select) {
  var w = $(window);
  var el = $(select);
  if (!el) return false;

  var offset = el.offset();
  if (!offset) return false;

  return !(w.scrollTop() > offset.top + el.outerHeight() || w.scrollTop() + w.height() < offset.top);
};

var isMobileFun = function isMobileFun() {
  var u = navigator.userAgent;
  var v = {
    trident: u.indexOf('Trident') > -1, //IE内核
    presto: u.indexOf('Presto') > -1, //opera内核
    webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
    android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
    iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
    iPad: u.indexOf('iPad') > -1, //是否iPad
    webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
  };

  return v.mobile || v.ios || v.android || v.iPhone || v.iPad;
};

/***/ }),

/***/ "Jgfk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-img9.e9f8dd8.png";

/***/ }),

/***/ "Jhnl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-info-b7.007e81e.jpg";

/***/ }),

/***/ "KDBx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "is-mobile": _vm.isMobile }, attrs: { id: "app" } },
    [
      _c("app-header"),
      _c("router-view", { staticClass: "view" }),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04c2046b", esExports)
  }
}

/***/ }),

/***/ "KEER":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAASFBMVEVMaXEAAABQUFBQUFBRUVFVVVVMTExQUFBRUVFQUFBQUFBQUFBQUFBQUFBQUFBRUVFQUFBQUFBRUVFVVVVSUlJVVVVRUVFRUVGZLCYLAAAAF3RSTlMAAZ9L8gYD0MBcUvutvpJltOwsHiUYie0dVmgAAACKSURBVHjarZLbCsIwDIb/ns+1ddO8/5s62FS6FHah30UJ+UoISfDFtmIwQUiibMF5Uu9JCpaPdPNue5h4RHgHdceETQC/ibCOYg17/5XiKCJVARiZwrlUSNKgkXYHOn0iaijU/YHW76hTgcmzUtkAtpIahaJq9w/LKJbw95HwsV8viq/2+hj4+bwAVpUHHuQ+CoQAAAAASUVORK5CYII="

/***/ }),

/***/ "KT/5":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Wkhg");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("d00c9880", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-04c2046b\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-04c2046b\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "KtyA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'robot2s': [{
    title: '外形',
    params: [['重量', '5.8KG（含充电座共7KG）'], ['尺寸', '259X258X506mm(含充电座260X326X520mm)'], ['表面工艺', 'UV，电镀']]
  }, {
    title: '摄像头',
    icon: 'icon-camera',
    params: [['视角', '超广角支持，低畸变'], ['水平视角', '83°'], ['像素', '1300万像素'], ['帧率', '根据网络自适配帧率']]
  }, {
    title: '音箱',
    icon: 'icon-voicebox',
    params: [['输出功率', '2X10W'], ['声道', '双声道，立体声'], ['音质特色', '双喇叭，独创低频辐射振膜系统，使低频获得更均匀的扩散，低频力度强，音质层次分明']]
  }, {
    title: '麦克风',
    icon: 'icon-mic',
    params: [['阵列数', '6'], ['识别距离', '室内环境下有效识别距离3～5米，识别率不低于90%，静音空旷环境最大识别距离10米'], ['特色功能', '混响消除，回声消除，自动降燥，远场语音']]
  }, {
    title: '屏幕尺寸',
    icon: 'icon-screen',
    params: [['尺寸', '5英寸，IPS全贴合'], ['分辨率', '1080X720']]
  }, {
    title: '核心硬件',
    icon: 'icon-hardware',
    params: [['CPU', '四核Cortex-A17'], ['RAM', '2GB，DDR3双通道'], ['ROM', '8GB']]
  }, {
    title: '运动',
    icon: 'icon-move',
    params: [['头部', ['俯角5°', '仰角25°', '水平旋转左右90°', '俯仰、旋转速度均可达到60°／S', '噪声<45dB(距离1米)']], ['身体', ['行走速度0.2m／s', '越障10mm', '越沟10～30mm', '爬坡10～15°', '噪声 <55dB( 距离1米)']]]
  }, {
    title: '无线通讯',
    icon: 'icon-wifi',
    params: [['Wi-Fi', '802.11n'], ['ZigBee', 'ZHA'], ['射频', '433MHZ']]
  }, {
    title: '电源',
    icon: 'icon-battery',
    params: [['电池', '18650锂电池，10400mAh'], ['续航时间', '音乐播放长达6小时，待机长达24小时'], ['充电方式', '自动回充，充满电大约需要6小时']]
  }],
  'robot3': [{
    title: '外形',
    params: [['重量', '11KG'], ['尺寸', '底盘直径： 338.2mm，高度：收合态435mm，伸展态628.5mm'], ['表面工艺', '曜石黑、幻银灰']]
  }, {
    title: '摄像头',
    icon: 'icon-camera',
    params: [['视角', '176°超级广角镜头'], ['图像传感器', '1/2.8"'], ['光圈', 'F1.8大'], ['摄像头', ['高清1080P', '星光级全彩']]]
  }, {
    title: '音箱',
    icon: 'icon-voicebox',
    params: [['输出功率', '2X10W'], ['声道', '双声道，立体声'], ['频响范围', 'TBD']]
  }, {
    title: '麦克风',
    icon: 'icon-mic',
    params: [['阵列数', '6'], ['声源定位', '360°'], ['特色功能', '回声消除、稳态/动态噪声抑制、语音增强']]
  }, {
    title: '屏幕尺寸',
    icon: 'icon-screen',
    params: [['显示屏', '10.1"IPS'], ['分辨率', ['1080X720', '支持多点触摸']]]
  }, {
    title: '核心硬件',
    icon: 'icon-hardware',
    params: [['CPU', '双CPU，六核64位高性能处理器'], ['RAM', '2GB'], ['ROM', '8GB']]
  }, {
    title: '运动',
    icon: 'icon-move',
    params: [['行走', '正常速度0.4m/s、最大速度可达0.8/s'], ['俯仰', '范围0~55°，速度45°/s'], ['水平旋转', '范围-150°~150°、速度45°/s'], ['上下伸缩', '区间7cm、速度3cm/s']]
  }, {
    title: '传感器',
    icon: 'icon-sensor',
    params: [['超声传感器', '4'], ['红外传感器', '6'], ['环境传感器', '1'], ['IMU', '1'], ['激光雷达', '1']]
  }, {
    title: '无线通讯',
    icon: 'icon-wifi',
    params: [['Wi-Fi', '802.11b/g/n(2.4GHz)'], ['ZigBee', 'IEEE802.15.4 250kbps(2.4GHz)'], ['BT', 'V2.1+EDR/BT V3.0/BT v3.0+HS/BT V4.0']]
  }, {
    title: '电源',
    icon: 'icon-battery',
    params: [['电池', '18650锂电池、容量10400mAh、额定电压11.1V'], ['充电方式', '自动回充']]
  }],
  'robot3s': [{
    title: '外形',
    params: [['重量', '11KG'], ['尺寸', '底盘直径： 338.2mm，高度：收合态435mm，伸展态628.5mm'], ['表面工艺', '曜石黑、幻银灰']]
  }, {
    title: '摄像头',
    icon: 'icon-camera',
    params: [['视角', '水平 98°，垂直 52°'], ['图像传感器', '1/2.8"'], ['光圈', 'F1.8大'], ['摄像头', ['高清1080P', '星光级全彩']]]
  }, {
    title: '音箱',
    icon: 'icon-voicebox',
    params: [['输出功率', '2X10W'], ['声道', '双声道，立体声'], ['频响范围', 'TBD']]
  }, {
    title: '麦克风',
    icon: 'icon-mic',
    params: [['阵列数', '6'], ['声源定位', '360°'], ['特色功能', '回声消除、稳态/动态噪声抑制、语音增强']]
  }, {
    title: '屏幕尺寸',
    icon: 'icon-screen',
    params: [['显示屏', '10.1"IPS'], ['分辨率', ['1080X720', '支持多点触摸']]]
  }, {
    title: '核心硬件',
    icon: 'icon-hardware',
    params: [['CPU', '双CPU，六核64位高性能处理器'], ['RAM', '4GB'], ['ROM', '16GB']]
  }, {
    title: '运动',
    icon: 'icon-move',
    params: [['行走', '正常速度0.4m/s、最大速度可达0.8/s'], ['俯仰', '范围0~55°，速度45°/s'], ['水平旋转', '范围-150°~150°、速度45°/s'], ['上下伸缩', '区间7cm、速度3cm/s']]
  }, {
    title: '传感器',
    icon: 'icon-sensor',
    params: [['超声传感器', '4'], ['防跌落传感器', '4'], ['环境传感器', '1'], ['IMU', '1'], ['激光雷达', '1'], ['深度相机', '1'], ['光线距离传感器', '1']]
  }, {
    title: '无线通讯',
    icon: 'icon-wifi',
    params: [['Wi-Fi', '802.11b/g/n(2.4GHz)']]
  }, {
    title: '电源',
    icon: 'icon-battery',
    params: [['电池', '18650锂电池、容量10400mAh、额定电压11.1V'], ['充电方式', '自动回充']]
  }]
});

/***/ }),

/***/ "LFzW":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAh4AAAAoCAMAAACGoQPhAAAAeFBMVEVMaXH////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////0cwFZAAAAJ3RSTlMAZhAh7wr9RLt3mc23M/beBYiw1OQW2k/Cum+pJ59VdRvqfTySR14t2BhoAAALnElEQVR42u2cC7eqKheGBVEEMrPbamXZvfn//+EXiKKSodnujLO/8449xi7AS/I4mUwmy/tHhCl1NvH+uPzc0aBxk4h6/+mhGOCzT4ICtEo4RA44MpL/cToAkKOe1u4IIPb+kxcTABJ3PjPaQ76Nh1Xiv+46AYBcN0p7qLtL3ZBGwM0XBsL7T5IOzrv7hkEPMRcengDmMB/cyUcEbr0EwHdAmtfqMXl1OyjqIfQX0IFAvjK6bz6OBy3FQTRtjS0OQD+MR9QSgaRZ4DWVAKv9btbW0Kfyl9DxEO//awig3r7HoMcmgAzzTyPXPYNLup09oPjkZWvKmpKPz9K/37XlANx8wj0dvLg3HoOMLk4g8oZIuPHg7KXav435FXlJZMnxi/82YQHAa/ZS+L3sTTJ05mIqqOu4QdMXADqugRFrDlAMiONZDMAj20wqzfmBrmam7sKjye9kuzIlGD0KfvcXzwvyeTRp6/cXPWrOjzY1zTlTZ7UVxNtMLAlZiv02DlqVK5pOFidyelQi3zqckobHkRMgeR+Dwwc9LJTQ2miQeq+UDhpeYoC+/FAAe1TqxgOBaTAejxOERtPTeoLMj/xZyEJeY3GVypL1j+cFBwKhreujZl59M2e9Y8/S5SqWU1CaLhf80rzpbE3CsnJzWDVNRwpAaONxC4AMu12PvOdbaM0mfZd1wMmQbkEgRuBhz98BaKE4AS5nJ4Zl+fltPAi0lGS0wmMtC/YNPFQTiQebwhMpPMBWct21rQMTjTNMxdkwEGwXUNdpH3tGNAGIsDW5dBoQBKSvkbaCTdwal0aZDw58BB62TBskuWOGa/V5PB5Gm3xWWg8ACG08tPUYggdM900+dtw6nvCyyWy7hKbCbGdMx/MZRE4AMn+g/0/bUTRWvIftYBR2z3nEEKueAPo8Hlp/GA9Y/LyNB+/CA8IrrtORgdZyva5YKBmga30MWZ7K4SfVhzMCIOLnwW3JDX4bD/thGfPBnMYDS8Ad9iWqBCAcMwsAR6zExsNMuRIgkZb+/BIP+hqPU/T7ULRZnLT9uPTEY7r+bQqVeExFWRRt1qG6yM04mEeu2djw7f2+5RtNCD+qoWU/VZW/1/P2kM4TKC46U84iAGGdv1TV4ifvIAWwCz0XHmoQ6Gk8EHBXo1f9/UE84Jle4gERfYXHHM+CIMD+5byZglQW9MNjuZ3NgrpmJR7rW6BrsJ9PphIYXvkWszNRCG2QLjqi4sJTFshvyvFItJMc5KJAB3t+UvyP2FOhwrYQ/Ak8GjGjrAod+Z1TQECpc10kYpb0VcYNLn69TTPQqz+/wkOK+y/wqPrN58WLe++Jh/26aDwWtD6UFEWV+3AToHjZzaoL767Taly7JLL2OjNGIZQmLZbjexR3voaqczAj7CPWo+9oZNY5sA/gvxUppWPxoBW+b/kePlfDciceNbOv+AgnQU/r4cBD66DMR1yysA9V/x/rTY6pLAz548J0Kccic+pA3dPiLhc+W4O4qA/iadFRnxlc2HP5r2aqEaT/GB5ab7qmNAIgyI2Ht9soy375KB73peShLLosFIG+zra5BdrEhPK4W2k99oF59vLw9WGAXzUeD7fsrkdA8D9qPd7F4yFEAAR14uEx6Z+Sc/BJPBCp4TFLpxLAm8ZxstFWhCqG0tL3OO1/cBmAUeYk/R4eKDY+RcT6reZga746Bg+/jgetSQDrPoHBozZzceNhAgYcu/CINxKK+eqDvsfsGoLJ2wkiFciQ1zzGq3hJfBwfZXk2VW6yN8tCkBL7w4+6eLzfRJvsPg4PIxceKAHa6Ca3OGR6/jsSD7uIQlPP8SAtPGrqHfegAoAgBx6zvereYx88SLZt6GLwiGtHoQWAWTXz14VrgbF3n+S79dL/+b17eDVDJ+2B3hagtXgQsgu83eVyiY9fwiN5/POHJV5hAlT/jz6NR9xj1TjXCLw/uJigUuS/xMNTPuJp905YjFd4JNuLFv1JVVQjPCvDpV0LcVmxLT7DWeLx+A8fWBCvy7nLYQmVltn2UpDxhcEl5vLeGW4kXrnFIDEfPoZHf7HReGj50rKzl3iwqR4JhuNxrfAIp5V0ndhp66Q8ic1xt1zvDiEr8GDxYnFcCdk3d9kGCdJYcrnhL+ARpxJcQC9zqroThTVO7F+KhzEg0Us8tmQ8HraS+0zjkUs8Jnh3WpZ4MDjESXIMFB6oiIOkgkyhVHhKj38aD0oUxADeYDwySExnEDw2LDY8mzgF1sSjHhYbuObiZ/6fth621ijw6tYjemE9lPDu5yoMIFPuP8v6ZgCMGvkj8PABBMNlQ59KRRBRLaQnEI5UIEwgHRtUN+88dIg9t0vxONfUyO17+H3wCE/rupbnDjxOe1rS4fY9ZsfdQ4/2q/h2yJYlH+nK/ZTZmMGF+aahnXyIIOqVSIi6ExbtLD8T3LPtAR+Ahyj4pAaPhJWKRuAxcuZyut7q+tkZPMKHoFQZIDUzl2XnzGWH02JxTyrY/RzmBKQW93F40Eo9wmJ2hlgGrDvp1W9AIEb7HqZt3PCNdUnW8TPpB3yPMXGP47Vv3OPEt9vtgZ33ihGzmO+Oe8xWQh1ibmi7UEH47Ftxj1I5COzeZ4JaVMYA6Wg8TGJbDoBadAjckZr4DTzOVdSUKlAyv+62gA58O6OmFxOjNxjVoqaboCtqutoUeBjliaJyHB5RJTce9iwk63rIMWnXMIB8LB7Y0IgafFCLDoVQ8hU8TH/K5Ix4DlDl3pjVEoji/kH12V25lxPfa54l5J6Sveai8djXkZ3IEvLlNZecACTM77iOYYhgCwMSj8SDAnlqnpidRqlKs+IoSUL0NB0oHYGHvWK7kfeAryA/I7PsznTSzoA1l6P6Ss4N7yY0R9ortqsshNby0PzLeGihCAAyqkxE2rmfIn6CjMDj8GANb5dIJnTQKu08scYDnioag4dJu9D5HluFBAqV+bjNSkuwLnjxhqy53JbGBpVFokxIe5bvEZyJ8n6OVWVhtNbfxcNEUQUSIHAXHejpNgWBR+EhGk1jAYTJVBYgqONXmti6c3u3Gw9XtthkpcP9CgexVV+P57VONTR4sFVTgY0HLuwRn9VgOMNctoxvx2fZYpdEfZ7T4hB8F6H6/n08ivwi7cw66TBCko8ReGCAuL1zQyR6PcRSDsS2OZTp28cD97m4c00XN20IUEHLMuJput8UtSEKPJNrumlqa+PhxcW7f6vxceTX3T2diMWrXNNwMb+e2ZlHOtn0/m08zBYJncJqe6WKDjcfbjwc2/lw9mKE4JBpPMzQw/StZUDQKDxsJZW3seKgNZ2C1l51YXemur2gn6rBorFLyT9Mkmlnpnq80QUhOZHyBq7vrdiyMrpKK5WFtAcevrz5CCVPAEGaji4+ktjCg9OnYs2LWmlnOZeAJgBJGr/aWJ4BMzTxao0t8j+JxwIF5unsw2cbTtz7XBa0PRkieSO6kk2797l4PwLayuKO7eW8VURHbWTIG1FTFJWrQCiRHwbsu0ISqMFBdTtai3NOlP+jPeUkpdaVCC5d4rwCl9UoJvnH8Dj9NrrRvyZQ01J3oXOX3Jq2F/lgs3Pvkqv4+G2efrm/aJvpFHsXD58higSQsltSAVAxoQGhJpJub7exhx7+Hh4cRHEKVNwD4XFjTTliec0gqG2Tjwa5vncaNS0XNvOdsXtsk825ZYmC+29SbkVKIm1YnHtsm9lix706Owr677HdpVVlSJLNVqODIqdQ/33uLTxAKTVd2TTmmNVHk9T5RyNwBvl7vkcCyLwKIm1lHQhQ4o2/C8QBtDWL7KxzJluP36G/P/8cg3aL2THnm2If/d1slXfs0N9I3o1+5r+PyvNxwA79YLfdi+WJnNbRNT/OvKEajoeXPeDKULUwn7G2dfCzmr+Ze075b7qmONO4RmneOoc2bFENVM7lKWToS7VFT3wNBMiBx/+nKMXv1WL/i3+i0k2XrXhQTez4w5x/g/4H2krbqlOT+V8AAAAASUVORK5CYII="

/***/ }),

/***/ "LS12":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-img3.e290439.png";

/***/ }),

/***/ "Luu2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/link3.3295397.png";

/***/ }),

/***/ "M2Cl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-info-b8.6fb9d66.jpg";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04c2046b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("KDBx");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("KT/5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04c2046b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-04c2046b", Component.options)
  } else {
    hotAPI.reload("data-v-04c2046b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MGI2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_footer_vue__ = __webpack_require__("BpUE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46c3e992_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_app_footer_vue__ = __webpack_require__("6fJm");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("fDdG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46c3e992_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_app_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\components\\app-footer.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-46c3e992", Component.options)
  } else {
    hotAPI.reload("data-v-46c3e992", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MGcR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "robot-design robot3s" }, [
    _c("div", { staticClass: "banner", attrs: { id: "design-b1" } }, [
      _c(
        "div",
        { staticClass: "bg-mask", class: { fadeUp: _vm.isB1Visible } },
        [
          _c(
            "div",
            { staticClass: "p1 delay1", class: { fadeUp: _vm.isB1Visible } },
            [_vm._v("机器人运营管理平台")]
          ),
          _c(
            "div",
            { staticClass: "p2 delay2", class: { fadeUp: _vm.isB1Visible } },
            [_vm._v("将机器人等多智能终端和机构运营管理服务相结合")]
          ),
          _c(
            "div",
            { staticClass: "p2 delay3", class: { fadeUp: _vm.isB1Visible } },
            [
              _vm._v(
                "将管理长者安全守护/生活照护智能服务与机构处理通报流程整合为一体化的AI运营管理平台"
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "item delay4",
              class: { fadeDown: _vm.isB1Visible }
            },
            [
              _vm.isMobile
                ? _c("img", {
                    attrs: {
                      src: __webpack_require__("wufj")
                    }
                  })
                : _c("img", {
                    attrs: {
                      src: __webpack_require__("wtzt")
                    }
                  })
            ]
          )
        ]
      )
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b2" } }, [
      _c(
        "div",
        { staticClass: "p1 delay1", class: { zoomOut: _vm.isB2Visible } },
        [_vm._v("登录界面")]
      ),
      _c(
        "div",
        { staticClass: "item delay2", class: { zoomOut: _vm.isB2Visible } },
        [
          _vm.isMobile
            ? _c("img", {
                attrs: {
                  src: __webpack_require__("jzMs")
                }
              })
            : _c("img", {
                attrs: {
                  src: __webpack_require__("jz4q")
                }
              })
        ]
      )
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b3" } }, [
      _c(
        "div",
        { staticClass: "p1 delay1", class: { zoomOut: _vm.isB3Visible } },
        [_vm._v("公告界面")]
      ),
      _c(
        "div",
        { staticClass: "item delay2", class: { zoomOut: _vm.isB3Visible } },
        [
          _vm.isMobile
            ? _c("img", {
                attrs: {
                  src: __webpack_require__("l+cR")
                }
              })
            : _c("img", {
                attrs: {
                  src: __webpack_require__("LS12")
                }
              })
        ]
      )
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b4" } }, [
      _c(
        "div",
        { staticClass: "p1 delay1", class: { zoomOut: _vm.isB4Visible } },
        [_vm._v("视频通话界面")]
      ),
      _c(
        "div",
        { staticClass: "item delay2", class: { zoomOut: _vm.isB4Visible } },
        [
          _vm.isMobile
            ? _c("img", {
                attrs: {
                  src: __webpack_require__("86us")
                }
              })
            : _c("img", {
                attrs: {
                  src: __webpack_require__("D6xO")
                }
              })
        ]
      )
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b5" } }, [
      _c(
        "div",
        { staticClass: "p1 delay1", class: { zoomOut: _vm.isB5Visible } },
        [_vm._v("工单界面")]
      ),
      _c(
        "div",
        { staticClass: "item delay2", class: { zoomOut: _vm.isB5Visible } },
        [
          _vm.isMobile
            ? _c("img", {
                attrs: {
                  src: __webpack_require__("XJFa")
                }
              })
            : _c("img", {
                attrs: {
                  src: __webpack_require__("FZ4f")
                }
              })
        ]
      )
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b6" } }, [
      _c(
        "div",
        { staticClass: "p1 delay1", class: { zoomOut: _vm.isB6Visible } },
        [_vm._v("概览界面")]
      ),
      _c(
        "div",
        { staticClass: "item delay2", class: { zoomOut: _vm.isB6Visible } },
        [
          _vm.isMobile
            ? _c("img", {
                attrs: {
                  src: __webpack_require__("6E3d")
                }
              })
            : _c("img", {
                attrs: {
                  src: __webpack_require__("qqJh")
                }
              })
        ]
      )
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b7" } }, [
      _c(
        "div",
        { staticClass: "p1 delay1", class: { zoomOut: _vm.isB7Visible } },
        [_vm._v("发布公告")]
      ),
      _c(
        "div",
        { staticClass: "item delay2", class: { zoomOut: _vm.isB7Visible } },
        [
          _vm.isMobile
            ? _c("img", {
                attrs: {
                  src: __webpack_require__("ZiJz")
                }
              })
            : _c("img", {
                attrs: {
                  src: __webpack_require__("NJT0")
                }
              })
        ]
      )
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b8" } }, [
      _c(
        "div",
        { staticClass: "p1 delay1", class: { fadeUp: _vm.isB8Visible } },
        [_vm._v("多维闭环机器人智能运营")]
      ),
      _c("div", { staticClass: "item" }, [
        _vm.isMobile
          ? _c(
              "div",
              { staticClass: "delay2", class: { fadeDown: _vm.isB8Visible } },
              [
                _c("img", {
                  staticClass: "img1",
                  attrs: {
                    src: __webpack_require__("UdWZ")
                  }
                }),
                _c("img", {
                  staticClass: "img2",
                  attrs: {
                    src: __webpack_require__("0bzJ")
                  }
                })
              ]
            )
          : _vm._e(),
        !_vm.isMobile
          ? _c(
              "div",
              { staticClass: "delay2", class: { fadeDown: _vm.isB8Visible } },
              [
                _c("img", {
                  staticClass: "img1",
                  attrs: {
                    src: __webpack_require__("elJj")
                  }
                }),
                _c("img", {
                  staticClass: "img2",
                  attrs: {
                    src: __webpack_require__("Jgfk")
                  }
                })
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51f0bf84", esExports)
  }
}

/***/ }),

/***/ "MLnh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("A+vi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7a7bc1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("HOPK");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("67jl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7a7bc1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\views\\robot\\3\\index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e7a7bc1a", Component.options)
  } else {
    hotAPI.reload("data-v-e7a7bc1a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mf4/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-info-b5.8457c81.jpg";

/***/ }),

/***/ "N9SH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-design-b1.5831b58.jpg";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__("JaHG");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





window.isMobile = Object(__WEBPACK_IMPORTED_MODULE_3__common_utils__["a" /* isMobileFun */])();
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  data: function data() {
    return {
      isMobile: window.isMobile
    };
  }
});
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

if (window.isMobile) document.querySelector('html').style.fontSize = document.body.clientWidth / 375 * 16 + 'px';

/***/ }),

/***/ "NJT0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-img7.87cb927.png";

/***/ }),

/***/ "NTse":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-info-4.9329780.png";

/***/ }),

/***/ "OOpF":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n* {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: transparent;\n  box-sizing: border-box;\n}\nhtml * {\n  outline: 0;\n}\nhtml,\nbody,\ndiv,\nspan,\nsmall,\np,\nem,\ni,\nb,\nth,\ntd,\ndl,\ndt,\ndd,\nul,\nol,\nli,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nform,\ntextarea,\ninput {\n  padding: 0;\n  margin: 0;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: normal;\n}\na {\n  color: #7d7d7d;\n  text-decoration: none;\n  transition: 0.3s;\n}\na:active,\na:visited {\n  color: currentColor;\n}\na:hover {\n  color: #3ec1bd;\n}\na,\nimg {\n  border: none;\n  touch-callout: none;\n}\nul,\nli,\nol {\n  list-style: none;\n}\ni,\nem {\n  font-style: normal;\n}\ns {\n  text-decoration: none;\n}\ntable {\n  border-spacing: 0;\n  border-collapse: collapse;\n}\ninput:focus,\nselect:focus,\ntextarea:focus,\nselect,\nbutton {\n  margin: 0;\n  outline: none;\n  appearance: none;\n}\ninput,\nbutton {\n  background-image: none;\n}\n.mt5 {\n  margin-top: 5px;\n}\n.mr5 {\n  margin-right: 5px;\n}\n.mb5 {\n  margin-bottom: 5px;\n}\n.ml5 {\n  margin-left: 5px;\n}\n.m5 {\n  margin: 5px;\n}\n.pt5 {\n  padding-top: 5px;\n}\n.pr5 {\n  padding-right: 5px;\n}\n.pb5 {\n  padding-bottom: 5px;\n}\n.pl5 {\n  padding-left: 5px;\n}\n.p5 {\n  padding: 5px;\n}\n.mt10 {\n  margin-top: 10px;\n}\n.mr10 {\n  margin-right: 10px;\n}\n.mb10 {\n  margin-bottom: 10px;\n}\n.ml10 {\n  margin-left: 10px;\n}\n.m10 {\n  margin: 10px;\n}\n.pt10 {\n  padding-top: 10px;\n}\n.pr10 {\n  padding-right: 10px;\n}\n.pb10 {\n  padding-bottom: 10px;\n}\n.pl10 {\n  padding-left: 10px;\n}\n.p10 {\n  padding: 10px;\n}\n.mt15 {\n  margin-top: 15px;\n}\n.mr15 {\n  margin-right: 15px;\n}\n.mb15 {\n  margin-bottom: 15px;\n}\n.ml15 {\n  margin-left: 15px;\n}\n.m15 {\n  margin: 15px;\n}\n.pt15 {\n  padding-top: 15px;\n}\n.pr15 {\n  padding-right: 15px;\n}\n.pb15 {\n  padding-bottom: 15px;\n}\n.pl15 {\n  padding-left: 15px;\n}\n.p15 {\n  padding: 15px;\n}\n.mt20 {\n  margin-top: 20px;\n}\n.mr20 {\n  margin-right: 20px;\n}\n.mb20 {\n  margin-bottom: 20px;\n}\n.ml20 {\n  margin-left: 20px;\n}\n.m20 {\n  margin: 20px;\n}\n.pt20 {\n  padding-top: 20px;\n}\n.pr20 {\n  padding-right: 20px;\n}\n.pb20 {\n  padding-bottom: 20px;\n}\n.pl20 {\n  padding-left: 20px;\n}\n.p20 {\n  padding: 20px;\n}\n.mt25 {\n  margin-top: 25px;\n}\n.mr25 {\n  margin-right: 25px;\n}\n.mb25 {\n  margin-bottom: 25px;\n}\n.ml25 {\n  margin-left: 25px;\n}\n.m25 {\n  margin: 25px;\n}\n.pt25 {\n  padding-top: 25px;\n}\n.pr25 {\n  padding-right: 25px;\n}\n.pb25 {\n  padding-bottom: 25px;\n}\n.pl25 {\n  padding-left: 25px;\n}\n.p25 {\n  padding: 25px;\n}\n.mt30 {\n  margin-top: 30px;\n}\n.mr30 {\n  margin-right: 30px;\n}\n.mb30 {\n  margin-bottom: 30px;\n}\n.ml30 {\n  margin-left: 30px;\n}\n.m30 {\n  margin: 30px;\n}\n.pt30 {\n  padding-top: 30px;\n}\n.pr30 {\n  padding-right: 30px;\n}\n.pb30 {\n  padding-bottom: 30px;\n}\n.pl30 {\n  padding-left: 30px;\n}\n.p30 {\n  padding: 30px;\n}\n.mt35 {\n  margin-top: 35px;\n}\n.mr35 {\n  margin-right: 35px;\n}\n.mb35 {\n  margin-bottom: 35px;\n}\n.ml35 {\n  margin-left: 35px;\n}\n.m35 {\n  margin: 35px;\n}\n.pt35 {\n  padding-top: 35px;\n}\n.pr35 {\n  padding-right: 35px;\n}\n.pb35 {\n  padding-bottom: 35px;\n}\n.pl35 {\n  padding-left: 35px;\n}\n.p35 {\n  padding: 35px;\n}\n.mt40 {\n  margin-top: 40px;\n}\n.mr40 {\n  margin-right: 40px;\n}\n.mb40 {\n  margin-bottom: 40px;\n}\n.ml40 {\n  margin-left: 40px;\n}\n.m40 {\n  margin: 40px;\n}\n.pt40 {\n  padding-top: 40px;\n}\n.pr40 {\n  padding-right: 40px;\n}\n.pb40 {\n  padding-bottom: 40px;\n}\n.pl40 {\n  padding-left: 40px;\n}\n.p40 {\n  padding: 40px;\n}\n.mt45 {\n  margin-top: 45px;\n}\n.mr45 {\n  margin-right: 45px;\n}\n.mb45 {\n  margin-bottom: 45px;\n}\n.ml45 {\n  margin-left: 45px;\n}\n.m45 {\n  margin: 45px;\n}\n.pt45 {\n  padding-top: 45px;\n}\n.pr45 {\n  padding-right: 45px;\n}\n.pb45 {\n  padding-bottom: 45px;\n}\n.pl45 {\n  padding-left: 45px;\n}\n.p45 {\n  padding: 45px;\n}\n.mt50 {\n  margin-top: 50px;\n}\n.mr50 {\n  margin-right: 50px;\n}\n.mb50 {\n  margin-bottom: 50px;\n}\n.ml50 {\n  margin-left: 50px;\n}\n.m50 {\n  margin: 50px;\n}\n.pt50 {\n  padding-top: 50px;\n}\n.pr50 {\n  padding-right: 50px;\n}\n.pb50 {\n  padding-bottom: 50px;\n}\n.pl50 {\n  padding-left: 50px;\n}\n.p50 {\n  padding: 50px;\n}\n#loading {\n  position: fixed;\n  width: 100%;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  z-index: 10000;\n  display: block;\n  background: transparent;\n  transition: all 0.5s;\n}\n#loading.hide {\n  display: none;\n}\n#loading .loading-inner {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  transition: transform 0.5s;\n  margin: auto;\n  width: 100px;\n  height: 100px;\n  border-radius: 10px;\n  color: #fff;\n  text-align: center;\n  background-color: rgba(0,0,0,0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  font-size: 0.75rem;\n}\n#loading .loading-inner i {\n  width: 40px;\n  height: 40px;\n  margin-bottom: 7px;\n  animation: loading 1s steps(12, end) infinite;\n  vertical-align: middle;\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAiIGhlaWdodD0iMTIwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGgxMDB2MTAwSDB6Ii8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjRTlFOUU5IiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTMwKSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iIzk4OTY5NyIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgzMCAxMDUuOTggNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjOUI5OTlBIiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKDYwIDc1Ljk4IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0EzQTFBMiIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA2NSA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNBQkE5QUEiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoMTIwIDU4LjY2IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0IyQjJCMiIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgxNTAgNTQuMDIgNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjQkFCOEI5IiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKDE4MCA1MCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNDMkMwQzEiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTE1MCA0NS45OCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNDQkNCQ0IiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTEyMCA0MS4zNCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNEMkQyRDIiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIDM1IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0RBREFEQSIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgtNjAgMjQuMDIgNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjRTJFMkUyIiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKC0zMCAtNS45OCA2NSkiLz48L3N2Zz4=\");\n  background-size: 100%;\n}\n@-moz-keyframes loading {\n0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n}\n100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n}\n}\n@-webkit-keyframes loading {\n0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n}\n100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n}\n}\n@-o-keyframes loading {\n0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n}\n100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n}\n}\n@keyframes loading {\n0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n}\n100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n}\n}\n.fade-enter-active,\n.fade-leave-active {\n  transition: opacity 0.5s;\n}\n.fade-enter,\n.fade-leave-to {\n  opacity: 0;\n}\n.fadeUp-enter-active,\n.fadeUp-leave-active {\n  transition: all 0.5s;\n}\n.fadeUp-enter,\n.fadeUp-leave-to {\n  opacity: 0;\n  transform: translateY(-100%);\n}\n.fadeUp {\n  opacity: 0;\n  animation: fadeUp 1s forwards;\n}\n.fadeDown,\n.is-mobile .app-header .nav a {\n  opacity: 0;\n  animation-name: fadeDown;\n  animation-duration: 1s;\n  animation-fill-mode: forwards;\n}\n.zoomIn {\n  transform: scale(1.4);\n  animation-name: zoomIn;\n  animation-duration: 1s;\n  animation-fill-mode: forwards;\n}\n.zoomOut {\n  animation-name: zoomOut;\n  animation-duration: 1s;\n  animation-fill-mode: backwards;\n}\n.info-b5-robot3-animation {\n  animation-name: info-b5-robot3-animation;\n  animation-duration: 3s;\n  animation-fill-mode: forwards;\n}\n.is-mobile .info-b5-robot3-animation {\n  animation-name: info-b5-robot3-animation-mobile;\n}\n.delay1 {\n  animation-delay: 0.3s;\n}\n.delay2 {\n  animation-delay: 0.6s;\n}\n.delay3 {\n  animation-delay: 0.9s;\n}\n.delay4 {\n  animation-delay: 1.2s;\n}\n.delay5 {\n  animation-delay: 1.5s;\n}\n.delay6 {\n  animation-delay: 1.8s;\n}\n.delay7 {\n  animation-delay: 2.1s;\n}\n.delay8 {\n  animation-delay: 2.4s;\n}\n.delay9 {\n  animation-delay: 2.7s;\n}\n.delay10 {\n  animation-delay: 3s;\n}\n.delay11 {\n  animation-delay: 3.3s;\n}\n.delay12 {\n  animation-delay: 3.6s;\n}\n.delay13 {\n  animation-delay: 3.9s;\n}\n.delay14 {\n  animation-delay: 4.2s;\n}\n.delay15 {\n  animation-delay: 4.5s;\n}\n.delay16 {\n  animation-delay: 4.8s;\n}\n.delay17 {\n  animation-delay: 5.1s;\n}\n.delay18 {\n  animation-delay: 5.399999999999999s;\n}\n.delay19 {\n  animation-delay: 5.7s;\n}\n.delay20 {\n  animation-delay: 6s;\n}\n@-moz-keyframes loading {\n0% {\n    opacity: 1;\n    transform: rotate(0);\n}\n90% {\n    opacity: 1;\n    transform: rotate(360deg);\n}\n100% {\n    opacity: 0;\n    transform: rotate(360deg);\n}\n}\n@-webkit-keyframes loading {\n0% {\n    opacity: 1;\n    transform: rotate(0);\n}\n90% {\n    opacity: 1;\n    transform: rotate(360deg);\n}\n100% {\n    opacity: 0;\n    transform: rotate(360deg);\n}\n}\n@-o-keyframes loading {\n0% {\n    opacity: 1;\n    transform: rotate(0);\n}\n90% {\n    opacity: 1;\n    transform: rotate(360deg);\n}\n100% {\n    opacity: 0;\n    transform: rotate(360deg);\n}\n}\n@keyframes loading {\n0% {\n    opacity: 1;\n    transform: rotate(0);\n}\n90% {\n    opacity: 1;\n    transform: rotate(360deg);\n}\n100% {\n    opacity: 0;\n    transform: rotate(360deg);\n}\n}\n@-moz-keyframes map {\n0% {\n    opacity: 0;\n    transform: scale(0.5);\n}\n100% {\n    opacity: 1;\n    transform: scale(1);\n}\n}\n@-webkit-keyframes map {\n0% {\n    opacity: 0;\n    transform: scale(0.5);\n}\n100% {\n    opacity: 1;\n    transform: scale(1);\n}\n}\n@-o-keyframes map {\n0% {\n    opacity: 0;\n    transform: scale(0.5);\n}\n100% {\n    opacity: 1;\n    transform: scale(1);\n}\n}\n@keyframes map {\n0% {\n    opacity: 0;\n    transform: scale(0.5);\n}\n100% {\n    opacity: 1;\n    transform: scale(1);\n}\n}\n@-moz-keyframes info-b5-robot3-animation-mobile {\n0% {\n    opacity: 0;\n    transform: translate(3.125rem, 6.25rem) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(1.5625rem, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(0.9375rem, 0) scale(0.8);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@-webkit-keyframes info-b5-robot3-animation-mobile {\n0% {\n    opacity: 0;\n    transform: translate(3.125rem, 6.25rem) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(1.5625rem, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(0.9375rem, 0) scale(0.8);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@-o-keyframes info-b5-robot3-animation-mobile {\n0% {\n    opacity: 0;\n    transform: translate(3.125rem, 6.25rem) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(1.5625rem, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(0.9375rem, 0) scale(0.8);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@keyframes info-b5-robot3-animation-mobile {\n0% {\n    opacity: 0;\n    transform: translate(3.125rem, 6.25rem) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(1.5625rem, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(0.9375rem, 0) scale(0.8);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@-moz-keyframes info-b5-robot3-animation {\n0% {\n    opacity: 0;\n    transform: translate(800px, 600px) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(800px, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(400px, 0) scale(0.7);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@-webkit-keyframes info-b5-robot3-animation {\n0% {\n    opacity: 0;\n    transform: translate(800px, 600px) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(800px, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(400px, 0) scale(0.7);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@-o-keyframes info-b5-robot3-animation {\n0% {\n    opacity: 0;\n    transform: translate(800px, 600px) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(800px, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(400px, 0) scale(0.7);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@keyframes info-b5-robot3-animation {\n0% {\n    opacity: 0;\n    transform: translate(800px, 600px) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(800px, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(400px, 0) scale(0.7);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@-moz-keyframes fadeUp {\n0% {\n    opacity: 0;\n    transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@-webkit-keyframes fadeUp {\n0% {\n    opacity: 0;\n    transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@-o-keyframes fadeUp {\n0% {\n    opacity: 0;\n    transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@keyframes fadeUp {\n0% {\n    opacity: 0;\n    transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@-moz-keyframes fadeDown {\n0% {\n    opacity: 0;\n    transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@-webkit-keyframes fadeDown {\n0% {\n    opacity: 0;\n    transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@-o-keyframes fadeDown {\n0% {\n    opacity: 0;\n    transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@keyframes fadeDown {\n0% {\n    opacity: 0;\n    transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@-moz-keyframes fadeRight {\n0% {\n    opacity: 0;\n    transform: translateX(100px);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@-webkit-keyframes fadeRight {\n0% {\n    opacity: 0;\n    transform: translateX(100px);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@-o-keyframes fadeRight {\n0% {\n    opacity: 0;\n    transform: translateX(100px);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@keyframes fadeRight {\n0% {\n    opacity: 0;\n    transform: translateX(100px);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@-moz-keyframes zoomIn {\n0% {\n    opacity: 0;\n    transform: scale(1.4);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@-webkit-keyframes zoomIn {\n0% {\n    opacity: 0;\n    transform: scale(1.4);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@-o-keyframes zoomIn {\n0% {\n    opacity: 0;\n    transform: scale(1.4);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@keyframes zoomIn {\n0% {\n    opacity: 0;\n    transform: scale(1.4);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@-moz-keyframes zoomOut {\n0% {\n    opacity: 0;\n    transform: scale(0.8);\n}\n100% {\n    transform: scale(1);\n}\n}\n@-webkit-keyframes zoomOut {\n0% {\n    opacity: 0;\n    transform: scale(0.8);\n}\n100% {\n    transform: scale(1);\n}\n}\n@-o-keyframes zoomOut {\n0% {\n    opacity: 0;\n    transform: scale(0.8);\n}\n100% {\n    transform: scale(1);\n}\n}\n@keyframes zoomOut {\n0% {\n    opacity: 0;\n    transform: scale(0.8);\n}\n100% {\n    transform: scale(1);\n}\n}\n.is-mobile {\n  width: 100%;\n  overflow: hidden;\n}\n.is-mobile .w {\n  width: 100%;\n}\n.is-mobile .cp-robot .tabs {\n  border-top: none;\n  border-bottom: 1px solid #eae9e9;\n  box-shadow: none;\n}\n.is-mobile .cp-robot .tabs a {\n  margin: 0 2.1875rem;\n}\n.is-mobile .robot-spec {\n  padding: 0;\n}\n.is-mobile .robot-spec .row {\n  display: block;\n  text-align: left;\n  padding: 1.25rem 0;\n  margin: 0 1.25rem;\n}\n.is-mobile .robot-spec .row .col1 {\n  width: 100%;\n  text-align: left;\n  padding-bottom: 0.625rem;\n}\n.is-mobile .robot-spec .row .col1 i {\n  display: none;\n}\n.is-mobile .robot-spec .row .params {\n  border: none;\n  padding: 0;\n}\n.is-mobile .robot-spec .row .params .param {\n  line-height: 2.5;\n}\n.is-mobile .robot-spec .row .params .col2 {\n  width: 4.0625rem;\n}\nbody {\n  font-size: 14px;\n  font-family: \"Helvetica Neue\", Helvetica, \"PingFang SC\", \"Hiragino Sans GB\", \"Microsoft YaHei\", \"\\5FAE\\8F6F\\96C5\\9ED1\", Arial, sans-serif;\n  color: #000;\n  background: #fff;\n}\n.w {\n  width: 1200px;\n  margin: 0 auto;\n}\n.ani-card {\n  transition: 1s all;\n}\n.ani-card:hover:hover {\n  box-shadow: 7px 7px 8px #ddd;\n}\n.app-header {\n  position: relative;\n  height: 90px;\n  line-height: 90px;\n  overflow: hidden;\n}\n.app-header .logo {\n  float: left;\n  width: 190px;\n  height: 90px;\n  background: url(" + escape(__webpack_require__("HzeT")) + ") no-repeat left center;\n}\n.app-header .nav {\n  float: right;\n}\n.app-header .nav a {\n  cursor: pointer;\n  display: inline-block;\n  font-size: 16px;\n  margin: 0 38px;\n  color: #000;\n}\n.app-header .nav a:hover,\n.app-header .nav a.router-link-active {\n  color: #3ec1bd;\n}\n.is-mobile .app-header {\n  position: relative;\n  height: 2.8125rem;\n  line-height: 2.8125rem;\n}\n.is-mobile .app-header.show-nav {\n  z-index: 20;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 30;\n  height: inherit;\n  background: #393d3f;\n}\n.is-mobile .app-header.show-nav .logo {\n  left: 7.96875rem;\n}\n.is-mobile .app-header.show-nav .nav {\n  display: block;\n}\n.is-mobile .app-header .logo {\n  position: absolute;\n  left: 0.78125rem;\n  top: 0;\n  height: 2.8125rem;\n  width: 7.5rem;\n  background-size: 5.625rem auto;\n  background-position: center;\n  transition: 1s left;\n}\n.is-mobile .app-header .menu {\n  position: absolute;\n  right: 0.78125rem;\n  top: 0;\n  width: 1.25rem;\n  height: 2.8125rem;\n  background: url(" + escape(__webpack_require__("hX8U")) + ") no-repeat center;\n  background-size: 100% auto;\n}\n.is-mobile .app-header .close {\n  position: absolute;\n  right: 0.78125rem;\n  top: 0;\n  width: 0.9375rem;\n  height: 2.8125rem;\n  background: url(" + escape(__webpack_require__("mLd6")) + ") no-repeat center;\n  background-size: 100% auto;\n}\n.is-mobile .app-header .nav {\n  float: inherit;\n  margin-top: 3.75rem;\n  text-align: center;\n  display: none;\n}\n.is-mobile .app-header .nav a {\n  display: block;\n  width: 12.5rem;\n  margin: 0 auto;\n  font-size: 0.9375rem;\n  color: #fff;\n  border-bottom: 1px solid #444749;\n}\n.is-mobile .app-header .nav a:hover,\n.is-mobile .app-header .nav a.router-link-active {\n  color: #3ec1bd;\n}\n", ""]);

// exports


/***/ }),

/***/ "OUBK":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAlCAMAAAAdgrsPAAAAYFBMVEVlZWVoaGhmZmZlZWVnZ2dmZmZmZmZMaXFfX19lZWVOTk5lZWVkZGRlZWVmZmZlZWVlZWVmZmZlZWVmZmZlZWVmZmZmZmZkZGRmZmZmZmZkZGRmZmZlZWVmZmZoaGhmZmaNRSSFAAAAH3RSTlOwB+67QG+QABDQAh4Z5p183frzwdVVN0xdKwuziaknXIn1DQAAAP9JREFUeNrt1MtuwyAQhWEuJgeDAd9jO0nn/d8yQNVGpFbtfftvvPkkFjMehhi/9LRbxxrEMrqQuLG9Whq+UU1X7NYQ8Req9pEm0n8Aaa1HuurdLJHVGkzSYZKRYwc5YsTw2WryIJoqKA1ouwZlkWIv1HRLnrWg2rkPqPht+/kNBZIZ0QQub1CkYHz9hkZGNiEHYBIRcWCmrUAz2TEk1DVAGCNagaU3BfISqjURUT2FTkXULkrci+e4GC4PqiKSD9EqQNVeuGAKNPVpWX1EHjk1IFUg6bPcfkOmm/ObFe5fSP5A4EhpA86RM1uBTszu1Bac2af//+78fTq+dKdu5hOyCDgl0a8okAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "ObJJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "P2Hj":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("lpgv");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2d348458", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5a4bed13\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./home.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5a4bed13\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./home.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "PzVH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-info-b4.d911899.jpg";

/***/ }),

/***/ "Qk9D":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Quej":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-info-b6.238b36c.jpg";

/***/ }),

/***/ "RNlF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-info-b1.4ddf2d2.jpg";

/***/ }),

/***/ "RlN6":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.cp-news .banner {\n  background: url(" + escape(__webpack_require__("qlnE")) + ") center;\n  background-size: auto 100%;\n  width: 100%;\n  height: 240px;\n  color: #fff;\n  font-size: 18px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.cp-news .banner .p1 {\n  font-size: 40px;\n}\n.cp-news .main-wrap {\n  background-color: #f5f7f9;\n  padding: 45px 0;\n}\n.cp-news .main-wrap .w {\n  padding: 30px;\n  background-color: #fff;\n}\n.cp-news .main-wrap .list .item {\n  border-bottom: 1px solid #dbd9d9;\n  transition: 1s all;\n  overflow: hidden;\n  padding: 20px 0;\n}\n.cp-news .main-wrap .list .item:hover {\n  background: #f5f7f9;\n  border-bottom-color: #f5f7f9;\n}\n.cp-news .main-wrap .list .item .col {\n  float: left;\n  margin-left: 30px;\n}\n.cp-news .main-wrap .list .item .date {\n  padding-top: 60px;\n}\n.cp-news .main-wrap .list .item .date h3 {\n  font-size: 30px;\n  color: #242323;\n}\n.cp-news .main-wrap .list .item .date span {\n  font-size: 14px;\n  color: #666;\n}\n.cp-news .main-wrap .list .item .img {\n  width: 187px;\n  height: 140px;\n}\n.cp-news .main-wrap .list .item .info {\n  width: 700px;\n}\n.cp-news .main-wrap .list .item .info .title {\n  display: block;\n  color: #242323;\n  font-size: 20px;\n  padding-bottom: 10px;\n}\n.cp-news .main-wrap .list .item .info .title:hover {\n  color: #3ec1bd;\n}\n.cp-news .main-wrap .list .item .info .desc {\n  font-size: 14px;\n  color: #666;\n}\n.cp-news .main-wrap .list .item .info .source {\n  margin-top: 5px;\n  text-align: right;\n  color: #999;\n}\n.cp-news .main-wrap .page {\n  text-align: center;\n  margin-top: 60px;\n}\n.cp-news .main-wrap .page span {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n  margin: 0 5px;\n  color: #999;\n  font-size: 14px;\n  cursor: pointer;\n  user-select: none;\n}\n.cp-news .main-wrap .page span.active {\n  color: #3bc0bc;\n  cursor: default;\n}\n.cp-news .main-wrap .page .btn-prev,\n.cp-news .main-wrap .page .btn-next {\n  background: #3bc0bc;\n  color: #fff;\n  font-size: 14px;\n}\n.cp-news .main-wrap .page .btn-prev.disable,\n.cp-news .main-wrap .page .btn-next.disable {\n  background: #ccc;\n  cursor: not-allowed;\n}\n.is-mobile .cp-news .banner {\n  height: 3.125rem;\n  background-image: url(" + escape(__webpack_require__("7EJk")) + ");\n}\n.is-mobile .cp-news .banner .p1 {\n  font-size: 0.9375rem;\n}\n.is-mobile .cp-news .banner .p2 {\n  font-size: 0.625rem;\n}\n.is-mobile .cp-news .main-wrap {\n  padding: 0;\n}\n.is-mobile .cp-news .main-wrap .w {\n  padding: 0;\n  padding: 0;\n}\n.is-mobile .cp-news .main-wrap .list .item {\n  padding: 0.625rem 0;\n}\n.is-mobile .cp-news .main-wrap .list .item .col {\n  margin-left: 0.9375rem;\n}\n.is-mobile .cp-news .main-wrap .list .item .img {\n  width: 5.625rem;\n  height: 4.375rem;\n}\n.is-mobile .cp-news .main-wrap .list .item .info {\n  position: relative;\n  width: 15rem;\n  min-height: 4.375rem;\n}\n.is-mobile .cp-news .main-wrap .list .item .info .title {\n  font-size: 0.9375rem;\n  padding-bottom: 0.9375rem;\n}\n.is-mobile .cp-news .main-wrap .list .item .info .source {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  line-height: 0.9375rem;\n  font-size: 0.625rem;\n}\n.is-mobile .cp-news .main-wrap .list .item .info .source .mobile-source {\n  float: left;\n}\n.is-mobile .cp-news .main-wrap .list .item .info .source .mobile-date {\n  float: right;\n}\n", ""]);

// exports


/***/ }),

/***/ "SXkU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_design_vue__ = __webpack_require__("fmc2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a35226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_design_vue__ = __webpack_require__("d3Mp");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("Tni/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_design_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a35226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_design_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\views\\robot\\3\\design.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-64a35226", Component.options)
  } else {
    hotAPI.reload("data-v-64a35226", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tni/":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7+3b");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("cbdf7922", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-64a35226\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./design.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-64a35226\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./design.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "U+YB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-info-b2.813f3d4.jpg";

/***/ }),

/***/ "U/rx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-banner-default.d2edcdd.jpg";

/***/ }),

/***/ "UPrL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-info-b4.78c2e2e.png";

/***/ }),

/***/ "UdWZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-img8.2744766.png";

/***/ }),

/***/ "Un2h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tab: 'tel',
      mobileTabIndex: 0,
      typeList: [{
        name: 'tel',
        title: '拨打电话',
        info: '拨打售后服务电话：193 0215 5869'
      }, {
        name: 'app',
        title: 'APP中提交',
        info: '登录手机APP，在个人中心的“问题反馈”，<br>填写故障信息'
      }, {
        name: 'weixin',
        title: '微信号提交',
        info: '关注微信号“弗徕威服务机器人（Flw_service ）”进行在线报修 <br>'
      }],
      qaList: [{
        question: '每次使用机器人前，都需要手动连接网络和外设吗？',
        answer: '不需要，第一次使用时需要手动同步连接，以后使用会自动连接。除非路由器配置（名称或密码）更改时，机器人需要通过手动再次连接。'
      }, {
        question: '如果家里正在播出的电视机节目中出现“打开窗户”、“过来”等语音对话，是否会误导机器人执行相关指令？',
        answer: '不会。因为对机器人发出的语音指令，前面需一起附带机器人的名字，首先唤醒机器人，如“维拉，你好”等，后面发出的指令才会有效，故一般不会出现电视机节目中出现诸如“打开窗户”、“过来”等语音对话时，会误导机器人执行相关指令。另外在未来，弗徕威家用服务机器人还会支持用户给机器人自定义名字。'
      }]
    };
  },

  computed: {
    currentMobileTab: function currentMobileTab() {
      return this.typeList[this.mobileTabIndex];
    }
  },
  methods: {
    setTab: function setTab(key) {
      this.tab = key;
    },
    prevTab: function prevTab() {
      if (this.mobileTabIndex > 0) this.mobileTabIndex--;
    },
    nextTab: function nextTab() {
      if (this.mobileTabIndex < this.typeList.length - 1) this.mobileTabIndex++;
    }
  },
  created: function created() {}
});

/***/ }),

/***/ "UyPP":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "Uyve":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-info-b6.05ac8d0.jpg";

/***/ }),

/***/ "V2yK":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAjCAMAAADVEmihAAAAhFBMVEVMaXFmZmZlZWVmZmZmZmZmZmZlZWVmZmZiYmJlZWVlZWVoaGhlZWVlZWVmZmZmZmZlZWVlZWVlZWVlZWVmZmZkZGRmZmZlZWVmZmZlZWVmZmZmZmZmZmZmZmZlZWVmZmZlZWVmZmZmZmZmZmZmZmZlZWVmZmZnZ2dmZmZmZmZlZWVmZmYaNXrFAAAAK3RSTlMAZ+V6+hvsAwf1sAtJmlORRKnY0GMQjYLfT6PxLDcmtxXIH3Rt/cNcP4i+E9FYJgAAAeRJREFUeNp9VImSqyAQBEUj3ke8E6/c2///f08hbKLytq3KDFMNdnoGyS8smmQcYJV7OZG/8Ozxhex4+B/RcgHm0nNOyHCiDQfSWM+MbfBy+Kw9WgGF7uCQ4Wdal5wX4Dp7mQzB/oSao9nWcgOBeGun+M60ZDHDdUONkDmLihaZp5Sn+RwpuLViDgznJWYAfFG5AwhlUqyoV/yImACQ1geA3B3DXv2zHlQaZCYPojIqMwNPmailto35MUk5AMM95qoGeJruBQy/4FGuqHunj0tny+cwH342U8CuRbmFRXb2Ia0/Sz8FLtKRcMMsgWYlygkgulFu+xcDAdmgAJvt68BWo3JIcT8seotOLC8vS1iaCe/db6oPnGQwxA5gnMPE4M+/XIhWCNC/ZVREUu9LbITOEKAfavaep0c5CQHUHMRMy53X75G3ob0qHSAtZx8NBs466gQo030y+eKNI0LtjYYtk7Sdlq63Y+8aKHTUEr2IJ7QctltBQJi0gWfgoVppm94yHL7fVcKCXbsqOVVNOxMVHuC7Ca5vqGXmrOYwgXHaXfSI6JCP4I/vAr0hORA91wXG0Hm/MSej/KToQW2g7QvTjEbGy0hZrYV3yfDGbX4a8ies0HxFZj0M0Q32XoAenSs+Hf8AgpMzuq51HpoAAAAASUVORK5CYII="

/***/ }),

/***/ "V8LD":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.robot-design.robot3s {\n  color: #fff;\n}\n.robot-design.robot3s #design-b1 {\n  position: relative;\n  min-width: 1200px;\n  height: 800px;\n  overflow: hidden;\n  background: url(" + escape(__webpack_require__("tUr6")) + ") no-repeat center;\n}\n.robot-design.robot3s #design-b1 .bg-mask {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-size: auto 100%;\n  text-align: center;\n}\n.robot-design.robot3s #design-b1 .p1 {\n  margin-top: 44px;\n  font-size: 31px;\n  padding-bottom: 10px;\n  text-align: center;\n}\n.robot-design.robot3s #design-b1 .p2 {\n  font-size: 18px;\n  padding-bottom: 10px;\n}\n.robot-design.robot3s #design-b1 .item img {\n  margin-top: 55px;\n}\n.robot-design.robot3s #design-b2,\n.robot-design.robot3s #design-b3,\n.robot-design.robot3s #design-b4,\n.robot-design.robot3s #design-b5,\n.robot-design.robot3s #design-b6,\n.robot-design.robot3s #design-b7 {\n  display: flex;\n  background-image: url(" + escape(__webpack_require__("tUr6")) + ");\n}\n.robot-design.robot3s #design-b2 .p1,\n.robot-design.robot3s #design-b3 .p1,\n.robot-design.robot3s #design-b4 .p1,\n.robot-design.robot3s #design-b5 .p1,\n.robot-design.robot3s #design-b6 .p1,\n.robot-design.robot3s #design-b7 .p1 {\n  font-size: 25px;\n}\n.robot-design.robot3s #design-b2 .item,\n.robot-design.robot3s #design-b3 .item,\n.robot-design.robot3s #design-b4 .item,\n.robot-design.robot3s #design-b5 .item,\n.robot-design.robot3s #design-b6 .item,\n.robot-design.robot3s #design-b7 .item {\n  display: inline;\n}\n.robot-design.robot3s #design-b2 .p1 {\n  margin-left: 325px;\n  margin-top: 39px;\n}\n.robot-design.robot3s #design-b2 .item {\n  width: 526px;\n}\n.robot-design.robot3s #design-b2 .item img {\n  margin-top: 28px;\n  margin-left: 35px;\n}\n.robot-design.robot3s #design-b3 .p1 {\n  margin-left: 325px;\n  margin-top: 39px;\n}\n.robot-design.robot3s #design-b3 .item {\n  width: 571px;\n}\n.robot-design.robot3s #design-b4 .p1 {\n  margin-left: 276px;\n  margin-top: 39px;\n}\n.robot-design.robot3s #design-b4 .item {\n  width: 548px;\n}\n.robot-design.robot3s #design-b5 .p1 {\n  margin-left: 325px;\n  margin-top: 39px;\n}\n.robot-design.robot3s #design-b5 .item {\n  width: 556px;\n}\n.robot-design.robot3s #design-b6 .p1 {\n  margin-left: 325px;\n  margin-top: 39px;\n}\n.robot-design.robot3s #design-b6 .item {\n  width: 543px;\n}\n.robot-design.robot3s #design-b7 .p1 {\n  margin-left: 325px;\n  margin-top: 39px;\n}\n.robot-design.robot3s #design-b7 .item {\n  width: 546px;\n}\n.robot-design.robot3s #design-b8 {\n  position: relative;\n  min-width: 1200px;\n  height: 800px;\n  overflow: hidden;\n  background: url(" + escape(__webpack_require__("tUr6")) + ") no-repeat center;\n  text-align: center;\n}\n.robot-design.robot3s #design-b8 .p1 {\n  margin-top: 80px;\n  font-size: 31px;\n  padding-bottom: 10px;\n  text-align: center;\n}\n.robot-design.robot3s #design-b8 .delay2 .img1 {\n  margin-top: 120px;\n  margin-left: 320px;\n  width: 743px;\n}\n.robot-design.robot3s #design-b8 .delay2 .img2 {\n  margin-top: 31px;\n  margin-left: 113px;\n  width: 191px;\n}\n.robot-design.robot3s .banner {\n  height: 800px;\n  min-width: 1200px;\n  background-size: auto 100%;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n.is-mobile .robot3s #design-b1,\n.is-mobile .robot3s #design-b2,\n.is-mobile .robot3s #design-b3,\n.is-mobile .robot3s #design-b4,\n.is-mobile .robot3s #design-b5,\n.is-mobile .robot3s #design-b6,\n.is-mobile .robot3s #design-b7,\n.is-mobile .robot3s #design-b8 {\n  width: 100%;\n  min-width: inherit;\n  height: 34.375rem;\n  background-image: url(" + escape(__webpack_require__("fAp4")) + ");\n  flex-direction: column;\n}\n.is-mobile .robot3s #design-b1 {\n  text-align: center;\n}\n.is-mobile .robot3s #design-b1 .p1 {\n  font-size: 20px;\n  padding-bottom: 14px;\n}\n.is-mobile .robot3s #design-b1 .p2 {\n  font-size: 7px;\n}\n.is-mobile .robot3s #design-b1 .item img {\n  margin-top: 10px;\n}\n.is-mobile .robot3s #design-b2 .p1 {\n  margin-left: 51px;\n  margin-top: 118px;\n}\n.is-mobile .robot3s #design-b2 .item {\n  width: 290px;\n}\n.is-mobile .robot3s #design-b2 .item img {\n  margin-top: 28px;\n  margin-left: 42px;\n}\n.is-mobile .robot3s #design-b3 .p1 {\n  margin-left: 51px;\n  margin-top: 118px;\n}\n.is-mobile .robot3s #design-b3 .item {\n  width: 306px;\n}\n.is-mobile .robot3s #design-b3 .item img {\n  margin-top: 21px;\n  margin-left: 35px;\n}\n.is-mobile .robot3s #design-b4 .p1 {\n  margin-left: 50px;\n  margin-top: 118px;\n}\n.is-mobile .robot3s #design-b4 .item {\n  width: 306px;\n}\n.is-mobile .robot3s #design-b4 .item img {\n  margin-left: 35px;\n  margin-top: 21px;\n}\n.is-mobile .robot3s #design-b5 .p1 {\n  margin-left: 49px;\n  margin-top: 118px;\n}\n.is-mobile .robot3s #design-b5 .item {\n  width: 305px;\n}\n.is-mobile .robot3s #design-b5 .item img {\n  margin-top: 22px;\n  margin-left: 35px;\n}\n.is-mobile .robot3s #design-b6 .p1 {\n  margin-left: 49px;\n  margin-top: 118px;\n}\n.is-mobile .robot3s #design-b6 .item {\n  width: 291px;\n}\n.is-mobile .robot3s #design-b6 .item img {\n  margin-top: 29px;\n  margin-left: 41px;\n}\n.is-mobile .robot3s #design-b7 .p1 {\n  margin-left: 49px;\n  margin-top: 118px;\n}\n.is-mobile .robot3s #design-b7 .item {\n  width: 306px;\n}\n.is-mobile .robot3s #design-b7 .item img {\n  margin-top: 22px;\n  margin-left: 33px;\n}\n.is-mobile .robot3s #design-b8 .p1 {\n  font-size: 20px;\n}\n.is-mobile .robot3s #design-b8 .delay2 .img1 {\n  margin-top: 58px;\n  margin-left: 11px;\n  width: 354px;\n}\n.is-mobile .robot3s #design-b8 .delay2 .img2 {\n  margin-top: 44px;\n  margin-left: 233px;\n  width: 102px;\n}\n.is-mobile .robot-design .p1 {\n  font-size: 1.4375rem;\n}\n.is-mobile .robot-design .p2 {\n  font-size: 0.75rem;\n}\n", ""]);

// exports


/***/ }),

/***/ "V8SB":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.robot-info .ww {\n  position: relative;\n}\n.robot-info .ww .p1 {\n  font-size: 37px;\n  color: #181616;\n}\n.robot-info .ww .p0 {\n  font-size: 20px;\n  color: #414141;\n}\n.robot-info .ww .p2 {\n  font-size: 20px;\n  color: #414141;\n}\n.robot-info .ww .p3 {\n  font-size: 17px;\n  color: #616161;\n}\n.robot-info.robot3s #info-b1 {\n  position: relative;\n  min-width: 1200px;\n  height: 800px;\n  overflow: hidden;\n}\n.robot-info.robot3s #info-b1 .bg-mask {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: url(" + escape(__webpack_require__("EG1Y")) + ") no-repeat center;\n  background-size: auto 100%;\n}\n.robot-info.robot3s #info-b1 .ww {\n  display: flex;\n}\n.robot-info.robot3s #info-b1 .ww .left {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  margin-left: 414px;\n  margin-top: 135px;\n}\n.robot-info.robot3s #info-b1 .ww .left .p2 {\n  margin-top: 37px;\n}\n.robot-info.robot3s #info-b1 .ww .left .p3 {\n  margin-top: 34px;\n}\n.robot-info.robot3s #info-b1 .ww .right {\n  display: flex;\n  flex-direction: column;\n  margin-top: 75px;\n  margin-left: 610px;\n}\n.robot-info.robot3s #info-b1 .ww .right .p4 {\n  font-size: 17px;\n  display: flex;\n  align-items: center;\n  padding-bottom: 13px;\n}\n.robot-info.robot3s #info-b1 .ww .right .p4 img {\n  margin-right: 10px;\n  width: 15px;\n  height: 15px;\n}\n.robot-info.robot3s #info-b2 {\n  min-width: 1200px;\n  background: #f5f7f9;\n  height: 800px;\n  background: url(" + escape(__webpack_require__("U+YB")) + ") no-repeat 60% center;\n  background-size: auto 100%;\n}\n.robot-info.robot3s #info-b2 .ww {\n  padding-top: 118px;\n  margin-left: 334px;\n  text-align: left;\n}\n.robot-info.robot3s #info-b2 .ww .p2 {\n  margin-top: 26px;\n}\n.robot-info.robot3s #info-b2 .ww .p3 {\n  margin-top: 24px;\n}\n.robot-info.robot3s #info-b2 .ww .p4 {\n  margin-top: 133px;\n  margin-left: -228px;\n}\n.robot-info.robot3s #info-b2 .ww .p4 .item {\n  vertical-align: top;\n  display: inline-block;\n  margin-right: 32px;\n  text-align: center;\n}\n.robot-info.robot3s #info-b2 .ww .p4 .item img {\n  width: 273px;\n  height: 208px;\n}\n.robot-info.robot3s #info-b2 .ww .p4 .item span {\n  display: inline-block;\n  font-size: 26px;\n  margin-top: 34px;\n}\n.robot-info.robot3s #info-b3 {\n  min-width: 1200px;\n  height: 800px;\n  background: url(" + escape(__webpack_require__("ADrp")) + ") no-repeat center;\n  background-size: auto 100%;\n}\n.robot-info.robot3s #info-b3 .ww {\n  padding-top: 103px;\n  margin-left: 368px;\n  text-align: left;\n}\n.robot-info.robot3s #info-b3 .ww .p2 {\n  margin-top: 32px;\n}\n.robot-info.robot3s #info-b3 .ww .p3 {\n  margin-top: 25px;\n}\n.robot-info.robot3s #info-b3 .ww .p4 {\n  margin-left: -200px;\n  margin-top: 152px;\n}\n.robot-info.robot3s #info-b3 .ww .p4 .item img {\n  width: 429px;\n  height: 315px;\n}\n.robot-info.robot3s #info-b4 {\n  min-width: 1200px;\n  height: 800px;\n  background: url(" + escape(__webpack_require__("inTp")) + ") no-repeat center;\n  background-size: auto 100%;\n}\n.robot-info.robot3s #info-b4 .ww {\n  padding-top: 151px;\n  margin-left: 354px;\n  text-align: left;\n}\n.robot-info.robot3s #info-b4 .ww .p2 {\n  margin-top: 31px;\n}\n.robot-info.robot3s #info-b4 .ww .p3 {\n  margin-top: 25px;\n}\n.robot-info.robot3s #info-b5 {\n  min-width: 1200px;\n  height: 800px;\n  background: url(" + escape(__webpack_require__("7xkP")) + ") no-repeat center;\n  background-size: auto 100%;\n}\n.robot-info.robot3s #info-b5 .ww {\n  padding-top: 138px;\n  margin-left: 434px;\n  text-align: left;\n}\n.robot-info.robot3s #info-b5 .ww .p0,\n.robot-info.robot3s #info-b5 .ww .p1,\n.robot-info.robot3s #info-b5 .ww .p2,\n.robot-info.robot3s #info-b5 .ww .p3,\n.robot-info.robot3s #info-b5 .ww .p4 {\n  color: #fff;\n}\n.robot-info.robot3s #info-b5 .ww .p2 {\n  margin-top: 32px;\n}\n.robot-info.robot3s #info-b5 .ww .p3 {\n  margin-top: 24px;\n}\n.is-mobile .robot3s #info-b1,\n.is-mobile .robot3s #info-b2,\n.is-mobile .robot3s #info-b3,\n.is-mobile .robot3s #info-b4,\n.is-mobile .robot3s #info-b5,\n.is-mobile .robot3s #info-b6,\n.is-mobile .robot3s #info-b7,\n.is-mobile .robot3s #info-b8 {\n  width: 100%;\n  min-width: inherit;\n  height: 34.375rem;\n}\n.is-mobile .robot3s #info-b1 .bg-mask {\n  background-image: url(" + escape(__webpack_require__("uRk5")) + ");\n}\n.is-mobile .robot3s #info-b1 .ww {\n  display: block;\n}\n.is-mobile .robot3s #info-b1 .ww .left {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  margin-left: 0rem;\n  margin-top: 3.125rem;\n}\n.is-mobile .robot3s #info-b1 .ww .left .p2 {\n  margin-top: 0.5rem;\n}\n.is-mobile .robot3s #info-b1 .ww .left .p3 {\n  margin-top: 0.5rem;\n}\n.is-mobile .robot3s #info-b1 .ww .right {\n  display: flex;\n  flex-direction: column;\n  margin-top: 1.25rem;\n  margin-left: 12.5rem;\n}\n.is-mobile .robot3s #info-b1 .ww .right .p4 {\n  font-size: 0.625rem;\n  display: flex;\n  align-items: center;\n  padding-bottom: 0.40625rem;\n}\n.is-mobile .robot3s #info-b1 .ww .right .p4 img {\n  margin-right: 0.3125rem;\n  width: 0.46875rem;\n  height: 0.46875rem;\n}\n.is-mobile .robot3s #info-b2 {\n  background-image: url(" + escape(__webpack_require__("mLsT")) + ");\n}\n.is-mobile .robot3s #info-b2 .ww {\n  text-align: center;\n  padding-top: 3.6875rem;\n  margin-left: 0rem;\n}\n.is-mobile .robot3s #info-b2 .ww .p0 {\n  color: #414141;\n}\n.is-mobile .robot3s #info-b2 .ww .p2 {\n  margin-top: 0.3125rem;\n  color: #414141;\n}\n.is-mobile .robot3s #info-b2 .ww .p3 {\n  margin-top: 0.3125rem;\n  color: #616161;\n}\n.is-mobile .robot3s #info-b2 .ww .p4 {\n  margin-top: 4.6875rem;\n  margin-left: -7.8125rem;\n}\n.is-mobile .robot3s #info-b2 .ww .p4 .item {\n  display: block;\n  margin-top: 1.40625rem;\n}\n.is-mobile .robot3s #info-b2 .ww .p4 .item img {\n  width: 5.3125rem;\n  height: 4.0625rem;\n}\n.is-mobile .robot3s #info-b2 .ww .p4 .item span {\n  font-size: 0.3125rem;\n  margin-top: 0.3125rem;\n}\n.is-mobile .robot3s #info-b3 {\n  background-image: url(" + escape(__webpack_require__("1juE")) + ");\n}\n.is-mobile .robot3s #info-b3 .ww {\n  text-align: center;\n  padding-top: 4.6875rem;\n  margin-left: 0rem;\n}\n.is-mobile .robot3s #info-b3 .ww .p0 {\n  color: #414141;\n}\n.is-mobile .robot3s #info-b3 .ww .p2 {\n  margin-top: 0.78125rem;\n  color: #414141;\n}\n.is-mobile .robot3s #info-b3 .ww .p3 {\n  margin-top: 0.46875rem;\n  color: #444;\n}\n.is-mobile .robot3s #info-b3 .ww .p4 {\n  margin-top: 8.4375rem;\n  margin-left: -9.375rem;\n}\n.is-mobile .robot3s #info-b3 .ww .p4 .item img {\n  width: 10.625rem;\n  height: 7.8125rem;\n}\n.is-mobile .robot3s #info-b4 {\n  background-image: url(" + escape(__webpack_require__("UPrL")) + ");\n}\n.is-mobile .robot3s #info-b4 .ww {\n  text-align: center;\n  padding-top: 1.25rem;\n  margin-left: 0rem;\n}\n.is-mobile .robot3s #info-b4 .ww .p0 {\n  color: #eee;\n}\n.is-mobile .robot3s #info-b4 .ww .p1 {\n  color: #fff;\n}\n.is-mobile .robot3s #info-b4 .ww .p2 {\n  margin-top: 0.625rem;\n  color: #eee;\n}\n.is-mobile .robot3s #info-b4 .ww .p3 {\n  margin-top: 0.46875rem;\n  color: #ddd;\n}\n.is-mobile .robot3s #info-b5 {\n  background-image: url(" + escape(__webpack_require__("9ezh")) + ");\n}\n.is-mobile .robot3s #info-b5 .ww {\n  text-align: center;\n  padding-top: 3.125rem;\n  margin-left: 0rem;\n}\n.is-mobile .robot3s #info-b5 .ww .p0,\n.is-mobile .robot3s #info-b5 .ww .p1 {\n  color: #000;\n}\n.is-mobile .robot3s #info-b5 .ww .p2 {\n  margin-top: 0.8125rem;\n  color: #414141;\n}\n.is-mobile .robot3s #info-b5 .ww .p3 {\n  margin-top: 0.625rem;\n  color: #616161;\n}\n.is-mobile .robot-info .ww .p1 {\n  font-size: 20px;\n  color: #181616;\n}\n.is-mobile .robot-info .ww .p0 {\n  font-size: 12px;\n  color: #414141;\n}\n.is-mobile .robot-info .ww .p2 {\n  font-size: 12px;\n  color: #414141;\n}\n.is-mobile .robot-info .ww .p3 {\n  font-size: 10px;\n  color: #616161;\n}\n.is-mobile .robot-info .ww .p4 {\n  font-size: 7px;\n  color: #616161;\n}\n", ""]);

// exports


/***/ }),

/***/ "VbuQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about-citys.e8cf7fe.jpg";

/***/ }),

/***/ "WAnI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-design-b4.70accf2.jpg";

/***/ }),

/***/ "WTXi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/face-cry.27261b3.gif";

/***/ }),

/***/ "Wkhg":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n* {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: transparent;\n  box-sizing: border-box;\n}\nhtml * {\n  outline: 0;\n}\nhtml,\nbody,\ndiv,\nspan,\nsmall,\np,\nem,\ni,\nb,\nth,\ntd,\ndl,\ndt,\ndd,\nul,\nol,\nli,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nform,\ntextarea,\ninput {\n  padding: 0;\n  margin: 0;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: normal;\n}\na {\n  color: #7d7d7d;\n  text-decoration: none;\n  transition: 0.3s;\n}\na:active,\na:visited {\n  color: currentColor;\n}\na:hover {\n  color: #3ec1bd;\n}\na,\nimg {\n  border: none;\n  touch-callout: none;\n}\nul,\nli,\nol {\n  list-style: none;\n}\ni,\nem {\n  font-style: normal;\n}\ns {\n  text-decoration: none;\n}\ntable {\n  border-spacing: 0;\n  border-collapse: collapse;\n}\ninput:focus,\nselect:focus,\ntextarea:focus,\nselect,\nbutton {\n  margin: 0;\n  outline: none;\n  appearance: none;\n}\ninput,\nbutton {\n  background-image: none;\n}\n.mt5 {\n  margin-top: 5px;\n}\n.mr5 {\n  margin-right: 5px;\n}\n.mb5 {\n  margin-bottom: 5px;\n}\n.ml5 {\n  margin-left: 5px;\n}\n.m5 {\n  margin: 5px;\n}\n.pt5 {\n  padding-top: 5px;\n}\n.pr5 {\n  padding-right: 5px;\n}\n.pb5 {\n  padding-bottom: 5px;\n}\n.pl5 {\n  padding-left: 5px;\n}\n.p5 {\n  padding: 5px;\n}\n.mt10 {\n  margin-top: 10px;\n}\n.mr10 {\n  margin-right: 10px;\n}\n.mb10 {\n  margin-bottom: 10px;\n}\n.ml10 {\n  margin-left: 10px;\n}\n.m10 {\n  margin: 10px;\n}\n.pt10 {\n  padding-top: 10px;\n}\n.pr10 {\n  padding-right: 10px;\n}\n.pb10 {\n  padding-bottom: 10px;\n}\n.pl10 {\n  padding-left: 10px;\n}\n.p10 {\n  padding: 10px;\n}\n.mt15 {\n  margin-top: 15px;\n}\n.mr15 {\n  margin-right: 15px;\n}\n.mb15 {\n  margin-bottom: 15px;\n}\n.ml15 {\n  margin-left: 15px;\n}\n.m15 {\n  margin: 15px;\n}\n.pt15 {\n  padding-top: 15px;\n}\n.pr15 {\n  padding-right: 15px;\n}\n.pb15 {\n  padding-bottom: 15px;\n}\n.pl15 {\n  padding-left: 15px;\n}\n.p15 {\n  padding: 15px;\n}\n.mt20 {\n  margin-top: 20px;\n}\n.mr20 {\n  margin-right: 20px;\n}\n.mb20 {\n  margin-bottom: 20px;\n}\n.ml20 {\n  margin-left: 20px;\n}\n.m20 {\n  margin: 20px;\n}\n.pt20 {\n  padding-top: 20px;\n}\n.pr20 {\n  padding-right: 20px;\n}\n.pb20 {\n  padding-bottom: 20px;\n}\n.pl20 {\n  padding-left: 20px;\n}\n.p20 {\n  padding: 20px;\n}\n.mt25 {\n  margin-top: 25px;\n}\n.mr25 {\n  margin-right: 25px;\n}\n.mb25 {\n  margin-bottom: 25px;\n}\n.ml25 {\n  margin-left: 25px;\n}\n.m25 {\n  margin: 25px;\n}\n.pt25 {\n  padding-top: 25px;\n}\n.pr25 {\n  padding-right: 25px;\n}\n.pb25 {\n  padding-bottom: 25px;\n}\n.pl25 {\n  padding-left: 25px;\n}\n.p25 {\n  padding: 25px;\n}\n.mt30 {\n  margin-top: 30px;\n}\n.mr30 {\n  margin-right: 30px;\n}\n.mb30 {\n  margin-bottom: 30px;\n}\n.ml30 {\n  margin-left: 30px;\n}\n.m30 {\n  margin: 30px;\n}\n.pt30 {\n  padding-top: 30px;\n}\n.pr30 {\n  padding-right: 30px;\n}\n.pb30 {\n  padding-bottom: 30px;\n}\n.pl30 {\n  padding-left: 30px;\n}\n.p30 {\n  padding: 30px;\n}\n.mt35 {\n  margin-top: 35px;\n}\n.mr35 {\n  margin-right: 35px;\n}\n.mb35 {\n  margin-bottom: 35px;\n}\n.ml35 {\n  margin-left: 35px;\n}\n.m35 {\n  margin: 35px;\n}\n.pt35 {\n  padding-top: 35px;\n}\n.pr35 {\n  padding-right: 35px;\n}\n.pb35 {\n  padding-bottom: 35px;\n}\n.pl35 {\n  padding-left: 35px;\n}\n.p35 {\n  padding: 35px;\n}\n.mt40 {\n  margin-top: 40px;\n}\n.mr40 {\n  margin-right: 40px;\n}\n.mb40 {\n  margin-bottom: 40px;\n}\n.ml40 {\n  margin-left: 40px;\n}\n.m40 {\n  margin: 40px;\n}\n.pt40 {\n  padding-top: 40px;\n}\n.pr40 {\n  padding-right: 40px;\n}\n.pb40 {\n  padding-bottom: 40px;\n}\n.pl40 {\n  padding-left: 40px;\n}\n.p40 {\n  padding: 40px;\n}\n.mt45 {\n  margin-top: 45px;\n}\n.mr45 {\n  margin-right: 45px;\n}\n.mb45 {\n  margin-bottom: 45px;\n}\n.ml45 {\n  margin-left: 45px;\n}\n.m45 {\n  margin: 45px;\n}\n.pt45 {\n  padding-top: 45px;\n}\n.pr45 {\n  padding-right: 45px;\n}\n.pb45 {\n  padding-bottom: 45px;\n}\n.pl45 {\n  padding-left: 45px;\n}\n.p45 {\n  padding: 45px;\n}\n.mt50 {\n  margin-top: 50px;\n}\n.mr50 {\n  margin-right: 50px;\n}\n.mb50 {\n  margin-bottom: 50px;\n}\n.ml50 {\n  margin-left: 50px;\n}\n.m50 {\n  margin: 50px;\n}\n.pt50 {\n  padding-top: 50px;\n}\n.pr50 {\n  padding-right: 50px;\n}\n.pb50 {\n  padding-bottom: 50px;\n}\n.pl50 {\n  padding-left: 50px;\n}\n.p50 {\n  padding: 50px;\n}\n#loading {\n  position: fixed;\n  width: 100%;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  z-index: 10000;\n  display: block;\n  background: transparent;\n  transition: all 0.5s;\n}\n#loading.hide {\n  display: none;\n}\n#loading .loading-inner {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  transition: transform 0.5s;\n  margin: auto;\n  width: 100px;\n  height: 100px;\n  border-radius: 10px;\n  color: #fff;\n  text-align: center;\n  background-color: rgba(0,0,0,0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  font-size: 0.75rem;\n}\n#loading .loading-inner i {\n  width: 40px;\n  height: 40px;\n  margin-bottom: 7px;\n  animation: loading 1s steps(12, end) infinite;\n  vertical-align: middle;\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAiIGhlaWdodD0iMTIwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGgxMDB2MTAwSDB6Ii8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjRTlFOUU5IiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTMwKSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iIzk4OTY5NyIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgzMCAxMDUuOTggNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjOUI5OTlBIiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKDYwIDc1Ljk4IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0EzQTFBMiIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA2NSA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNBQkE5QUEiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoMTIwIDU4LjY2IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0IyQjJCMiIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgxNTAgNTQuMDIgNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjQkFCOEI5IiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKDE4MCA1MCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNDMkMwQzEiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTE1MCA0NS45OCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNDQkNCQ0IiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTEyMCA0MS4zNCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNEMkQyRDIiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIDM1IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0RBREFEQSIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgtNjAgMjQuMDIgNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjRTJFMkUyIiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKC0zMCAtNS45OCA2NSkiLz48L3N2Zz4=\");\n  background-size: 100%;\n}\n@-moz-keyframes loading {\n0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n}\n100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n}\n}\n@-webkit-keyframes loading {\n0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n}\n100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n}\n}\n@-o-keyframes loading {\n0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n}\n100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n}\n}\n@keyframes loading {\n0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n}\n100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n}\n}\n.fade-enter-active,\n.fade-leave-active {\n  transition: opacity 0.5s;\n}\n.fade-enter,\n.fade-leave-to {\n  opacity: 0;\n}\n.fadeUp-enter-active,\n.fadeUp-leave-active {\n  transition: all 0.5s;\n}\n.fadeUp-enter,\n.fadeUp-leave-to {\n  opacity: 0;\n  transform: translateY(-100%);\n}\n.fadeUp {\n  opacity: 0;\n  animation: fadeUp 1s forwards;\n}\n.fadeDown {\n  opacity: 0;\n  animation-name: fadeDown;\n  animation-duration: 1s;\n  animation-fill-mode: forwards;\n}\n.zoomIn {\n  transform: scale(1.4);\n  animation-name: zoomIn;\n  animation-duration: 1s;\n  animation-fill-mode: forwards;\n}\n.zoomOut {\n  animation-name: zoomOut;\n  animation-duration: 1s;\n  animation-fill-mode: backwards;\n}\n.info-b5-robot3-animation {\n  animation-name: info-b5-robot3-animation;\n  animation-duration: 3s;\n  animation-fill-mode: forwards;\n}\n.is-mobile .info-b5-robot3-animation {\n  animation-name: info-b5-robot3-animation-mobile;\n}\n.delay1 {\n  animation-delay: 0.3s;\n}\n.delay2 {\n  animation-delay: 0.6s;\n}\n.delay3 {\n  animation-delay: 0.9s;\n}\n.delay4 {\n  animation-delay: 1.2s;\n}\n.delay5 {\n  animation-delay: 1.5s;\n}\n.delay6 {\n  animation-delay: 1.8s;\n}\n.delay7 {\n  animation-delay: 2.1s;\n}\n.delay8 {\n  animation-delay: 2.4s;\n}\n.delay9 {\n  animation-delay: 2.7s;\n}\n.delay10 {\n  animation-delay: 3s;\n}\n.delay11 {\n  animation-delay: 3.3s;\n}\n.delay12 {\n  animation-delay: 3.6s;\n}\n.delay13 {\n  animation-delay: 3.9s;\n}\n.delay14 {\n  animation-delay: 4.2s;\n}\n.delay15 {\n  animation-delay: 4.5s;\n}\n.delay16 {\n  animation-delay: 4.8s;\n}\n.delay17 {\n  animation-delay: 5.1s;\n}\n.delay18 {\n  animation-delay: 5.399999999999999s;\n}\n.delay19 {\n  animation-delay: 5.7s;\n}\n.delay20 {\n  animation-delay: 6s;\n}\n@-moz-keyframes loading {\n0% {\n    opacity: 1;\n    transform: rotate(0);\n}\n90% {\n    opacity: 1;\n    transform: rotate(360deg);\n}\n100% {\n    opacity: 0;\n    transform: rotate(360deg);\n}\n}\n@-webkit-keyframes loading {\n0% {\n    opacity: 1;\n    transform: rotate(0);\n}\n90% {\n    opacity: 1;\n    transform: rotate(360deg);\n}\n100% {\n    opacity: 0;\n    transform: rotate(360deg);\n}\n}\n@-o-keyframes loading {\n0% {\n    opacity: 1;\n    transform: rotate(0);\n}\n90% {\n    opacity: 1;\n    transform: rotate(360deg);\n}\n100% {\n    opacity: 0;\n    transform: rotate(360deg);\n}\n}\n@keyframes loading {\n0% {\n    opacity: 1;\n    transform: rotate(0);\n}\n90% {\n    opacity: 1;\n    transform: rotate(360deg);\n}\n100% {\n    opacity: 0;\n    transform: rotate(360deg);\n}\n}\n@-moz-keyframes map {\n0% {\n    opacity: 0;\n    transform: scale(0.5);\n}\n100% {\n    opacity: 1;\n    transform: scale(1);\n}\n}\n@-webkit-keyframes map {\n0% {\n    opacity: 0;\n    transform: scale(0.5);\n}\n100% {\n    opacity: 1;\n    transform: scale(1);\n}\n}\n@-o-keyframes map {\n0% {\n    opacity: 0;\n    transform: scale(0.5);\n}\n100% {\n    opacity: 1;\n    transform: scale(1);\n}\n}\n@keyframes map {\n0% {\n    opacity: 0;\n    transform: scale(0.5);\n}\n100% {\n    opacity: 1;\n    transform: scale(1);\n}\n}\n@-moz-keyframes info-b5-robot3-animation-mobile {\n0% {\n    opacity: 0;\n    transform: translate(3.125rem, 6.25rem) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(1.5625rem, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(0.9375rem, 0) scale(0.8);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@-webkit-keyframes info-b5-robot3-animation-mobile {\n0% {\n    opacity: 0;\n    transform: translate(3.125rem, 6.25rem) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(1.5625rem, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(0.9375rem, 0) scale(0.8);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@-o-keyframes info-b5-robot3-animation-mobile {\n0% {\n    opacity: 0;\n    transform: translate(3.125rem, 6.25rem) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(1.5625rem, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(0.9375rem, 0) scale(0.8);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@keyframes info-b5-robot3-animation-mobile {\n0% {\n    opacity: 0;\n    transform: translate(3.125rem, 6.25rem) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(1.5625rem, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(0.9375rem, 0) scale(0.8);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@-moz-keyframes info-b5-robot3-animation {\n0% {\n    opacity: 0;\n    transform: translate(800px, 600px) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(800px, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(400px, 0) scale(0.7);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@-webkit-keyframes info-b5-robot3-animation {\n0% {\n    opacity: 0;\n    transform: translate(800px, 600px) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(800px, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(400px, 0) scale(0.7);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@-o-keyframes info-b5-robot3-animation {\n0% {\n    opacity: 0;\n    transform: translate(800px, 600px) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(800px, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(400px, 0) scale(0.7);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@keyframes info-b5-robot3-animation {\n0% {\n    opacity: 0;\n    transform: translate(800px, 600px) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(800px, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(400px, 0) scale(0.7);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@-moz-keyframes fadeUp {\n0% {\n    opacity: 0;\n    transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@-webkit-keyframes fadeUp {\n0% {\n    opacity: 0;\n    transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@-o-keyframes fadeUp {\n0% {\n    opacity: 0;\n    transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@keyframes fadeUp {\n0% {\n    opacity: 0;\n    transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@-moz-keyframes fadeDown {\n0% {\n    opacity: 0;\n    transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@-webkit-keyframes fadeDown {\n0% {\n    opacity: 0;\n    transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@-o-keyframes fadeDown {\n0% {\n    opacity: 0;\n    transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@keyframes fadeDown {\n0% {\n    opacity: 0;\n    transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@-moz-keyframes fadeRight {\n0% {\n    opacity: 0;\n    transform: translateX(100px);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@-webkit-keyframes fadeRight {\n0% {\n    opacity: 0;\n    transform: translateX(100px);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@-o-keyframes fadeRight {\n0% {\n    opacity: 0;\n    transform: translateX(100px);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@keyframes fadeRight {\n0% {\n    opacity: 0;\n    transform: translateX(100px);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@-moz-keyframes zoomIn {\n0% {\n    opacity: 0;\n    transform: scale(1.4);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@-webkit-keyframes zoomIn {\n0% {\n    opacity: 0;\n    transform: scale(1.4);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@-o-keyframes zoomIn {\n0% {\n    opacity: 0;\n    transform: scale(1.4);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@keyframes zoomIn {\n0% {\n    opacity: 0;\n    transform: scale(1.4);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@-moz-keyframes zoomOut {\n0% {\n    opacity: 0;\n    transform: scale(0.8);\n}\n100% {\n    transform: scale(1);\n}\n}\n@-webkit-keyframes zoomOut {\n0% {\n    opacity: 0;\n    transform: scale(0.8);\n}\n100% {\n    transform: scale(1);\n}\n}\n@-o-keyframes zoomOut {\n0% {\n    opacity: 0;\n    transform: scale(0.8);\n}\n100% {\n    transform: scale(1);\n}\n}\n@keyframes zoomOut {\n0% {\n    opacity: 0;\n    transform: scale(0.8);\n}\n100% {\n    transform: scale(1);\n}\n}\n.is-mobile {\n  width: 100%;\n  overflow: hidden;\n}\n.is-mobile .w {\n  width: 100%;\n}\n.is-mobile .cp-robot .tabs {\n  border-top: none;\n  border-bottom: 1px solid #eae9e9;\n  box-shadow: none;\n}\n.is-mobile .cp-robot .tabs a {\n  margin: 0 2.1875rem;\n}\n.is-mobile .robot-spec {\n  padding: 0;\n}\n.is-mobile .robot-spec .row {\n  display: block;\n  text-align: left;\n  padding: 1.25rem 0;\n  margin: 0 1.25rem;\n}\n.is-mobile .robot-spec .row .col1 {\n  width: 100%;\n  text-align: left;\n  padding-bottom: 0.625rem;\n}\n.is-mobile .robot-spec .row .col1 i {\n  display: none;\n}\n.is-mobile .robot-spec .row .params {\n  border: none;\n  padding: 0;\n}\n.is-mobile .robot-spec .row .params .param {\n  line-height: 2.5;\n}\n.is-mobile .robot-spec .row .params .col2 {\n  width: 4.0625rem;\n}\nbody {\n  font-size: 14px;\n  font-family: \"Helvetica Neue\", Helvetica, \"PingFang SC\", \"Hiragino Sans GB\", \"Microsoft YaHei\", \"\\5FAE\\8F6F\\96C5\\9ED1\", Arial, sans-serif;\n  color: #000;\n  background: #fff;\n}\n.w {\n  width: 1200px;\n  margin: 0 auto;\n}\n.ani-card {\n  transition: 1s all;\n}\n.ani-card:hover:hover {\n  box-shadow: 7px 7px 8px #ddd;\n}\n", ""]);

// exports


/***/ }),

/***/ "Wp+A":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "X+eM":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.cp-service {\n  color: #333;\n  font-size: 14px;\n}\n.cp-service h2 {\n  font-size: 30px;\n  text-align: center;\n}\n.cp-service h3 {\n  font-size: 16px;\n  text-align: center;\n}\n.cp-service .banner {\n  width: 100%;\n  height: 240px;\n  background: url(" + escape(__webpack_require__("tbZT")) + ") center;\n  background-size: auto 100%;\n  color: #fff;\n  font-size: 18px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.cp-service .banner .p1 {\n  font-size: 40px;\n}\n.cp-service #after-sale {\n  background-color: #f5f7f9;\n  padding: 65px 0 40px;\n}\n.cp-service #after-sale .info1 {\n  text-align: center;\n  margin: 30px 0;\n}\n.cp-service #after-sale .info1 .item {\n  display: inline-block;\n  background-color: #fff;\n  vertical-align: top;\n  width: 350px;\n  height: 200px;\n}\n.cp-service #after-sale .info1 .item.item2 {\n  margin: 0 30px;\n}\n.cp-service #after-sale .info1 .item h4 {\n  font-size: 18px;\n  padding: 25px 0;\n  margin-bottom: 20px;\n  background: url(" + escape(__webpack_require__("zAZ4")) + ") bottom center no-repeat;\n}\n.cp-service #after-sale .info1 .item p {\n  color: #666;\n}\n.cp-service #after-sale .info1 .item1 p {\n  padding-top: 25px;\n}\n.cp-service #after-sale .info1 .item2 p {\n  text-align: left;\n  padding-left: 90px;\n  line-height: 1.7;\n}\n.cp-service #after-sale .info1 .item3 p {\n  padding: 0 20px;\n  text-align: left;\n}\n.cp-service #after-sale .info2 {\n  background-color: #fff;\n  width: 1110px;\n  margin: 0 auto;\n  padding-bottom: 30px;\n}\n.cp-service #after-sale .info2 h4 {\n  font-size: 18px;\n  padding: 25px 0;\n  margin-bottom: 20px;\n  text-align: center;\n  background: url(" + escape(__webpack_require__("zAZ4")) + ") bottom center no-repeat;\n}\n.cp-service #after-sale .info2 p {\n  padding-left: 290px;\n  color: #666;\n}\n.cp-service #after-sale .tip {\n  text-align: center;\n  margin-top: 40px;\n  color: #999;\n}\n.cp-service #maintenance {\n  padding: 70px 0 45px;\n}\n.cp-service #maintenance .tab-wrap {\n  position: relative;\n}\n.cp-service #maintenance .tab-wrap .tab {\n  width: 510px;\n  height: 150px;\n  transition: 1s all;\n  background-position: 50px center;\n  background-repeat: no-repeat;\n  padding-left: 125px;\n}\n.cp-service #maintenance .tab-wrap .tab.active,\n.cp-service #maintenance .tab-wrap .tab:hover {\n  background-color: #f5f7f9;\n}\n.cp-service #maintenance .tab-wrap .tab.tel {\n  background-image: url(" + escape(__webpack_require__("/Hx1")) + ");\n}\n.cp-service #maintenance .tab-wrap .tab.app {\n  background-image: url(" + escape(__webpack_require__("OUBK")) + ");\n}\n.cp-service #maintenance .tab-wrap .tab.weixin {\n  background-image: url(" + escape(__webpack_require__("V2yK")) + ");\n}\n.cp-service #maintenance .tab-wrap .tab h4 {\n  padding-top: 40px;\n  font-weight: bold;\n  font-size: 18px;\n  margin-bottom: 10px;\n}\n.cp-service #maintenance .tab-wrap .tab p {\n  color: #666;\n}\n.cp-service #maintenance .tab-wrap .img {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 620px;\n  height: 100%;\n  background-position: center;\n  background-repeat: no-repeat;\n  animation: fadeRight 1.3s forwards;\n}\n.cp-service #maintenance .tab-wrap .img.tel {\n  background-image: url(" + escape(__webpack_require__("d2M4")) + ");\n}\n.cp-service #maintenance .tab-wrap .img.app {\n  background-image: url(" + escape(__webpack_require__("21Pe")) + ");\n}\n.cp-service #maintenance .tab-wrap .img.weixin {\n  background-image: url(" + escape(__webpack_require__("ziMH")) + ");\n}\n.cp-service #maintenance .tip {\n  text-align: center;\n  padding-top: 30px;\n  color: #999;\n}\n.cp-service #maintenance .tip b {\n  color: #3bc0bc;\n}\n.cp-service #qa {\n  background-color: #f5f7f9;\n  padding: 65px 0 40px;\n}\n.cp-service #qa .list .item {\n  background-color: #fff;\n  margin-top: 30px;\n  padding: 30px;\n}\n.cp-service #qa .list .item p {\n  margin-bottom: 15px;\n  overflow: hidden;\n}\n.cp-service #qa .list .item p .icon {\n  float: left;\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  text-align: center;\n}\n.cp-service #qa .list .item p .icon.q {\n  background-color: #3bc0bc;\n  color: #fff;\n}\n.cp-service #qa .list .item p .icon.a {\n  background-color: #f5f7f9;\n  color: #3bc0bc;\n}\n.cp-service #qa .list .item p span {\n  float: left;\n  margin-left: 15px;\n  width: 1050px;\n  color: #666;\n  line-height: 30px;\n}\n.cp-service #qa .list .item p span.q {\n  font-size: 18px;\n  color: #333;\n}\n.is-mobile .cp-service .banner {\n  height: 3.125rem;\n  background-image: url(" + escape(__webpack_require__("7EJk")) + ");\n}\n.is-mobile .cp-service .banner .p1 {\n  font-size: 0.9375rem;\n}\n.is-mobile .cp-service .banner .p2 {\n  font-size: 0.625rem;\n}\n.is-mobile .cp-service h2 {\n  background: #fff;\n  font-size: 0.9375rem;\n  padding-top: 0.625rem;\n}\n.is-mobile .cp-service h3 {\n  background: #fff;\n  font-size: 0.625rem;\n  padding-bottom: 0.625rem;\n}\n.is-mobile .cp-service #after-sale {\n  padding: 0;\n}\n.is-mobile .cp-service #after-sale .info1 {\n  margin: 0.625rem auto;\n}\n.is-mobile .cp-service #after-sale .info1 .item {\n  width: 20.9375rem;\n  height: 7.0625rem;\n  margin: 0.3125rem 0;\n}\n.is-mobile .cp-service #after-sale .info1 .item h4 {\n  font-size: 0.75rem;\n  padding: 0.625rem 0 0.3125rem;\n}\n.is-mobile .cp-service #after-sale .info1 .item1 p {\n  padding-top: 0.9375rem;\n}\n.is-mobile .cp-service #after-sale .info1 .item2 p {\n  padding-left: 5rem;\n  font-size: 0.6875rem;\n}\n.is-mobile .cp-service #after-sale .info1 .item3 p {\n  font-size: 0.6875rem;\n}\n.is-mobile .cp-service #after-sale .info2 {\n  width: 20.9375rem;\n  height: 7.0625rem;\n  margin: 0.3125rem auto;\n}\n.is-mobile .cp-service #after-sale .info2 h4 {\n  font-size: 0.75rem;\n  padding: 0.625rem 0 0.3125rem;\n  margin-bottom: 0.625rem;\n}\n.is-mobile .cp-service #after-sale .info2 p {\n  padding: 0 20px;\n  font-size: 0.625rem;\n}\n.is-mobile .cp-service #after-sale .tip {\n  font-size: 0.6875rem;\n  padding: 1.09375rem;\n  margin: 0;\n  text-align: left;\n}\n.is-mobile .cp-service #maintenance {\n  padding: 0;\n}\n.is-mobile .cp-service #maintenance .tip {\n  font-size: 0.6875rem;\n  padding: 3.125rem;\n}\n.is-mobile .cp-service #maintenance .tab-wrap-mobile .tab {\n  position: relative;\n  margin: 0 auto;\n  width: 20.625rem;\n  height: 4.6875rem;\n  background: #f5f7f9;\n  transition: 1s all;\n  background-position: 3.125rem center;\n  background-repeat: no-repeat;\n  padding: 1.125rem 2.1875rem 0 5rem;\n  background-size: auto 1.25rem;\n}\n.is-mobile .cp-service #maintenance .tab-wrap-mobile .tab.tel {\n  background-image: url(" + escape(__webpack_require__("/Hx1")) + ");\n}\n.is-mobile .cp-service #maintenance .tab-wrap-mobile .tab.app {\n  background-image: url(" + escape(__webpack_require__("OUBK")) + ");\n}\n.is-mobile .cp-service #maintenance .tab-wrap-mobile .tab.weixin {\n  background-image: url(" + escape(__webpack_require__("V2yK")) + ");\n}\n.is-mobile .cp-service #maintenance .tab-wrap-mobile .tab p {\n  font-size: 0.6875rem;\n}\n.is-mobile .cp-service #maintenance .tab-wrap-mobile .tab .btn-prev,\n.is-mobile .cp-service #maintenance .tab-wrap-mobile .tab .btn-next {\n  position: absolute;\n  top: 0;\n  width: 2.375rem;\n  height: 4.6875rem;\n  line-height: 4.6875rem;\n  background: #ebeff3;\n  text-align: center;\n}\n.is-mobile .cp-service #maintenance .tab-wrap-mobile .tab .btn-prev {\n  left: 0;\n}\n.is-mobile .cp-service #maintenance .tab-wrap-mobile .tab .btn-next {\n  right: 0;\n}\n.is-mobile .cp-service #maintenance .tab-wrap-mobile .img {\n  width: 100%;\n  height: 28.125rem;\n  background-position: center;\n  background-repeat: no-repeat;\n  animation: fadeDown 1.3s forwards;\n}\n.is-mobile .cp-service #maintenance .tab-wrap-mobile .img.tel {\n  background-image: url(" + escape(__webpack_require__("d2M4")) + ");\n}\n.is-mobile .cp-service #maintenance .tab-wrap-mobile .img.app {\n  background-image: url(" + escape(__webpack_require__("21Pe")) + ");\n}\n.is-mobile .cp-service #maintenance .tab-wrap-mobile .img.weixin {\n  background-image: url(" + escape(__webpack_require__("ziMH")) + ");\n}\n.is-mobile .cp-service #qa {\n  padding: 0;\n}\n.is-mobile .cp-service #qa .list .item {\n  margin: 0.9375rem;\n  padding: 0.9375rem;\n}\n.is-mobile .cp-service #qa .list .item p {\n  margin-bottom: 0.625rem;\n}\n.is-mobile .cp-service #qa .list .item p .icon {\n  width: 1.09375rem;\n  height: 1.09375rem;\n  line-height: 1.09375rem;\n  font-size: 0.6875rem;\n}\n.is-mobile .cp-service #qa .list .item p span {\n  line-height: 1.09375rem;\n  width: 16.875rem;\n  margin-left: 0.625rem;\n  font-size: 0.6875rem;\n}\n.is-mobile .cp-service #qa .list .item p span.q {\n  font-size: 0.9375rem;\n}\n", ""]);

// exports


/***/ }),

/***/ "XJFa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-img5.8e8a861.png";

/***/ }),

/***/ "XLau":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("X+eM");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("6a1af3d4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c0f8379e\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./service.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c0f8379e\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./service.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "XYsi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-info-b7.03d89f7.jpg";

/***/ }),

/***/ "XZo4":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.robot-info .w {\n  position: relative;\n}\n.robot-info .w .p1 {\n  font-size: 40px;\n  color: #333;\n}\n.robot-info .w .p2 {\n  font-size: 16px;\n  color: #666;\n}\n.robot-info .w .p3 {\n  font-size: 14px;\n  color: #999;\n}\n.robot-info.robot2s #info-b1 {\n  min-width: 1200px;\n  height: 748px;\n  background: url(" + escape(__webpack_require__("l7lX")) + ") no-repeat center;\n  background-size: auto 100%;\n}\n.robot-info.robot2s #info-b1 .w {\n  padding: 200px 0 0 600px;\n}\n.robot-info.robot2s #info-b1 .p2 {\n  font-size: 24px;\n}\n.robot-info.robot2s #info-b1 .p3 {\n  margin-top: 70px;\n}\n.robot-info.robot2s #info-b2 {\n  min-width: 1200px;\n  background: #f5f7f9;\n}\n.robot-info.robot2s #info-b2 .w {\n  text-align: center;\n  padding: 70px 0;\n}\n.robot-info.robot2s #info-b2 .list {\n  margin-top: 80px;\n}\n.robot-info.robot2s #info-b2 .list .item {\n  display: inline-block;\n  margin: 0 20px 40px;\n}\n.robot-info.robot2s #info-b2 .list .item h3 {\n  font-size: 18px;\n  width: 260px;\n  height: 52px;\n  line-height: 52px;\n  border-radius: 30px 30px 5px;\n  background: #3bc0bc;\n  color: #fff;\n  margin-bottom: 15px;\n}\n.robot-info.robot2s #info-b2 .list .item p {\n  color: #999;\n}\n.robot-info.robot2s #info-b3 {\n  min-width: 1200px;\n  height: 800px;\n  background: url(" + escape(__webpack_require__("I3h8")) + ") no-repeat center;\n  background-size: auto 100%;\n}\n.robot-info.robot2s #info-b3 .w {\n  padding: 100px 0 0 10px;\n}\n.robot-info.robot2s #info-b4 {\n  min-width: 1200px;\n  height: 800px;\n  background: url(" + escape(__webpack_require__("usSO")) + ") no-repeat center;\n  background-size: auto 100%;\n}\n.robot-info.robot2s #info-b4 .w {\n  text-align: center;\n  padding-top: 100px;\n}\n.robot-info.robot2s #info-b4 .p2 {\n  line-height: 1.8;\n  margin-bottom: 90px;\n}\n.robot-info.robot2s #info-b5 {\n  min-width: 1200px;\n  height: 800px;\n  background: url(" + escape(__webpack_require__("i+C4")) + ") no-repeat center;\n  background-size: auto 100%;\n  overflow: hidden;\n}\n.robot-info.robot2s #info-b5 .w {\n  text-align: center;\n  padding-top: 150px;\n}\n.robot-info.robot2s #info-b6 {\n  min-width: 1200px;\n  height: 800px;\n  background: url(" + escape(__webpack_require__("Quej")) + ") no-repeat center;\n  background-size: auto 100%;\n}\n.robot-info.robot2s #info-b6 .w {\n  position: relative;\n  padding: 650px 0 0 880px;\n}\n.robot-info.robot2s #info-b6 .msg {\n  position: absolute;\n  top: 600px;\n  left: 80px;\n  text-align: center;\n  font-size: 16px;\n  width: 260px;\n  height: 52px;\n  line-height: 52px;\n  border-radius: 30px 30px 5px;\n  margin-bottom: 15px;\n  background: #fff;\n  color: #333;\n}\n.robot-info.robot2s #info-b6 .msg.blue {\n  top: 270px;\n  left: 160px;\n  color: #fff;\n  background: #3bc0bc;\n}\n.robot-info.robot2s #info-b6 .msg2 {\n  position: absolute;\n  top: 600px;\n  left: 80px;\n  text-align: center;\n  font-size: 16px;\n  width: 260px;\n  height: 52px;\n  line-height: 52px;\n  border-radius: 30px 30px 30px 5px;\n  margin-bottom: 15px;\n  background: #fff;\n  color: #333;\n}\n.robot-info.robot2s #info-b7 {\n  min-width: 1200px;\n  height: 800px;\n  background: url(" + escape(__webpack_require__("Z8Yx")) + ") no-repeat center;\n  background-size: auto 100%;\n}\n.robot-info.robot2s #info-b7 .w {\n  text-align: center;\n  padding-top: 100px;\n}\n.robot-info.robot2s #info-b7 .p2 {\n  line-height: 1.2;\n  margin-bottom: 90px;\n}\n.is-mobile .robot2s #info-b1,\n.is-mobile .robot2s #info-b2,\n.is-mobile .robot2s #info-b3,\n.is-mobile .robot2s #info-b4,\n.is-mobile .robot2s #info-b5,\n.is-mobile .robot2s #info-b6,\n.is-mobile .robot2s #info-b7 {\n  width: 100%;\n  min-width: inherit;\n  height: 34.375rem;\n}\n.is-mobile .robot2s #info-b1 {\n  background-image: url(" + escape(__webpack_require__("3hqC")) + ");\n}\n.is-mobile .robot2s #info-b1 .w {\n  padding: 1.5625rem 0 0 0;\n  text-align: center;\n}\n.is-mobile .robot2s #info-b1 .w .p2 {\n  font-size: 0.75rem;\n}\n.is-mobile .robot2s #info-b1 .w .p3 {\n  font-size: 0.8125rem;\n  margin-top: 1.875rem;\n}\n.is-mobile .robot2s #info-b1 .w .p3 img {\n  width: 80%;\n}\n.is-mobile .robot2s #info-b2 .w {\n  padding: 2.1875rem 0;\n}\n.is-mobile .robot2s #info-b2 .w .list {\n  margin-top: 1.875rem;\n}\n.is-mobile .robot2s #info-b2 .w .list .item {\n  display: block;\n  overflow: hidden;\n  margin: 0 auto 1.8125rem;\n}\n.is-mobile .robot2s #info-b2 .w .list .item h3 {\n  float: right;\n  height: 1.75rem;\n  line-height: 1.75rem;\n  font-size: 0.875rem;\n  width: 12.5rem;\n  margin-right: 3.125rem;\n  margin-bottom: 0;\n}\n.is-mobile .robot2s #info-b2 .w .list .item p {\n  float: left;\n  width: 6.25rem;\n  height: 1.75rem;\n  line-height: 1.75rem;\n  text-align: right;\n}\n.is-mobile .robot2s #info-b3 {\n  background-image: url(" + escape(__webpack_require__("tN3s")) + ");\n}\n.is-mobile .robot2s #info-b3 .w {\n  padding: 3.125rem 0 0 2.8125rem;\n}\n.is-mobile .robot2s #info-b4 {\n  background-image: url(" + escape(__webpack_require__("rO48")) + ");\n}\n.is-mobile .robot2s #info-b4 .w {\n  padding-top: 3.125rem;\n}\n.is-mobile .robot2s #info-b4 .w .p2 {\n  margin-bottom: 2.8125rem;\n  padding: 0 1.875rem;\n}\n.is-mobile .robot2s #info-b4 .w .p3 img {\n  width: 80%;\n}\n.is-mobile .robot2s #info-b5 {\n  background-image: url(" + escape(__webpack_require__("gr/A")) + ");\n}\n.is-mobile .robot2s #info-b5 .w {\n  padding-top: 1.25rem;\n}\n.is-mobile .robot2s #info-b5 .w .p1,\n.is-mobile .robot2s #info-b5 .w .p2,\n.is-mobile .robot2s #info-b5 .w .p3 {\n  color: #fff;\n}\n.is-mobile .robot2s #info-b5 .w img {\n  width: 70%;\n  margin-top: 7.8125rem;\n}\n.is-mobile .robot2s #info-b6 {\n  background-image: url(" + escape(__webpack_require__("Uyve")) + ");\n}\n.is-mobile .robot2s #info-b6 .w {\n  padding: 28.125rem 0 0 1.25rem;\n}\n.is-mobile .robot2s #info-b6 .msg {\n  width: 12.5rem;\n  height: 1.875rem;\n  line-height: 1.875rem;\n  font-size: 0.75rem;\n  top: 21.5625rem;\n  left: 3.4375rem;\n}\n.is-mobile .robot2s #info-b6 .msg.blue {\n  top: 15.625rem;\n  left: 5rem;\n}\n.is-mobile .robot2s #info-b6 .msg2 {\n  width: 12.5rem;\n  height: 1.875rem;\n  line-height: 1.875rem;\n  font-size: 0.75rem;\n  top: 21.5625rem;\n  left: 3.4375rem;\n}\n.is-mobile .robot2s #info-b6 .msg2.blue {\n  top: 3rem;\n  left: 5rem;\n}\n.is-mobile .robot2s #info-b7 {\n  background-image: url(" + escape(__webpack_require__("Jhnl")) + ");\n}\n.is-mobile .robot2s #info-b7 .w {\n  padding-top: 3.125rem;\n}\n.is-mobile .robot-info .w .p1 {\n  font-size: 1.4375rem;\n}\n.is-mobile .robot-info .w .p2 {\n  font-size: 0.75rem;\n}\n", ""]);

// exports


/***/ }),

/***/ "Xz3Y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-design-b4.262db89.jpg";

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_home_vue__ = __webpack_require__("26dS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_robot_spec_vue__ = __webpack_require__("q0bZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_robot_2s_index_vue__ = __webpack_require__("ok8V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_robot_2s_info_vue__ = __webpack_require__("kGqw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_robot_2s_design_vue__ = __webpack_require__("kaV8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_robot_3_index_vue__ = __webpack_require__("MLnh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_robot_3_info_vue__ = __webpack_require__("BFZJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_robot_3_design_vue__ = __webpack_require__("SXkU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_robot_3s_index_vue__ = __webpack_require__("3FFM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_robot_3s_info_vue__ = __webpack_require__("FJd1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_robot_3s_design_vue__ = __webpack_require__("+j1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_about_vue__ = __webpack_require__("FBzZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_news_vue__ = __webpack_require__("uxuc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_service_vue__ = __webpack_require__("9Lro");
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition;
  } else {
    var position = {};
    // new navigation.
    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash;
    }
    // check if any matched route config has meta that requires scrolling to top
    if (to.matched.some(function (m) {
      return m.meta.scrollToTop;
    })) {
      // cords will be used if no selector is provided,
      // or if the selector didn't match any element.
      position.x = 0;
      position.y = 0;
    }
    // if the returned position is falsy or an empty object,
    // will retain current scroll position.
    return position;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  scrollBehavior: scrollBehavior,
  routes: [{
    path: '/home',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__views_home_vue__["a" /* default */],
    meta: { scrollToTop: true }
  }, {
    path: '/robot2s',
    component: __WEBPACK_IMPORTED_MODULE_4__views_robot_2s_index_vue__["a" /* default */],
    meta: { scrollToTop: true },
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_5__views_robot_2s_info_vue__["a" /* default */]
    }, {
      path: 'info',
      component: __WEBPACK_IMPORTED_MODULE_5__views_robot_2s_info_vue__["a" /* default */]
    }, {
      path: 'design',
      component: __WEBPACK_IMPORTED_MODULE_6__views_robot_2s_design_vue__["a" /* default */]
    }, {
      path: 'spec',
      component: __WEBPACK_IMPORTED_MODULE_3__views_robot_spec_vue__["a" /* default */]
    }]
  }, {
    path: '/robot3',
    component: __WEBPACK_IMPORTED_MODULE_7__views_robot_3_index_vue__["a" /* default */],
    meta: { scrollToTop: true },
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_8__views_robot_3_info_vue__["a" /* default */]
    }, {
      path: 'info',
      component: __WEBPACK_IMPORTED_MODULE_8__views_robot_3_info_vue__["a" /* default */]
    }, {
      path: 'design',
      component: __WEBPACK_IMPORTED_MODULE_9__views_robot_3_design_vue__["a" /* default */]
    }, {
      path: 'spec',
      component: __WEBPACK_IMPORTED_MODULE_3__views_robot_spec_vue__["a" /* default */]
    }]
  }, {
    path: '/robot3s',
    component: __WEBPACK_IMPORTED_MODULE_10__views_robot_3s_index_vue__["a" /* default */],
    meta: { scrollToTop: true },
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_11__views_robot_3s_info_vue__["a" /* default */]
    }, {
      path: 'info',
      component: __WEBPACK_IMPORTED_MODULE_11__views_robot_3s_info_vue__["a" /* default */]
    }, {
      path: 'design',
      component: __WEBPACK_IMPORTED_MODULE_12__views_robot_3s_design_vue__["a" /* default */]
    }, {
      path: 'spec',
      component: __WEBPACK_IMPORTED_MODULE_3__views_robot_spec_vue__["a" /* default */]
    }]
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_13__views_about_vue__["a" /* default */]
  }, {
    path: '/news',
    name: 'news',
    component: __WEBPACK_IMPORTED_MODULE_14__views_news_vue__["a" /* default */],
    meta: { scrollToTop: true }
  }, {
    path: '/service',
    name: 'service',
    component: __WEBPACK_IMPORTED_MODULE_15__views_service_vue__["a" /* default */]
  }, {
    path: '/robot2s',
    redirect: '/robot2s/info'
  }, {
    path: '/robot3',
    redirect: '/robot3/info'
  }, {
    path: '*',
    redirect: '/home'
  }]
}));

/***/ }),

/***/ "Z3A+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cp-about" }, [
    _vm._m(0),
    _c("div", { staticClass: "w", attrs: { id: "company-profile" } }, [
      _c("h2", [_vm._v("公司简介")]),
      _c("h3", [_vm._v("Company profile")]),
      _c("h4", [_vm._v("智能服务机器人研发及产业化领先企业")]),
      _c("p", [
        _vm._v(
          "弗徕威智能机器人科技（上海）有限公司是国内率先参与制订服务机器人企业标准、并获得首批认证的企业。2012年8月注册于上海浦东，是国家高新技术企业、科技部创新基金支持单位、国家战略新兴产业标准化试点单位、科技部《养老服务课题》承接单位、国家知识产权局“专利试点单位”、上海市“专精特新”企业、浦东新区科委重点科技创业企业以及国家三部委（工信部、民政部、卫健委）授予智慧健康养老应用试点示范企业。作为主要参编单位、企业参与了4个机器人国家标准和4个行业标准制定。"
        )
      ]),
      _c("p", [
        _vm._v(
          "企业专注于服务机器人领域深耕十年，是全球领先的以智能机器人为核心技术的智慧社区解决方案供应商，拥有完整自主知识产权体系且可自主生产服务机器人。企业是国内最早实现机器人量产、且一次性交付量最大的服务机器人之一，技术实现力和产品稳定性已获市场验证。团队核心成员主要来自机器人领域具有国际和国内影响力的专家，已授权核心发明专利数量行业领先。企业已形成机器人智慧社区、智慧康养、智能清洁等多场景解决方案，且在多个地产项目和康养机构示范应用落地。科技赋能，共创美好生活。"
        )
      ]),
      _vm.isMobile
        ? _c("img", {
            staticClass: "img",
            attrs: { src: __webpack_require__("VbuQ") }
          })
        : _c("img", {
            staticClass: "img",
            attrs: { src: __webpack_require__("aa0x") }
          })
    ]),
    _vm._m(1),
    _vm._m(2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner" }, [
      _c("p", { staticClass: "p1" }, [_vm._v("关爱触手可及")]),
      _c("p", { staticClass: "p2" }, [_vm._v("CARE YOU CAN TOUCH")]),
      _c("p", { staticClass: "p3" }, [
        _vm._v("让机器人进入千家万户，成为服务机器人行业的领先企业")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w", attrs: { id: "application-area" } }, [
      _c("h2", [_vm._v("应用领域")]),
      _c("h3", [_vm._v("Application Area")]),
      _c("ul", { staticClass: "list" }, [
        _c("li", [
          _c("img", {
            attrs: { src: __webpack_require__("BAqv") }
          }),
          _c("div", { staticClass: "title" }, [_vm._v("智慧社区")]),
          _c("p", [
            _vm._v(" 提供以机器人为核心的"),
            _c("br"),
            _vm._v("整套智慧住宅解决方案")
          ])
        ]),
        _c("li", [
          _c("img", {
            attrs: { src: __webpack_require__("+GEd") }
          }),
          _c("div", { staticClass: "title" }, [_vm._v("智慧康养")]),
          _c("p", [
            _vm._v("提供专业的长者居家照护和陪伴服务机器人"),
            _c("br"),
            _vm._v("打造机器人智慧康养社区")
          ])
        ]),
        _c("li", [
          _c("img", {
            attrs: { src: __webpack_require__("FYrh") }
          }),
          _c("div", { staticClass: "title" }, [_vm._v("智慧清洁")]),
          _c("p", [
            _vm._v("提供公共空间无人驾驶智能清洁、"),
            _c("br"),
            _vm._v("消杀毒服务机器人解决方案")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "contact-us" } }, [
      _c("div", { staticClass: "w" }, [
        _c("h2", [_vm._v("联系我们")]),
        _c("h3", [_vm._v("Contact us")]),
        _c("div", { staticClass: "info1" }, [
          _c("div", { staticClass: "left" }, [
            _c("h4", [_vm._v("联系方式")]),
            _c("p", [_vm._v("地址：上海·长宁·威宁路369号缤谷大厦10楼1001室")]),
            _c("p", [_vm._v("地址：上海·浦东·芳春路400号1幢3层")]),
            _c("p", [_vm._v("总机：193 0215 5869")]),
            _c("p", [_vm._v("邮箱：marketing@flyingwings.cn")])
          ])
        ]),
        _c("div", { staticClass: "info2" }, [
          _c("div", { staticClass: "item" }, [
            _c("h4", [_vm._v("业务合作")]),
            _c("p", [_vm._v("电话：193 0215 5869")])
          ]),
          _c("div", { staticClass: "item" }, [
            _c("h4", [_vm._v("供应商合作")]),
            _c("p", [_vm._v("电话：193 0215 5869")])
          ]),
          _c("div", { staticClass: "item" }, [
            _c("h4", [_vm._v("售后服务")]),
            _c("p", [_vm._v("电话：193 0215 5869")])
          ]),
          _c("div", { staticClass: "item" }, [
            _c("h4", [_vm._v("媒体合作")]),
            _c("p", [
              _vm._v("邮箱："),
              _c("a", { attrs: { href: "mailto:jj.li@flyingwings.cn" } }, [
                _vm._v("marketing@flyingwings.cn")
              ])
            ])
          ]),
          _c("div", { staticClass: "item" }, [
            _c("h4", [_vm._v("产品反馈")]),
            _c("p", [
              _vm._v("邮箱："),
              _c("a", { attrs: { href: "mailto:feedback@flyingwing.cn" } }, [
                _vm._v("feedback@flyingwing.cn")
              ])
            ])
          ]),
          _c("div", { staticClass: "item" }, [
            _c("h4", [_vm._v("加入我们")]),
            _c("p", [
              _vm._v("邮箱："),
              _c("a", { attrs: { href: "mailto:hr@flyingwings.cn" } }, [
                _vm._v("hr@flyingwings.cn")
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23b71e09", esExports)
  }
}

/***/ }),

/***/ "Z8Yx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-info-b7.ba2a071.jpg";

/***/ }),

/***/ "ZA49":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-info-b8.73fd071.jpg";

/***/ }),

/***/ "ZPyE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "robot-spec w" },
    _vm._l(_vm.list, function(item) {
      return _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col1" }, [
          item.icon ? _c("i", { class: [item.icon] }) : _vm._e(),
          _c("p", [_vm._v(_vm._s(item.title))])
        ]),
        _c(
          "div",
          { staticClass: "params" },
          _vm._l(item.params, function(item2) {
            return _c(
              "div",
              { staticClass: "param" },
              [
                _c("div", { staticClass: "col2" }, [_vm._v(_vm._s(item2[0]))]),
                typeof item2[1] === "string"
                  ? [
                      _c("div", { staticClass: "col3" }, [
                        _vm._v(_vm._s(item2[1]))
                      ])
                    ]
                  : [
                      _c(
                        "div",
                        { staticClass: "col3" },
                        _vm._l(item2[1], function(item3) {
                          return _c("p", [_vm._v(_vm._s(item3))])
                        })
                      )
                    ]
              ],
              2
            )
          })
        )
      ])
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c1a6e21", esExports)
  }
}

/***/ }),

/***/ "ZfXq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cp-home" },
    [
      _vm._m(0),
      _c("div", { staticClass: "list-links" }, [
        _vm._m(1),
        _vm._m(2),
        _c(
          "a",
          {
            staticClass: "link3 ani-card",
            on: {
              click: function($event) {
                _vm.showVideo = 1
              }
            }
          },
          [_c("b", [_vm._v("了解维拉")])]
        )
      ]),
      _c("div", { staticClass: "partners" }, [
        _c("div", { staticClass: "pp" }, [_vm._v("合作伙伴")]),
        _c("div", { staticClass: "logo-list" }, [
          _c(
            "ul",
            { staticClass: "ul1" },
            [
              _vm._l(_vm.partners1, function(n) {
                return _c("li", {
                  style: {
                    backgroundImage: "url(static/images/partners/" + n + ".png)"
                  }
                })
              }),
              _vm._l(_vm.partners1, function(n) {
                return _c("li", {
                  style: {
                    backgroundImage: "url(static/images/partners/" + n + ".png)"
                  }
                })
              })
            ],
            2
          ),
          _c(
            "ul",
            { staticClass: "ul2", staticStyle: { "margin-left": "-50px" } },
            [
              _vm._l(_vm.partners2, function(n) {
                return _c("li", {
                  style: {
                    backgroundImage: "url(static/images/partners/" + n + ".png)"
                  }
                })
              }),
              _vm._l(_vm.partners2, function(n) {
                return _c("li", {
                  style: {
                    backgroundImage: "url(static/images/partners/" + n + ".png)"
                  }
                })
              })
            ],
            2
          )
        ])
      ]),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showVideo,
                expression: "showVideo"
              }
            ],
            staticClass: "video-wrap"
          },
          [
            _c("div", { staticClass: "mask", on: { click: _vm.closeVideo } }),
            _c(
              "div",
              { staticClass: "btn-close", on: { click: _vm.closeVideo } },
              [_vm._v("+")]
            ),
            _vm.showVideo
              ? _c("iframe", {
                  attrs: {
                    frameborder: "0",
                    allowfullscreen: "allowfullscreen",
                    src: "https://v.qq.com/iframe/player.html?vid=r0538txqcoz"
                  }
                })
              : _vm._e()
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner" }, [
      _c("div", { attrs: { id: "iSlider-wrapper" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "link1 ani-card",
        attrs: { href: "/#/news", target: "_black" }
      },
      [_c("b", [_vm._v("新闻动态")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "link2 ani-card",
        attrs: { href: "/#/robot3/design", target: "_black" }
      },
      [_c("b", [_vm._v("颜值至上")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a4bed13", esExports)
  }
}

/***/ }),

/***/ "ZiJz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-img7.b9a0189.png";

/***/ }),

/***/ "ZtUs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-design-b4.7b5233b.jpg";

/***/ }),

/***/ "a0sQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/map.6b5464c.jpg";

/***/ }),

/***/ "aV1F":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/link1.f00e2ac.png";

/***/ }),

/***/ "aa0x":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about-citys.ca09e10.jpg";

/***/ }),

/***/ "b64E":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-design-b1.9275921.jpg";

/***/ }),

/***/ "bVsh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_utils__ = __webpack_require__("JaHG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      robot3Show: DB.robot3Show,
      isB1Visible: true,
      isB2Visible: false,
      isB3Visible: false,
      isB4Visible: false,
      isB5Visible: false,
      isB6Visible: false,
      isB7Visible: false,
      isB8Visible: false
    };
  },

  computed: {},
  methods: {},
  created: function created() {
    var _this = this;

    $(window).on('scroll', function () {
      _this.isB1Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b1');
      _this.isB2Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b2');
      _this.isB3Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b3');
      _this.isB4Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b4');
      _this.isB5Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b5');
      _this.isB6Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b6');
      _this.isB7Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b7');
      _this.isB8Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b8');
    });
  }
});

/***/ }),

/***/ "bp4M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cp-service" }, [
    _vm._m(0),
    _vm._m(1),
    _c("div", { attrs: { id: "maintenance" } }, [
      _c("div", { staticClass: "w" }, [
        _c("h2", [_vm._v("报修方式")]),
        _c("h3", [_vm._v("Maintenance")]),
        _vm.isMobile
          ? _c(
              "div",
              { staticClass: "tab-wrap-mobile" },
              [
                _c(
                  "div",
                  { staticClass: "tab", class: [_vm.currentMobileTab.name] },
                  [
                    _c("h4", [_vm._v(_vm._s(_vm.currentMobileTab.title))]),
                    _c("p", {
                      domProps: { innerHTML: _vm._s(_vm.currentMobileTab.info) }
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mobileTabIndex > 0,
                            expression: "mobileTabIndex > 0"
                          }
                        ],
                        staticClass: "btn-prev",
                        on: { click: _vm.prevTab }
                      },
                      [_vm._v("<")]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mobileTabIndex < _vm.typeList.length - 1,
                            expression: "mobileTabIndex < (typeList.length-1)"
                          }
                        ],
                        staticClass: "btn-next",
                        on: { click: _vm.nextTab }
                      },
                      [_vm._v(">")]
                    )
                  ]
                ),
                _vm._l(_vm.typeList, function(item, index) {
                  return _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: index === _vm.mobileTabIndex,
                        expression: "index === mobileTabIndex"
                      }
                    ],
                    staticClass: "img",
                    class: [item.name]
                  })
                })
              ],
              2
            )
          : _c(
              "div",
              { staticClass: "tab-wrap" },
              _vm._l(_vm.typeList, function(item) {
                return _c(
                  "div",
                  {
                    staticClass: "tab",
                    class: [{ active: _vm.tab === item.name }, item.name],
                    on: {
                      mouseover: function($event) {
                        _vm.setTab(item.name)
                      }
                    }
                  },
                  [
                    _c("h4", [_vm._v(_vm._s(item.title))]),
                    _c("p", { domProps: { innerHTML: _vm._s(item.info) } }),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.name === _vm.tab,
                          expression: "item.name === tab"
                        }
                      ],
                      staticClass: "img",
                      class: [item.name]
                    })
                  ]
                )
              })
            ),
        _vm._m(2)
      ])
    ]),
    _c("div", { attrs: { id: "qa" } }, [
      _c("div", { staticClass: "w" }, [
        _c("h2", [_vm._v("服务问答")]),
        _c("h3", [_vm._v("Questions & Answers")]),
        _c(
          "div",
          { staticClass: "list" },
          _vm._l(_vm.qaList, function(item) {
            return _c("div", { staticClass: "item ani-card" }, [
              _c("p", [
                _c("i", { staticClass: "icon q" }, [_vm._v("Q")]),
                _c("span", { staticClass: "q" }, [
                  _vm._v(_vm._s(item.question))
                ])
              ]),
              _c("p", [
                _c("i", { staticClass: "icon a" }, [_vm._v("A")]),
                _c("span", [_vm._v(_vm._s(item.answer))])
              ])
            ])
          })
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner" }, [
      _c("p", { staticClass: "p1" }, [_vm._v("服务")]),
      _c("p", { staticClass: "p2" }, [_vm._v("SERVICE")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "after-sale" } }, [
      _c("div", { staticClass: "w" }, [
        _c("h2", [_vm._v("售后服务")]),
        _c("h3", [_vm._v("After-sale Service")]),
        _c("div", { staticClass: "info1" }, [
          _c("div", { staticClass: "item item1 ani-card" }, [
            _c("h4", [_vm._v("适用产品")]),
            _c("p", [_vm._v("弗徕威智能服务机器人产品")])
          ]),
          _c("div", { staticClass: "item item2 ani-card" }, [
            _c("h4", [_vm._v("保修期限")]),
            _c("p", [_c("b", [_vm._v("整机：")]), _c("span", [_vm._v("1年")])]),
            _c("p", [
              _c("b", [_vm._v("主要部件（如电机）：")]),
              _c("span", [_vm._v("1年")])
            ]),
            _c("p", [
              _c("b", [_vm._v("配套智能设备及电池：")]),
              _c("span", [_vm._v("6个月")])
            ])
          ]),
          _c("div", { staticClass: "item item3 ani-card" }, [
            _c("h4", [_vm._v("维修方式")]),
            _c("p", [
              _vm._v(
                "通过正规快递寄回弗徕威售后服务中心维修，维修完毕后会联系您寄出，产品包装箱请妥善保管，以便产品维修时使用"
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "info2 ani-card" }, [
          _c("h4", [_vm._v("维修费用")]),
          _c("p", [
            _vm._v("保修期内：非使用不当原因造成的产品损坏，弗徕威负责免费维修")
          ]),
          _c("p", [
            _vm._v(
              "保修期外：由消费者付费维修，弗徕威会根据损坏状况收取一定维修费用（含快递费用）"
            )
          ])
        ]),
        _c("div", { staticClass: "tip" }, [
          _vm._v(
            "以上政策适用于消费者在中国大陆所购买的弗徕威产品，并遵循中国相关的“三包”规定"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tip" }, [
      _vm._v("服务时间为"),
      _c("b", [_vm._v("周一至周五9:00-18:00")]),
      _vm._v("，法定节假日休息。"),
      _c("br"),
      _vm._v(
        "报修时明确告知您所使用的产品型号、产品序列号、详细的故障现象等，以便快捷为您服务。"
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c0f8379e", esExports)
  }
}

/***/ }),

/***/ "c1sd":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAWCAMAAADgvdz9AAAAflBMVEVMaXEyMjIxMTEyMjIyMjIyMjIyMjIzMzMyMjIyMjI0NDQzMzMyMjIxMTEyMjIyMjIyMjIzMzMyMjIzMzMzMzMzMzMzMzMyMjIzMzMyMjIyMjIyMjIzMzMzMzMyMjIyMjIzMzMyMjIzMzMyMjItLS06OjozMzMyMjIzMzMzMzPADsY1AAAAKXRSTlMA1S4G2U8f/QKrGFS9JcE5pjL0+ipaCoFKsPhBic6ZxrLsZZ4RDd9vcUIKeq4AAAEbSURBVHjadZLJjoMwEAULAthJWBPIvu/v/39waIFERsy8gw8uq9rdNsAmXTHKKt2AJVloPcZrLRIsqaLnGD8jpZhaKqBZ/TI3UEimz1XCXulkoJNUeyiVQyJV+NbkB+zPCjyVlPBWAHO5DKhPx+OpBjKnOQR6M9UBLlaAZqk2ywYTT+HQLoFi/MIOh0aN16a7emIF7BQyk2ZwV58T3U6oHVY/lPNWqs8RvFNIIv2FAwzXhr/kpfrcv+SR5vhru1C5jrqwv9pckTXW98HNyegNmKrsGvsogrgbS1VGUVl1Y4kh0odMKvCBzqOhFlIGubZQuMv3k1xcAVvlmFh7iI0OPIa9rADkej0Y5fFSjiX77zNlgOm3g3nwb039A/ZPIiaPSzEWAAAAAElFTkSuQmCC"

/***/ }),

/***/ "cX4e":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qr-app.91270fc.png";

/***/ }),

/***/ "cmYL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-design-b2.b1c095f.jpg";

/***/ }),

/***/ "d2M4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "d3Mp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "robot-design robot3" }, [
    _c("div", { staticClass: "banner", attrs: { id: "design-b1" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1" }, [
          _c("b", { class: { fadeUp: _vm.isB1Visible } }, [_vm._v("独具创新")]),
          _c("span", { class: { fadeDown: _vm.isB1Visible } }, [
            _vm._v("多模态设计")
          ])
        ]),
        _c(
          "div",
          { staticClass: "p2 delay2", class: { fadeDown: _vm.isB1Visible } },
          [_vm._v("伸缩、旋转形态自由切换，可静可动，造型由你定义")]
        )
      ])
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b2" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB2Visible } }, [
          _vm._v("精于心，减于形")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay2", class: { fadeUp: _vm.isB2Visible } },
          [_vm._v("区别于传统机器人造型，融于家的简洁几何线条设计")]
        )
      ])
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b3" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB3Visible } }, [
          _vm._v("不妥协，追求质感")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1", class: { fadeUp: _vm.isB3Visible } },
          [_vm._v("高端布料和金属质感，让家别具一份精致")]
        )
      ])
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b4" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB4Visible } }, [
          _vm._v("不止于形")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1", class: { fadeUp: _vm.isB4Visible } },
          [_vm._v("深入考究人机交互")]
        ),
        _c(
          "div",
          { staticClass: "p3 delay1", class: { fadeUp: _vm.isB4Visible } },
          [
            _vm._v("不止于外形，充分考虑躺，坐，站情况下的交互"),
            _c("br"),
            _vm._v("结合表情声音动作让人与机器人的交互更自然")
          ]
        ),
        _c(
          "div",
          { staticClass: "face-list" },
          _vm._l(_vm.face, function(value, key) {
            return _c(
              "div",
              {
                staticClass: "item",
                class: { active: key === _vm.currentFace },
                on: {
                  click: function($event) {
                    _vm.selectFace(key)
                  },
                  mouseover: function($event) {
                    _vm.selectFace(key)
                  }
                }
              },
              [
                _c("div", { staticClass: "icon", class: [key] }),
                _c("p", [_vm._v(_vm._s(value))])
              ]
            )
          })
        ),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentFace === "laugh",
              expression: "currentFace === 'laugh'"
            }
          ],
          staticClass: "face-gif",
          attrs: { src: __webpack_require__("sFtI") }
        }),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentFace === "angry",
              expression: "currentFace === 'angry'"
            }
          ],
          staticClass: "face-gif",
          attrs: { src: __webpack_require__("s0LP") }
        }),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentFace === "cry",
              expression: "currentFace === 'cry'"
            }
          ],
          staticClass: "face-gif",
          attrs: { src: __webpack_require__("WTXi") }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64a35226", esExports)
  }
}

/***/ }),

/***/ "elJj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-img8.de5d0d1.png";

/***/ }),

/***/ "fAp4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-bg.6f75259.png";

/***/ }),

/***/ "fDdG":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("urym");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("192f71f4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-46c3e992\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./app-footer.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-46c3e992\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./app-footer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "fNd4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cp-news" }, [
    _vm._m(0),
    _c("div", { staticClass: "main-wrap" }, [
      _c("div", { staticClass: "w" }, [
        _c(
          "div",
          { staticClass: "list" },
          _vm._l(_vm.currentList, function(item) {
            return _c("div", { staticClass: "item" }, [
              !_vm.isMobile
                ? _c("div", { staticClass: "col date" }, [
                    _c("h3", [
                      _vm._v(
                        _vm._s(item.date.split("-")[1]) +
                          "-" +
                          _vm._s(item.date.split("-")[2])
                      )
                    ]),
                    _c("span", [_vm._v(_vm._s(item.date.split("-")[0]))])
                  ])
                : _vm._e(),
              _c("img", {
                staticClass: "col img",
                attrs: { src: "static/images/news/" + item.img }
              }),
              _c("div", { staticClass: "info col" }, [
                _vm.isMobile
                  ? _c(
                      "a",
                      { staticClass: "title", attrs: { href: item.url } },
                      [_vm._v(_vm._s(item.title))]
                    )
                  : _c(
                      "a",
                      {
                        staticClass: "title",
                        attrs: { href: item.url, target: "_black" }
                      },
                      [_vm._v(_vm._s(item.title))]
                    ),
                !_vm.isMobile
                  ? _c("p", { staticClass: "desc" }, [
                      _vm._v(_vm._s(item.desc))
                    ])
                  : _vm._e(),
                _c("p", { staticClass: "source" }, [
                  _c("span", { staticClass: "mobile-source" }, [
                    _vm._v(_vm._s(item.source))
                  ]),
                  _vm.isMobile
                    ? _c("span", { staticClass: "mobile-date" }, [
                        _vm._v(_vm._s(item.date))
                      ])
                    : _vm._e()
                ])
              ])
            ])
          })
        ),
        _c(
          "div",
          { staticClass: "page" },
          [
            _c(
              "span",
              {
                staticClass: "btn-prev",
                class: { disable: !_vm.canPrev },
                on: { click: _vm.handelPrev }
              },
              [_vm._v("<")]
            ),
            _vm._l(_vm.pageCount, function(n) {
              return _c(
                "span",
                {
                  class: { active: n == _vm.currentPage },
                  on: {
                    click: function($event) {
                      _vm.handelPage(n)
                    }
                  }
                },
                [_vm._v(_vm._s(n))]
              )
            }),
            _c(
              "span",
              {
                staticClass: "btn-next",
                class: { disable: !_vm.canNext },
                on: { click: _vm.handelNext }
              },
              [_vm._v(">")]
            )
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner" }, [
      _c("p", { staticClass: "p1" }, [_vm._v("新闻动态")]),
      _c("p", { staticClass: "p2" }, [_vm._v("NEWS")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b2b2df2", esExports)
  }
}

/***/ }),

/***/ "fY6B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: {},
  methods: {}
});

/***/ }),

/***/ "fmc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_utils__ = __webpack_require__("JaHG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      robot3Show: DB.robot3Show,
      isB1Visible: true,
      isB2Visible: false,
      isB3Visible: false,
      isB4Visible: false,
      currentFace: 'laugh',
      face: {
        laugh: '开心',
        angry: '生气',
        cry: '哭泣'
      }
    };
  },

  computed: {},
  methods: {
    selectFace: function selectFace(face) {
      this.currentFace = face;
    }
  },
  created: function created() {
    var _this = this;

    $(window).on('scroll', function () {
      _this.isB1Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#design-b1');
      _this.isB2Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#design-b2');
      _this.isB3Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#design-b3');
      _this.isB4Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#design-b4');
    });
  }
});

/***/ }),

/***/ "g1w2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-info-b6.71b2d7f.jpg";

/***/ }),

/***/ "gLza":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "gTka":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.cp-robot .tabs {\n  width: 100%;\n  text-align: center;\n  height: 48px;\n  line-height: 48px;\n  border-top: 1px solid #eae9e9;\n  box-shadow: 0 3px 10px #eae9e9;\n}\n.cp-robot .tabs.fixed {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: rgba(255,255,255,0.8);\n  z-index: 10;\n}\n.cp-robot .tabs a {\n  display: inline-block;\n  margin: 0 18px;\n  cursor: pointer;\n  font-size: 14px;\n}\n.cp-robot .tabs a.router-link-active {\n  color: #3bc0bc;\n}\n", ""]);

// exports


/***/ }),

/***/ "gr/A":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-info-b5.41539c4.jpg";

/***/ }),

/***/ "h8ir":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-info-b4.ec4a3c2.jpg";

/***/ }),

/***/ "hX8U":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAYCAMAAAC/Wk/yAAAAD1BMVEVMaXEyMjIzMzM0NDQzMzM9G5SdAAAABHRSTlMA5kpJG2qUMwAAACtJREFUeNrt0bENAAAIAkFA9p/ZFYitfE1CcRg6iAM6ivlQ2bXwsspU5i6zwxQHJ+4wiwEAAAAASUVORK5CYII="

/***/ }),

/***/ "hjXl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-design-b3.bd0a8ab.jpg";

/***/ }),

/***/ "i+C4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-info-b5.ef567c2.jpg";

/***/ }),

/***/ "iFcm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var Slide = null;
var sliderList = [{ content: '\n    <a href="#/robot3s/info" class="slide" style="background-image: url(static/images/banner3.jpg?v=1)">\n      <div class="text text1">\n        <p class="p1">\u673A\u5668\u4EBA\u667A\u6167\u5EB7\u517B\u793E\u533A</p>\n        <p class="p2">\u670D\u52A1\u66F4\u8D34\u5FC3  \u8FD0\u8425\u66F4\u9AD8\u6548</p>\n        <p class="p3">\u4E86\u89E3\u66F4\u591A></p>\n      </div>\n    </a>'
}, { content: '\n    <a href="#/robot3/info" class="slide" style="background-image: url(static/images/banner1.jpg?v=1)">\n      <div class="text text1">\n        <p class="p1">\u5B9A\u4E49AI\u667A\u6167\u751F\u6D3B</p>\n        <p class="p2">\u7EF4\u62C93.0 \xA539,999\u5143/\u5957</p>\n        <p class="p3">\u4E86\u89E3\u66F4\u591A></p>\n      </div>\n    </a>'
}, { content: '\n    <a href="#/robot2s/info" class="slide" style="background-image: url(static/images/banner2.jpg?v=1)">\n      <div  class="text text1">\n        <p class="p1">\u672A\u6765\u4E4B\u9009 \u5C3D\u663E\u79D1\u6280</p>\n        <p class="p2">\u7EF4\u62C92.0 \xA518,999\u5143/\u5957</p>\n        <p class="p3">\u4E86\u89E3\u66F4\u591A></p>\n      </div>\n    </a>'
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      showVideo: false,
      animationIndex: 0,
      partners1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      partners2: [18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38]
    };
  },

  computed: {},
  methods: {
    closeVideo: function closeVideo() {
      this.showVideo = false;
    },
    initSlide: function initSlide() {

      Slide = new iSlider({
        dom: document.getElementById('iSlider-wrapper'),
        data: sliderList,
        fixPage: false,
        isAutoplay: true,
        duration: 3000,
        isLooping: 3000,
        plugins: ['dot']
      });
    },
    initPartnersCss: function initPartnersCss() {
      var n1 = this.partners1.length;
      var n2 = this.partners2.length;

      var s = '\n        @keyframes -ms-loop1 { 100% {transform: translateX(-' + 250 * n1 + 'px)}}\n        @keyframes -webkie-loop1 {100% {transform: translateX(-' + 250 * n1 + 'px)}}\n        @keyframes loop1 {100% {transform: translateX(-' + 250 * n1 + 'px)}}\n\n        @keyframes -ms-loop2 { 100% {transform: translateX(-' + 250 * n2 + 'px)}}\n        @keyframes -webkie-loop2 {100% {transform: translateX(-' + 250 * n2 + 'px)}}\n        @keyframes loop2 {100% {transform: translateX(-' + 250 * n2 + 'px)}}\n\n        .cp-home .partners .ul1 {\n          -ms-animation: loop1 ' + 4 * n1 + 's linear infinite;\n          -webkie-animation: loop1 ' + 4 * n1 + 's linear infinite;\n          animation: loop1 ' + 4 * n1 + 's linear infinite;\n        }\n        .cp-home .partners .ul2 {\n          -ms-animation: loop2 ' + 4 * n2 + 's linear infinite;\n          -webkie-animation: loop2 ' + 4 * n2 + 's linear infinite;\n          animation: loop2 ' + 4 * n2 + 's linear infinite;\n        }\n      ';

      var styleObject = document.createElement('style');
      styleObject.type = 'text/css';
      styleObject.innerHTML = s;
      document.getElementsByTagName('head')[0].appendChild(styleObject);
    }
  },
  created: function created() {
    this.initPartnersCss();
  },
  mounted: function mounted() {
    this.initSlide();
  }
});

/***/ }),

/***/ "iVUu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-banner-default.b4a6b51.jpg";

/***/ }),

/***/ "inTp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-info-b4.8b4e854.jpg";

/***/ }),

/***/ "jG7l":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/link2.e582521.png";

/***/ }),

/***/ "jd1m":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.cp-robot .tabs {\n  width: 100%;\n  text-align: center;\n  height: 48px;\n  line-height: 48px;\n  border-top: 1px solid #eae9e9;\n  box-shadow: 0 3px 10px #eae9e9;\n}\n.cp-robot .tabs.fixed {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: rgba(255,255,255,0.8);\n  z-index: 10;\n}\n.cp-robot .tabs a {\n  display: inline-block;\n  margin: 0 18px;\n  cursor: pointer;\n  font-size: 14px;\n}\n.cp-robot .tabs a.router-link-active {\n  color: #3bc0bc;\n}\n.cp-robot #robot3s-default-banner {\n  min-width: 1200px;\n  height: 800px;\n  background: url(" + escape(__webpack_require__("U/rx")) + ") no-repeat center;\n  background-size: auto 100%;\n  text-align: center;\n}\n.cp-robot #robot3s-default-banner .w {\n  padding-top: 306px;\n}\n.cp-robot #robot3s-default-banner .p1 {\n  color: #fff;\n  font-size: 40px;\n}\n.cp-robot #robot3s-default-banner .p2 {\n  margin-top: 120px;\n  font-size: 24px;\n  color: #4ce2af;\n}\n.is-mobile #robot3s-default-banner {\n  min-width: 100%;\n  background-image: url(" + escape(__webpack_require__("iVUu")) + ");\n  height: 34.375rem;\n}\n.is-mobile #robot3s-default-banner .w {\n  padding-top: 12.5rem;\n}\n.is-mobile #robot3s-default-banner .p1 {\n  font-size: 1.25rem;\n}\n.is-mobile #robot3s-default-banner .p2 {\n  margin-top: 3.75rem;\n  font-size: 0.625rem;\n}\n", ""]);

// exports


/***/ }),

/***/ "jlZZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-design-b1.e0a9b4b.jpg";

/***/ }),

/***/ "jz4q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-img2.2810df4.png";

/***/ }),

/***/ "jzMs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-img2.53a788f.png";

/***/ }),

/***/ "k+El":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5qVc");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3b0ae93e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7bf87b9d\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./info.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7bf87b9d\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./info.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "kGqw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_info_vue__ = __webpack_require__("nc+F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d356b33_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_info_vue__ = __webpack_require__("vffT");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("9/wf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d356b33_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\views\\robot\\2s\\info.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6d356b33", Component.options)
  } else {
    hotAPI.reload("data-v-6d356b33", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kaV8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_design_vue__ = __webpack_require__("+dhH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_636db903_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_design_vue__ = __webpack_require__("Fq+V");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("sTW6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_design_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_636db903_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_design_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\views\\robot\\2s\\design.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-636db903", Component.options)
  } else {
    hotAPI.reload("data-v-636db903", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kggS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-info-2.fff7e15.png";

/***/ }),

/***/ "kiD0":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAMAAAAVBLyFAAAASFBMVEVMaXGGhpN/g5OJiZyAg5N/g5N/hpN+g5R/g5N/hJN+g5N/g5R+gpN/hJN7g5J/g5N/hJJ9gZSAhJN/hJR/hJOBhJN/g5SAhJRXnfltAAAAF3RSTlMAE7YNq/Am+ejaYdDHoiG8kE+Dd2ZTPM140oYAAAB7SURBVHjaPctZEsIwDATRiZfIDtm3vv9NgQjzvlRdI0nxGI28DPq7C672cr1RAhAKpfOUYI9GjiusnjJggJUU0vD8Gi4EvpZPHPGz4sqsjUeCYaXORpIOgPqCbFDAJE2emixpPPtt2Gkm/cQ2q52abjKA7KXF67zuNOsNQikMPEa/FfUAAAAASUVORK5CYII="

/***/ }),

/***/ "l+cR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-img3.ced2db7.png";

/***/ }),

/***/ "l7lX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-info-b1.7353a90.jpg";

/***/ }),

/***/ "laUw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-img3.0fa256b.png";

/***/ }),

/***/ "laoQ":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "lpgv":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.cp-home .banner {\n  position: relative;\n  min-width: 1200px;\n  height: 750px;\n  overflow: hidden;\n}\n.cp-home .banner .islider-dot-wrap {\n  position: absolute;\n  bottom: 30px;\n  left: 0;\n  width: 100%;\n  z-index: 10;\n  text-align: center;\n}\n.cp-home .banner .islider-dot-wrap li {\n  width: 60px;\n  height: 6px;\n  margin: 0 10px;\n  display: inline-block;\n  background-color: #fff;\n  font-size: 0;\n}\n.cp-home .banner .islider-dot-wrap li.active {\n  background-color: #3bc0bc;\n}\n.cp-home .banner #iSlider-wrapper {\n  height: 100%;\n}\n.cp-home .banner .islider-outer {\n  position: relative;\n  height: 100%;\n}\n.cp-home .banner .islider-outer li {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n}\n.cp-home .banner .islider-outer .slide {\n  display: block;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background-size: auto 100%;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n.cp-home .banner .islider-outer .slide .text {\n  position: absolute;\n  width: 100%;\n  top: 50px;\n  text-align: center;\n  line-height: 1.7;\n}\n.cp-home .banner .islider-outer .slide .text .p1 {\n  font-size: 46px;\n  color: #4c4c4c;\n  opacity: 0;\n}\n.cp-home .banner .islider-outer .slide .text .p2 {\n  font-size: 24px;\n  color: #4c4c4c;\n  opacity: 0;\n}\n.cp-home .banner .islider-outer .slide .text .p3 {\n  display: block;\n  font-size: 19px;\n  color: #00a9a8;\n  opacity: 0;\n}\n.cp-home .banner .islider-outer .slide .text2 .p1 {\n  padding-top: 80px;\n  color: #fff;\n}\n.cp-home .banner .islider-outer .slide .text2 .p2 {\n  margin-top: 120px;\n  font-size: 24px;\n  color: #4ce2af;\n}\n.cp-home .banner .islider-outer .islider-active .p1 {\n  animation: fadeUp 1s forwards;\n}\n.cp-home .banner .islider-outer .islider-active .p2 {\n  animation: fadeUp 1s 0.5s forwards;\n}\n.cp-home .banner .islider-outer .islider-active .p3 {\n  animation: fadeUp 1s 0.8s forwards;\n}\n.cp-home .list-links {\n  margin: 45px 0;\n  text-align: center;\n}\n.cp-home .list-links a {\n  display: inline-block;\n  width: 370px;\n  height: 310px;\n  padding-top: 240px;\n  background-position: top center;\n  background-repeat: no-repeat;\n}\n.cp-home .list-links a b {\n  display: block;\n  height: 70px;\n  line-height: 70px;\n  font-size: 18px;\n  border: 2px solid #f5f7f9;\n  border-top: none;\n}\n.cp-home .list-links .link1 {\n  background-image: url(" + escape(__webpack_require__("aV1F")) + ");\n}\n.cp-home .list-links .link2 {\n  margin: 0 20px;\n  background-image: url(" + escape(__webpack_require__("jG7l")) + ");\n}\n.cp-home .list-links .link3 {\n  background-image: url(" + escape(__webpack_require__("Luu2")) + ");\n}\n.cp-home .partners {\n  background: #f5f7f9;\n}\n.cp-home .partners .pp {\n  font-size: 40px;\n  margin: 0 auto;\n  text-align: center;\n  width: 1150px;\n  border-bottom: 1px solid #eae9e9;\n  padding: 40px 0;\n}\n.cp-home .partners .logo-list {\n  padding: 85px 0;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.cp-home .partners .logo-list ul li {\n  width: 250px;\n  height: 156px;\n  display: inline-block;\n  background-size: cover;\n}\n.cp-home .video-wrap {\n  position: fixed;\n  z-index: 20;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.cp-home .video-wrap .btn-close {\n  position: absolute;\n  right: 50%;\n  bottom: 20px;\n  color: #fff;\n  font-size: 60px;\n  transform: rotate(45deg) translatey(-50%);\n}\n.cp-home .video-wrap .mask {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0,0,0,0.8);\n}\n.cp-home .video-wrap iframe {\n  position: relative;\n  z-index: 30;\n  width: 80%;\n  height: 80%;\n  margin: 30px 0 0 10%;\n}\n.is-mobile .cp-home .video-wrap iframe {\n  height: 18.75rem;\n  margin-top: 6.25rem;\n}\n.is-mobile .cp-home .banner {\n  min-width: inherit;\n  height: 34.375rem;\n}\n.is-mobile .cp-home .banner .islider-dot-wrap {\n  bottom: 0.9375rem;\n}\n.is-mobile .cp-home .banner .islider-dot-wrap li {\n  width: 2.1875rem;\n  height: 0.125rem;\n  margin: 0 0.3125rem;\n}\n.is-mobile .cp-home .banner .islider-outer .slide .text .p1 {\n  font-size: 1.4375rem;\n}\n.is-mobile .cp-home .banner .islider-outer .slide .p2 {\n  font-size: 0.75rem;\n}\n.is-mobile .cp-home .banner .islider-outer .slide .p3 {\n  font-size: 0.625rem;\n}\n.is-mobile .cp-home .list-links {\n  margin: 0.625rem 0;\n}\n.is-mobile .cp-home .list-links a {\n  width: 18.75rem;\n  height: 15.625rem;\n  background-size: 100% auto;\n  padding-top: 12.03125rem;\n}\n.is-mobile .cp-home .list-links a b {\n  height: 2.8125rem;\n  line-height: 2.8125rem;\n  border-left: none;\n  border-right: none;\n  border-top: none;\n}\n.is-mobile .cp-home .partners .pp {\n  font-size: 0.9375rem;\n  width: 100%;\n  padding: 1.25rem 0;\n}\n.is-mobile .cp-home .partners .logo-list {\n  padding: 2.1875rem 0;\n}\n.is-mobile .cp-home .partners .logo-list ul li {\n  padding: 2.1875rem 0;\n  width: 125px;\n  height: 78px;\n}\n@-moz-keyframes loop {\n100% {\n    transform: translateX(-1000px);\n}\n}\n@-webkit-keyframes loop {\n100% {\n    transform: translateX(-1000px);\n}\n}\n@-o-keyframes loop {\n100% {\n    transform: translateX(-1000px);\n}\n}\n@keyframes loop {\n100% {\n    transform: translateX(-1000px);\n}\n}\n", ""]);

// exports


/***/ }),

/***/ "mCE0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-info-b5.16874d9.jpg";

/***/ }),

/***/ "mLd6":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAKlBMVEVMaXH////////////////////////////////////////////////////m1kuZAAAADXRSTlMA/FZO+Ufd54arCbCyDliQggAAAHRJREFUeNrl0UEOgzAMRNGxg5NA6/tft0JYSNEwXKB/+5Yfx/wEHmtjOGam+aNumQN7lrOeHHY76dYAv1zo4qTkpLeTki9KTkq+KPmi7FYqvFS7CUW72AF1sFypWbk46P/yF/3lb5ys/+5A9B7q34QuvvP4ATb+CmYo6yZ8AAAAAElFTkSuQmCC"

/***/ }),

/***/ "mLsT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-info-b2.29a17fb.png";

/***/ }),

/***/ "mPzo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_spec__ = __webpack_require__("KtyA");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      list: []
    };
  },
  created: function created() {
    var type = this.$route.fullPath.split('/')[1];
    this.list = __WEBPACK_IMPORTED_MODULE_0__config_spec__["a" /* default */][type];
  }
});

/***/ }),

/***/ "miFu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cp-robot" },
    [
      _vm.robot3Show
        ? [
            _c("transition", { attrs: { name: "fadeUp" } }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isTabsVisible,
                      expression: "!isTabsVisible"
                    }
                  ],
                  staticClass: "tabs fixed"
                },
                [
                  _c("router-link", { attrs: { to: "/robot3s/info" } }, [
                    _vm._v("机器人")
                  ]),
                  _c("router-link", { attrs: { to: "/robot3s/design" } }, [
                    _vm._v("平台")
                  ]),
                  _c("router-link", { attrs: { to: "/robot3s/spec" } }, [
                    _vm._v("技术规格")
                  ])
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "tabs", attrs: { id: "tabs" } },
              [
                _c("router-link", { attrs: { to: "/robot3s/info" } }, [
                  _vm._v("机器人")
                ]),
                _c("router-link", { attrs: { to: "/robot3s/design" } }, [
                  _vm._v("平台")
                ]),
                _c("router-link", { attrs: { to: "/robot3s/spec" } }, [
                  _vm._v("技术规格")
                ])
              ],
              1
            ),
            _c("router-view")
          ]
        : [
            _c("div", { attrs: { id: "robot3s-default-banner" } }, [
              _c("div", { staticClass: "w" }, [
                _vm.isMobile
                  ? _c("div", { staticClass: "p1 fadeUp" }, [
                      _vm._v(" 11.15日"),
                      _c("br"),
                      _vm._v("深圳新品发布会")
                    ])
                  : _c("div", { staticClass: "p1 fadeUp" }, [
                      _vm._v("11.15日·深圳新品发布会")
                    ]),
                _c("div", { staticClass: "p2 fadeDown delay1" })
              ])
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b826b08", esExports)
  }
}

/***/ }),

/***/ "nc+F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_utils__ = __webpack_require__("JaHG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isB1Visible: true,
      isB2Visible: false,
      isB3Visible: false,
      isB4Visible: false,
      isB5Visible: false,
      isB6Visible: false,
      isB7Visible: false,
      b2List: [{ text: '“我要听周杰伦的歌”', tag: '音乐' }, { text: '“学一下小狗的声音”', tag: '闲聊' }, { text: '“设置一个明早8点的闹钟”', tag: '效率' }, { text: '“海内存知己出自哪首诗”', tag: '百科' }, { text: '“调高电视机音量”', tag: '智能家居' }, { text: '“北京今天限行号是什么”', tag: '生活信息' }, { text: '“妈妈昨晚睡眠情况如何”', tag: '家人健康' }, { text: '“我要听故事”', tag: '有声资源' }]
    };
  },

  computed: {},
  methods: {},
  created: function created() {
    var _this = this;

    $(window).on('scroll', function () {
      _this.isB1Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b1');
      _this.isB2Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b2');
      _this.isB3Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b3');
      _this.isB4Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b4');
      _this.isB5Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b5');
      _this.isB6Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b6');
      _this.isB7Visible = Object(__WEBPACK_IMPORTED_MODULE_0__common_utils__["b" /* isVisible */])('#info-b7');
    });
  }
});

/***/ }),

/***/ "nrqA":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("OOpF");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7c1852bb", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-045f21ae\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./app-header.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-045f21ae\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./app-header.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "o2Bm":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAMAAACzQHQ9AAAAP1BMVEVMaXF/hJR/hJR/h5d/g5N/g5R/gpN/hJN/gpJ8gpJ/g5OAhJR/g5N/g5OAg5KAg5J+g5KJiZJ/gpSAhJOAhJTHFrvuAAAAFHRSTlMAjmAgP7rgcLAvgvGnwFeXZQ5KeZAKHUoAAAB3SURBVHjajdDLDsMwCERRcIzB7ySd///WYjmVusxdIJ3dCCIS/Oq0AuuuYDvT7nhjM3TbCcwIqAwINzQWwD2zIZTBuUVZjjIQpnLu93K6wlXDPZHPBncpKbRgQE5YThU1+YHTrfq3V/XN3jPuxuPVB962wJPnH18n3wmm3ehWAAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "oMgk":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAIVBMVEVQUFBMaXFRUVFRUVFOTk5QUFBRUVFVVVVPT09PT09RUVFmXUP5AAAACnRSTlPwAKCQK9/PG0BQ5ei0DAAAAFFJREFUeNp1kEkOgDAMA02Wbv9/MKiigIw7x1GsJMYQYBQnyiX9IHzKxIe8JdIeEkvam7Upo7KsgR4so+t4+082KWVcLpInibh+c18I4buSBSf+SQTdXQep4wAAAABJRU5ErkJggg=="

/***/ }),

/***/ "ok8V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("HCx1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ae5b5c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("216z");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("/mVd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ae5b5c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\views\\robot\\2s\\index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ae5b5c6", Component.options)
  } else {
    hotAPI.reload("data-v-7ae5b5c6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oukn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-info-b2.2d5d45f.jpg";

/***/ }),

/***/ "p2bX":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "pH+L":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("u8Ly");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0d5eab10", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-23b71e09\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./about.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-23b71e09\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./about.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "prrE":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ptHS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__ = __webpack_require__("CzOb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_045f21ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__ = __webpack_require__("IjzZ");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("nrqA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_045f21ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\components\\app-header.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-045f21ae", Component.options)
  } else {
    hotAPI.reload("data-v-045f21ae", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q0bZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spec_vue__ = __webpack_require__("mPzo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c1a6e21_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_spec_vue__ = __webpack_require__("ZPyE");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("9MU5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spec_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c1a6e21_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_spec_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\views\\robot\\spec.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7c1a6e21", Component.options)
  } else {
    hotAPI.reload("data-v-7c1a6e21", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q4Cb":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAASCAMAAABo+94fAAAALVBMVEVMaXFPT09PT09RUVFPT09RUVFQUFBRUVFPT09QUFBRUVF/f39QUFBRUVFRUVGiQovSAAAADnRSTlMAMGGgQIB83CDQ6AKuxlz9wmIAAABISURBVHja3c07DsAwCANQkxTI1/c/boamUiRygr7JeDAwXhjoKXCCGUH+Xz0lmMTgxUCXZ3P/kvRjsdbwpJhqa6pWcErc0nsvYZMFb6jvW9oAAAAASUVORK5CYII="

/***/ }),

/***/ "q6H2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-design-b1.0c68cc3.jpg";

/***/ }),

/***/ "qe9x":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAcCAMAAAC9M9RRAAAAkFBMVEVMaXFQUFBQUFBRUVFQUFBRUVFQUFBOTk5PT09RUVFRUVFQUFBQUFBQUFBQUFBRUVFRUVFYWFhQUFBPT09VVVVPT09QUFBQUFBRUVFQUFBRUVFQUFBQUFBQUFBQUFBQUFBQUFBRUVFQUFBQUFBQUFBQUFBQUFBQUFBQUFBRUVFVVVVQUFBRUVFPT09VVVVRUVE6mKiPAAAAL3RSTlMAUqji963pAWCEN2oO0/2XWASlIApN+u5It9lAn2R+8stxkieOuy7IdYoSssR2GPLcUb8AAAE/SURBVHjaXZHXloMwDERlDJhmeiihp9fV///dHslsTtj7ovEgj2UDhkz0+wrjfS4y+CKVqJNlePcS5aBgJXLQuRipuhe20WrrSVANrIK+LLGOOPo8BUD46HHdxQ5FhbgDpuzW5IUaSjeHf6hZZpDiEYiLVaObFCYJU7CuRtqtuIhzHfCRrgXSJ1XYXNTdLak6EnAgcdLKROuQR4sBUxIztbPDU4wIFTfsb2C4ObzdBp1wIC1Z8MazhkQqvqO5c2DT1KWdQIcNGXktFChRj8BP0AFcdUYj+7Y7uzUfFsmrAgjwAMRDDA0PrywT6uO4eZ0Dvo1IMH987J8n3v86lqoeC5aFX08hfDjmFcr22Uqs+gK+adBK+lOPKWw52BFNWFlbW7nGcKZy43frT06/gxrPa+PBI0J8eV4Dhhm3zADwCxJsGXVNN/7gAAAAAElFTkSuQmCC"

/***/ }),

/***/ "qlnE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner-news.e9ae81e.jpg";

/***/ }),

/***/ "qqJh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-img6.4f6a527.png";

/***/ }),

/***/ "qry4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAABIFBMVEVMaXE6rf8/nv5NpP87rf83rP87rv87r/87r/86r/84qP47rP87rv87rf87rv9yvf8/ofw6qf9Bm/tDr/8+ofxAnPw6sP88rv87rv8yr/86rv/4/+o7ov06rP85lPk7rf8/pf04l/r/5+EvlP3/xrohgvwbpf+Hkc7/lYr/n5Qvpf9Wpvs0qf8+o/zHqLoevP96vfEouf87sP8/ofw+pv5DkflAnPw/ov1Dk/pClvpGh/hFivg8rv8+pf1EjflBmvs7rv87r/88rf49qP5Ejvk9p/5CmPtFjPk9qv49qf5DkvpCl/tBmftEkPlAn/xAnfw8q/49q/4/o/1BmPo5tf86sv88sf8zmfworf8yqf8xn/89uf8foP8epf+RgLNIgvbVmbVTAAAAMnRSTlMAgSALnmvY8s7hOKpijZQEPUGUV1uEvRUt/8YMdukptUixK5I/uerTjmXilvLsYf2URlDVwVkAAAMRSURBVHja7dTpU9pAGMfxlftUqKDW2973scGEtAkhgUBWYogBPHr+//9Fn2dhFIvHbJC+ab4vcIgzn/nNkoRERUVFRUVFRd1ULpnYzKbT6exasbDxYGpsO0WnWyvEH4JdL9KZssn53WSa3lSmPKebp7e1NA8bz9DbS8zhZuld5UPDGXp3yyHdBL2vQih3ld7fegh3JU3vby0EvEQxk9e8nsmjWC7MYACtSf501qQm4JvCcJI2NU0D5oTnXMW/+xD836Qb4rca7nQcxlgLsq/Cr3DVcWC7JvwArlMNXYakPhvyDGUzI3yvacjaNVCC2eBqzW6xE18zBc+iSC2ftVCVbg7tFvMtmhSD90zfATdQFEnyZgJYUQKQHd8UPOSM5qMrAduH5OnwgsdH28zXlsXglOXY6HqAGjMBjjROthKiMLMDBVlwXbcznesiDbKi28JwxmJ6AHtBHQzUvxt0XAPlQGeiR7GHsAfH4PZ6qlq/nqr2uMxhwR9v2WS65MlGZ4DqIXR8ePkJNIw2YLLOzKQYXKBMV2BwD9wj8KA2Bn/BPgK6Y8ieojvNnBgco44u9Q0XjgHYNq/RaLR5QMNmV4bFVooIltUQ7qCLZLf7dVy3C/wxbEY40M2iKJw4tQMP4aPj9oS9pGHzBG7RkihcGjFdkl21DoPH7BeMyzgZ4L6ka1kiXMrEs+gB3OhydhLKfLHRV+xRRRyuDJnuGQMVfrppGGVYXFcHMgzeISHaOcXJKk6+thjhQxwsOeflMPD+0B+f8mTy9EmMT/jxAdkKI+eHju7Jk8OAOMv38oMIzBfk9ZMw8Ep2yAJP7uDmxuV9zF0XDrg52iVbKyRMsXe4uQ+vC3z4GhjcwrgXzsEclkjoYm++85tu0AMbXxj4AurxJ2OUzpE5Wv1mDS2gZXgGxw0MZM1RPjaPuxV/Xn+fsnxWO/vx88yDpCCoXVzsJHJk3nbjJFaqbC+9/PX26SOoWk2W4drD9ewVWXgfPn1eiJv7eH66ugg4Lxn9zUXAFfV3u0oW0fZBlURFRf2byvskKuq/6w/7KlAQeQbYFAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "qu5y":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "rO48":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-info-b4.0cd43a7.jpg";

/***/ }),

/***/ "rmhC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dialog4.a36a76b.png";

/***/ }),

/***/ "s+NX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-design-b4.afc5b7a.jpg";

/***/ }),

/***/ "s0LP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/face-angry.43632a6.gif";

/***/ }),

/***/ "sFtI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/face-laugh.d693e6f.gif";

/***/ }),

/***/ "sTW6":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("/HRF");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("d1d3863a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-636db903\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./design.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-636db903\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./design.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "sh7B":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "sqz6":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAXCAMAAADA1rRbAAAAb1BMVEVMaXFQUFBTU1NRUVFQUFBVVVVSUlJQUFBRUVFQUFBQUFBRUVFRUVFQUFBQUFBRUVFQUFBVVVVQUFBSUlJQUFBRUVFRUVFQUFBRUVFRUVFQUFBPT09MTExRUVFRUVFRUVFRUVFRUVFSUlJRUVFRUVF96EVUAAAAJHRSTlMA4x589gYR/capYAMthr8y2AyQRyNldOwm8c1QCu+Wa5dRRKCqzw/rAAAA4ElEQVR42p3P2Q6DIBRF0cs8KGidtXN7/v8bGxKNtdGXridgE3KhBW/fU29g+undctpQ3gJAX05lnxbWqzV6BpThpSnRr1ACzM+tsTCuoG+FM7BNWj1H2Jx+5Rbjk6g1RtCOTBjTkpM1zU7F2Z+LE81q6Ujlc7pbg8TY+3whV8s73RVgLojgGHDtMvrCLeQjXwZ6SFi+xoEhNrRqIthAi0ussu3AVbysO0WL4xPtb+7mNe1/XyKRItupAbKqi7qSCDtVO04Jd5r+oQZ1HDkD44dVoIQ4rB1GdIdVRxM3A38AopkO0438iZ4AAAAASUVORK5CYII="

/***/ }),

/***/ "ss2l":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner-about.808689e.jpg";

/***/ }),

/***/ "t8zM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-info-b7.64259ed.jpg";

/***/ }),

/***/ "tIE6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-design-b3.d9d0cd4.jpg";

/***/ }),

/***/ "tN3s":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-info-b3.1de5757.jpg";

/***/ }),

/***/ "tUr6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-bg.da470dc.png";

/***/ }),

/***/ "tbZT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner-service.18c489f.jpg";

/***/ }),

/***/ "u+ZD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-info-1.f580dae.png";

/***/ }),

/***/ "u8Ly":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.cp-about {\n  color: #333;\n}\n.cp-about h2 {\n  font-size: 30px;\n  text-align: center;\n}\n.cp-about h3 {\n  font-size: 16px;\n  text-align: center;\n}\n.cp-about .banner {\n  background: url(" + escape(__webpack_require__("07wV")) + ") center;\n  background-size: auto 100%;\n  width: 100%;\n  height: 550px;\n  color: #fff;\n  font-size: 18px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.cp-about .banner .p1 {\n  font-size: 40px;\n}\n.cp-about .banner .p2 {\n  margin: 0 0 20px 0;\n}\n.cp-about #company-profile {\n  padding-top: 60px;\n}\n.cp-about #company-profile h4 {\n  font-size: 16px;\n  text-align: center;\n  padding-top: 20px;\n}\n.cp-about #company-profile p {\n  padding: 20px 60px 0;\n  text-indent: 2em;\n  font-size: 14px;\n}\n.cp-about #company-profile .img {\n  display: block;\n  margin: 40px auto 0;\n}\n.cp-about #application-area {\n  padding: 60px 0 100px;\n}\n.cp-about #application-area ul {\n  margin-top: 40px;\n  text-align: center;\n}\n.cp-about #application-area ul li {\n  display: inline-block;\n  width: 240px;\n  margin: 0 80px;\n}\n.cp-about #application-area ul li .title {\n  font-size: 18px;\n  margin: 20px 0;\n}\n.cp-about #application-area ul li p {\n  font-size: 13px;\n  width: 250px;\n}\n.cp-about #contact-us {\n  background: #f5f7f9;\n  padding: 40px 0 30px;\n}\n.cp-about #contact-us .info1 {\n  margin-top: 40px;\n  height: 390px;\n  background: #fff;\n  background: url(" + escape(__webpack_require__("Hnad")) + ") right center no-repeat #fff;\n}\n.cp-about #contact-us .info1 .left {\n  font-size: 18px;\n  width: 440px;\n  padding: 50px 0 0 110px;\n}\n.cp-about #contact-us .info1 .left h4 {\n  text-align: center;\n  padding-bottom: 10px;\n  margin-bottom: 56px;\n  background: url(" + escape(__webpack_require__("zAZ4")) + ") bottom center no-repeat;\n}\n.cp-about #contact-us .info1 .left p {\n  line-height: 40px;\n}\n.cp-about #contact-us .info2 {\n  background-color: #fff;\n  margin-top: 15px;\n  overflow: hidden;\n  padding-left: 110px;\n  padding-bottom: 35px;\n}\n.cp-about #contact-us .info2 .item {\n  float: left;\n  width: 360px;\n  padding-top: 35px;\n}\n.cp-about #contact-us .info2 .item h4 {\n  font-size: 18px;\n  padding-bottom: 10px;\n}\n.cp-about #contact-us .info2 .item p {\n  font-size: 14px;\n}\n.is-mobile .cp-about h2 {\n  font-size: 0.9375rem;\n}\n.is-mobile .cp-about h3 {\n  font-size: 0.625rem;\n}\n.is-mobile .cp-about .banner {\n  height: 34.71875rem;\n  background-image: url(" + escape(__webpack_require__("ss2l")) + ");\n}\n.is-mobile .cp-about .banner .p1 {\n  margin-top: -15.625rem;\n  font-size: 1.25rem;\n}\n.is-mobile .cp-about .banner .p2 {\n  font-size: 0.5625rem;\n}\n.is-mobile .cp-about .banner .p3 {\n  font-size: 0.625rem;\n}\n.is-mobile .cp-about #company-profile {\n  padding-top: 0.9375rem;\n}\n.is-mobile .cp-about #company-profile h2 {\n  font-size: 0.9375rem;\n}\n.is-mobile .cp-about #company-profile h3 {\n  font-size: 0.625rem;\n}\n.is-mobile .cp-about #company-profile p {\n  padding: 0.625rem 1.875rem 0;\n  line-height: 1.8;\n}\n.is-mobile .cp-about #company-profile .img {\n  margin: 1.25rem auto 0;\n  width: 90%;\n}\n.is-mobile .cp-about #application-area {\n  padding: 1.875rem 0;\n}\n.is-mobile .cp-about #application-area ul li {\n  display: block;\n  margin: 0 auto 1.25rem;\n}\n.is-mobile .cp-about #application-area ul li img {\n  width: 7.5rem;\n}\n.is-mobile .cp-about #application-area ul li .title {\n  font-size: 0.5625rem;\n  margin: 0.625rem 0;\n}\n.is-mobile .cp-about #application-area ul li p {\n  font-size: 0.40625rem;\n}\n.is-mobile .cp-about #contact-us {\n  padding: 1.25rem 0;\n}\n.is-mobile .cp-about #contact-us .info1 {\n  margin: 1.25rem;\n  height: 23.75rem;\n  background: url(" + escape(__webpack_require__("a0sQ")) + ") right bottom no-repeat #fff;\n  background-size: 100% auto;\n}\n.is-mobile .cp-about #contact-us .info1 .left {\n  width: 100%;\n  padding: 0;\n}\n.is-mobile .cp-about #contact-us .info1 .left h4 {\n  padding: 0.625rem 0;\n  margin-bottom: 1.09375rem;\n}\n.is-mobile .cp-about #contact-us .info1 .left p {\n  line-height: 2;\n  font-size: 0.875rem;\n  padding-left: 2.5rem;\n}\n.is-mobile .cp-about #contact-us .info2 {\n  margin: 0;\n  padding: 0;\n}\n.is-mobile .cp-about #contact-us .info2 .item {\n  width: 50%;\n  padding: 0.9375rem 0 0.9375rem 0.9375rem;\n}\n.is-mobile .cp-about #contact-us .info2 .item h4 {\n  font-size: 0.875rem;\n}\n.is-mobile .cp-about #contact-us .info2 .item p {\n  font-size: 0.6875rem;\n}\n", ""]);

// exports


/***/ }),

/***/ "uRk5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-info-b1.c468cf9.png";

/***/ }),

/***/ "urym":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n* {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: transparent;\n  box-sizing: border-box;\n}\nhtml * {\n  outline: 0;\n}\nhtml,\nbody,\ndiv,\nspan,\nsmall,\np,\nem,\ni,\nb,\nth,\ntd,\ndl,\ndt,\ndd,\nul,\nol,\nli,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nform,\ntextarea,\ninput {\n  padding: 0;\n  margin: 0;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: normal;\n}\na {\n  color: #7d7d7d;\n  text-decoration: none;\n  transition: 0.3s;\n}\na:active,\na:visited {\n  color: currentColor;\n}\na:hover {\n  color: #3ec1bd;\n}\na,\nimg {\n  border: none;\n  touch-callout: none;\n}\nul,\nli,\nol {\n  list-style: none;\n}\ni,\nem {\n  font-style: normal;\n}\ns {\n  text-decoration: none;\n}\ntable {\n  border-spacing: 0;\n  border-collapse: collapse;\n}\ninput:focus,\nselect:focus,\ntextarea:focus,\nselect,\nbutton {\n  margin: 0;\n  outline: none;\n  appearance: none;\n}\ninput,\nbutton {\n  background-image: none;\n}\n.mt5 {\n  margin-top: 5px;\n}\n.mr5 {\n  margin-right: 5px;\n}\n.mb5 {\n  margin-bottom: 5px;\n}\n.ml5 {\n  margin-left: 5px;\n}\n.m5 {\n  margin: 5px;\n}\n.pt5 {\n  padding-top: 5px;\n}\n.pr5 {\n  padding-right: 5px;\n}\n.pb5 {\n  padding-bottom: 5px;\n}\n.pl5 {\n  padding-left: 5px;\n}\n.p5 {\n  padding: 5px;\n}\n.mt10 {\n  margin-top: 10px;\n}\n.mr10 {\n  margin-right: 10px;\n}\n.mb10 {\n  margin-bottom: 10px;\n}\n.ml10 {\n  margin-left: 10px;\n}\n.m10 {\n  margin: 10px;\n}\n.pt10 {\n  padding-top: 10px;\n}\n.pr10 {\n  padding-right: 10px;\n}\n.pb10 {\n  padding-bottom: 10px;\n}\n.pl10 {\n  padding-left: 10px;\n}\n.p10 {\n  padding: 10px;\n}\n.mt15 {\n  margin-top: 15px;\n}\n.mr15 {\n  margin-right: 15px;\n}\n.mb15 {\n  margin-bottom: 15px;\n}\n.ml15 {\n  margin-left: 15px;\n}\n.m15 {\n  margin: 15px;\n}\n.pt15 {\n  padding-top: 15px;\n}\n.pr15 {\n  padding-right: 15px;\n}\n.pb15 {\n  padding-bottom: 15px;\n}\n.pl15 {\n  padding-left: 15px;\n}\n.p15 {\n  padding: 15px;\n}\n.mt20 {\n  margin-top: 20px;\n}\n.mr20 {\n  margin-right: 20px;\n}\n.mb20 {\n  margin-bottom: 20px;\n}\n.ml20 {\n  margin-left: 20px;\n}\n.m20 {\n  margin: 20px;\n}\n.pt20 {\n  padding-top: 20px;\n}\n.pr20 {\n  padding-right: 20px;\n}\n.pb20 {\n  padding-bottom: 20px;\n}\n.pl20 {\n  padding-left: 20px;\n}\n.p20 {\n  padding: 20px;\n}\n.mt25 {\n  margin-top: 25px;\n}\n.mr25 {\n  margin-right: 25px;\n}\n.mb25 {\n  margin-bottom: 25px;\n}\n.ml25 {\n  margin-left: 25px;\n}\n.m25 {\n  margin: 25px;\n}\n.pt25 {\n  padding-top: 25px;\n}\n.pr25 {\n  padding-right: 25px;\n}\n.pb25 {\n  padding-bottom: 25px;\n}\n.pl25 {\n  padding-left: 25px;\n}\n.p25 {\n  padding: 25px;\n}\n.mt30 {\n  margin-top: 30px;\n}\n.mr30 {\n  margin-right: 30px;\n}\n.mb30 {\n  margin-bottom: 30px;\n}\n.ml30 {\n  margin-left: 30px;\n}\n.m30 {\n  margin: 30px;\n}\n.pt30 {\n  padding-top: 30px;\n}\n.pr30 {\n  padding-right: 30px;\n}\n.pb30 {\n  padding-bottom: 30px;\n}\n.pl30 {\n  padding-left: 30px;\n}\n.p30 {\n  padding: 30px;\n}\n.mt35 {\n  margin-top: 35px;\n}\n.mr35 {\n  margin-right: 35px;\n}\n.mb35 {\n  margin-bottom: 35px;\n}\n.ml35 {\n  margin-left: 35px;\n}\n.m35 {\n  margin: 35px;\n}\n.pt35 {\n  padding-top: 35px;\n}\n.pr35 {\n  padding-right: 35px;\n}\n.pb35 {\n  padding-bottom: 35px;\n}\n.pl35 {\n  padding-left: 35px;\n}\n.p35 {\n  padding: 35px;\n}\n.mt40 {\n  margin-top: 40px;\n}\n.mr40 {\n  margin-right: 40px;\n}\n.mb40 {\n  margin-bottom: 40px;\n}\n.ml40 {\n  margin-left: 40px;\n}\n.m40 {\n  margin: 40px;\n}\n.pt40 {\n  padding-top: 40px;\n}\n.pr40 {\n  padding-right: 40px;\n}\n.pb40 {\n  padding-bottom: 40px;\n}\n.pl40 {\n  padding-left: 40px;\n}\n.p40 {\n  padding: 40px;\n}\n.mt45 {\n  margin-top: 45px;\n}\n.mr45 {\n  margin-right: 45px;\n}\n.mb45 {\n  margin-bottom: 45px;\n}\n.ml45 {\n  margin-left: 45px;\n}\n.m45 {\n  margin: 45px;\n}\n.pt45 {\n  padding-top: 45px;\n}\n.pr45 {\n  padding-right: 45px;\n}\n.pb45 {\n  padding-bottom: 45px;\n}\n.pl45 {\n  padding-left: 45px;\n}\n.p45 {\n  padding: 45px;\n}\n.mt50 {\n  margin-top: 50px;\n}\n.mr50 {\n  margin-right: 50px;\n}\n.mb50 {\n  margin-bottom: 50px;\n}\n.ml50 {\n  margin-left: 50px;\n}\n.m50 {\n  margin: 50px;\n}\n.pt50 {\n  padding-top: 50px;\n}\n.pr50 {\n  padding-right: 50px;\n}\n.pb50 {\n  padding-bottom: 50px;\n}\n.pl50 {\n  padding-left: 50px;\n}\n.p50 {\n  padding: 50px;\n}\n#loading {\n  position: fixed;\n  width: 100%;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  z-index: 10000;\n  display: block;\n  background: transparent;\n  transition: all 0.5s;\n}\n#loading.hide {\n  display: none;\n}\n#loading .loading-inner {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  transition: transform 0.5s;\n  margin: auto;\n  width: 100px;\n  height: 100px;\n  border-radius: 10px;\n  color: #fff;\n  text-align: center;\n  background-color: rgba(0,0,0,0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  font-size: 0.75rem;\n}\n#loading .loading-inner i {\n  width: 40px;\n  height: 40px;\n  margin-bottom: 7px;\n  animation: loading 1s steps(12, end) infinite;\n  vertical-align: middle;\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAiIGhlaWdodD0iMTIwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGgxMDB2MTAwSDB6Ii8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjRTlFOUU5IiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTMwKSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iIzk4OTY5NyIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgzMCAxMDUuOTggNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjOUI5OTlBIiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKDYwIDc1Ljk4IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0EzQTFBMiIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA2NSA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNBQkE5QUEiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoMTIwIDU4LjY2IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0IyQjJCMiIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgxNTAgNTQuMDIgNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjQkFCOEI5IiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKDE4MCA1MCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNDMkMwQzEiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTE1MCA0NS45OCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNDQkNCQ0IiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTEyMCA0MS4zNCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNEMkQyRDIiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIDM1IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0RBREFEQSIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgtNjAgMjQuMDIgNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjRTJFMkUyIiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKC0zMCAtNS45OCA2NSkiLz48L3N2Zz4=\");\n  background-size: 100%;\n}\n@-moz-keyframes loading {\n0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n}\n100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n}\n}\n@-webkit-keyframes loading {\n0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n}\n100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n}\n}\n@-o-keyframes loading {\n0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n}\n100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n}\n}\n@keyframes loading {\n0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n}\n100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n}\n}\n.fade-enter-active,\n.fade-leave-active {\n  transition: opacity 0.5s;\n}\n.fade-enter,\n.fade-leave-to {\n  opacity: 0;\n}\n.fadeUp-enter-active,\n.fadeUp-leave-active {\n  transition: all 0.5s;\n}\n.fadeUp-enter,\n.fadeUp-leave-to {\n  opacity: 0;\n  transform: translateY(-100%);\n}\n.fadeUp {\n  opacity: 0;\n  animation: fadeUp 1s forwards;\n}\n.fadeDown {\n  opacity: 0;\n  animation-name: fadeDown;\n  animation-duration: 1s;\n  animation-fill-mode: forwards;\n}\n.zoomIn {\n  transform: scale(1.4);\n  animation-name: zoomIn;\n  animation-duration: 1s;\n  animation-fill-mode: forwards;\n}\n.zoomOut {\n  animation-name: zoomOut;\n  animation-duration: 1s;\n  animation-fill-mode: backwards;\n}\n.info-b5-robot3-animation {\n  animation-name: info-b5-robot3-animation;\n  animation-duration: 3s;\n  animation-fill-mode: forwards;\n}\n.is-mobile .info-b5-robot3-animation {\n  animation-name: info-b5-robot3-animation-mobile;\n}\n.delay1 {\n  animation-delay: 0.3s;\n}\n.delay2 {\n  animation-delay: 0.6s;\n}\n.delay3 {\n  animation-delay: 0.9s;\n}\n.delay4 {\n  animation-delay: 1.2s;\n}\n.delay5 {\n  animation-delay: 1.5s;\n}\n.delay6 {\n  animation-delay: 1.8s;\n}\n.delay7 {\n  animation-delay: 2.1s;\n}\n.delay8 {\n  animation-delay: 2.4s;\n}\n.delay9 {\n  animation-delay: 2.7s;\n}\n.delay10 {\n  animation-delay: 3s;\n}\n.delay11 {\n  animation-delay: 3.3s;\n}\n.delay12 {\n  animation-delay: 3.6s;\n}\n.delay13 {\n  animation-delay: 3.9s;\n}\n.delay14 {\n  animation-delay: 4.2s;\n}\n.delay15 {\n  animation-delay: 4.5s;\n}\n.delay16 {\n  animation-delay: 4.8s;\n}\n.delay17 {\n  animation-delay: 5.1s;\n}\n.delay18 {\n  animation-delay: 5.399999999999999s;\n}\n.delay19 {\n  animation-delay: 5.7s;\n}\n.delay20 {\n  animation-delay: 6s;\n}\n@-moz-keyframes loading {\n0% {\n    opacity: 1;\n    transform: rotate(0);\n}\n90% {\n    opacity: 1;\n    transform: rotate(360deg);\n}\n100% {\n    opacity: 0;\n    transform: rotate(360deg);\n}\n}\n@-webkit-keyframes loading {\n0% {\n    opacity: 1;\n    transform: rotate(0);\n}\n90% {\n    opacity: 1;\n    transform: rotate(360deg);\n}\n100% {\n    opacity: 0;\n    transform: rotate(360deg);\n}\n}\n@-o-keyframes loading {\n0% {\n    opacity: 1;\n    transform: rotate(0);\n}\n90% {\n    opacity: 1;\n    transform: rotate(360deg);\n}\n100% {\n    opacity: 0;\n    transform: rotate(360deg);\n}\n}\n@keyframes loading {\n0% {\n    opacity: 1;\n    transform: rotate(0);\n}\n90% {\n    opacity: 1;\n    transform: rotate(360deg);\n}\n100% {\n    opacity: 0;\n    transform: rotate(360deg);\n}\n}\n@-moz-keyframes map {\n0% {\n    opacity: 0;\n    transform: scale(0.5);\n}\n100% {\n    opacity: 1;\n    transform: scale(1);\n}\n}\n@-webkit-keyframes map {\n0% {\n    opacity: 0;\n    transform: scale(0.5);\n}\n100% {\n    opacity: 1;\n    transform: scale(1);\n}\n}\n@-o-keyframes map {\n0% {\n    opacity: 0;\n    transform: scale(0.5);\n}\n100% {\n    opacity: 1;\n    transform: scale(1);\n}\n}\n@keyframes map {\n0% {\n    opacity: 0;\n    transform: scale(0.5);\n}\n100% {\n    opacity: 1;\n    transform: scale(1);\n}\n}\n@-moz-keyframes info-b5-robot3-animation-mobile {\n0% {\n    opacity: 0;\n    transform: translate(3.125rem, 6.25rem) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(1.5625rem, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(0.9375rem, 0) scale(0.8);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@-webkit-keyframes info-b5-robot3-animation-mobile {\n0% {\n    opacity: 0;\n    transform: translate(3.125rem, 6.25rem) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(1.5625rem, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(0.9375rem, 0) scale(0.8);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@-o-keyframes info-b5-robot3-animation-mobile {\n0% {\n    opacity: 0;\n    transform: translate(3.125rem, 6.25rem) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(1.5625rem, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(0.9375rem, 0) scale(0.8);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@keyframes info-b5-robot3-animation-mobile {\n0% {\n    opacity: 0;\n    transform: translate(3.125rem, 6.25rem) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(1.5625rem, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(0.9375rem, 0) scale(0.8);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@-moz-keyframes info-b5-robot3-animation {\n0% {\n    opacity: 0;\n    transform: translate(800px, 600px) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(800px, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(400px, 0) scale(0.7);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@-webkit-keyframes info-b5-robot3-animation {\n0% {\n    opacity: 0;\n    transform: translate(800px, 600px) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(800px, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(400px, 0) scale(0.7);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@-o-keyframes info-b5-robot3-animation {\n0% {\n    opacity: 0;\n    transform: translate(800px, 600px) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(800px, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(400px, 0) scale(0.7);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@keyframes info-b5-robot3-animation {\n0% {\n    opacity: 0;\n    transform: translate(800px, 600px) scale(0.4);\n}\n30% {\n    opacity: 1;\n    transform: translate(800px, 0) scale(0.7);\n}\n60% {\n    opacity: 1;\n    transform: translate(400px, 0) scale(0.7);\n}\n100% {\n    opacity: 1;\n    transform: translate(0, 0) scale(1);\n}\n}\n@-moz-keyframes fadeUp {\n0% {\n    opacity: 0;\n    transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@-webkit-keyframes fadeUp {\n0% {\n    opacity: 0;\n    transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@-o-keyframes fadeUp {\n0% {\n    opacity: 0;\n    transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@keyframes fadeUp {\n0% {\n    opacity: 0;\n    transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@-moz-keyframes fadeDown {\n0% {\n    opacity: 0;\n    transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@-webkit-keyframes fadeDown {\n0% {\n    opacity: 0;\n    transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@-o-keyframes fadeDown {\n0% {\n    opacity: 0;\n    transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@keyframes fadeDown {\n0% {\n    opacity: 0;\n    transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    transform: translateY(0);\n}\n}\n@-moz-keyframes fadeRight {\n0% {\n    opacity: 0;\n    transform: translateX(100px);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@-webkit-keyframes fadeRight {\n0% {\n    opacity: 0;\n    transform: translateX(100px);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@-o-keyframes fadeRight {\n0% {\n    opacity: 0;\n    transform: translateX(100px);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@keyframes fadeRight {\n0% {\n    opacity: 0;\n    transform: translateX(100px);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@-moz-keyframes zoomIn {\n0% {\n    opacity: 0;\n    transform: scale(1.4);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@-webkit-keyframes zoomIn {\n0% {\n    opacity: 0;\n    transform: scale(1.4);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@-o-keyframes zoomIn {\n0% {\n    opacity: 0;\n    transform: scale(1.4);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@keyframes zoomIn {\n0% {\n    opacity: 0;\n    transform: scale(1.4);\n}\n100% {\n    opacity: 1;\n    transform: translateX(0);\n}\n}\n@-moz-keyframes zoomOut {\n0% {\n    opacity: 0;\n    transform: scale(0.8);\n}\n100% {\n    transform: scale(1);\n}\n}\n@-webkit-keyframes zoomOut {\n0% {\n    opacity: 0;\n    transform: scale(0.8);\n}\n100% {\n    transform: scale(1);\n}\n}\n@-o-keyframes zoomOut {\n0% {\n    opacity: 0;\n    transform: scale(0.8);\n}\n100% {\n    transform: scale(1);\n}\n}\n@keyframes zoomOut {\n0% {\n    opacity: 0;\n    transform: scale(0.8);\n}\n100% {\n    transform: scale(1);\n}\n}\n.is-mobile {\n  width: 100%;\n  overflow: hidden;\n}\n.is-mobile .w {\n  width: 100%;\n}\n.is-mobile .cp-robot .tabs {\n  border-top: none;\n  border-bottom: 1px solid #eae9e9;\n  box-shadow: none;\n}\n.is-mobile .cp-robot .tabs a {\n  margin: 0 2.1875rem;\n}\n.is-mobile .robot-spec {\n  padding: 0;\n}\n.is-mobile .robot-spec .row {\n  display: block;\n  text-align: left;\n  padding: 1.25rem 0;\n  margin: 0 1.25rem;\n}\n.is-mobile .robot-spec .row .col1 {\n  width: 100%;\n  text-align: left;\n  padding-bottom: 0.625rem;\n}\n.is-mobile .robot-spec .row .col1 i {\n  display: none;\n}\n.is-mobile .robot-spec .row .params {\n  border: none;\n  padding: 0;\n}\n.is-mobile .robot-spec .row .params .param {\n  line-height: 2.5;\n}\n.is-mobile .robot-spec .row .params .col2 {\n  width: 4.0625rem;\n}\nbody {\n  font-size: 14px;\n  font-family: \"Helvetica Neue\", Helvetica, \"PingFang SC\", \"Hiragino Sans GB\", \"Microsoft YaHei\", \"\\5FAE\\8F6F\\96C5\\9ED1\", Arial, sans-serif;\n  color: #000;\n  background: #fff;\n}\n.w {\n  width: 1200px;\n  margin: 0 auto;\n}\n.ani-card {\n  transition: 1s all;\n}\n.ani-card:hover:hover {\n  box-shadow: 7px 7px 8px #ddd;\n}\n.app-footer {\n  color: #7d7d7d;\n  padding-top: 46px;\n}\n.app-footer .links {\n  overflow: hidden;\n  padding-left: 60px;\n  padding-bottom: 50px;\n  border-bottom: 1px solid #ccc;\n}\n.app-footer .links .col {\n  float: left;\n  margin-right: 130px;\n  font-size: 14px;\n}\n.app-footer .links .col:last-child {\n  margin-right: 0;\n}\n.app-footer .links .col h3 {\n  padding-bottom: 20px;\n  font-size: 18px;\n}\n.app-footer .links .col a {\n  display: block;\n  height: 18px;\n  line-height: 18px;\n  margin-bottom: 5px;\n  cursor: pointer;\n}\n.app-footer .links .cocern {\n  padding-right: 80px;\n  margin-right: 80px;\n  position: relative;\n}\n.app-footer .links .cocern a {\n  padding-left: 24px;\n}\n.app-footer .links .cocern .weixin {\n  background: url(" + escape(__webpack_require__("kiD0")) + ") no-repeat left center;\n}\n.app-footer .links .cocern .weibo {\n  background: url(" + escape(__webpack_require__("xF3L")) + ") no-repeat left center;\n}\n.app-footer .links .cocern .app {\n  background: url(" + escape(__webpack_require__("o2Bm")) + ") no-repeat left center;\n}\n.app-footer .links .cocern .weixin:hover .qr-img,\n.app-footer .links .cocern .app:hover .qr-img {\n  opacity: 1;\n  transform: translateX(0);\n}\n.app-footer .links .cocern .qr-img {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  width: 74px;\n  height: 74px;\n  transition: 0.5s all;\n  opacity: 0;\n  transform: translateX(20px);\n}\n.app-footer .links .tel a {\n  display: block;\n  font-size: 22px;\n  color: #27ccc7;\n  font-weight: normal;\n}\n.app-footer .links .tel p {\n  padding-top: 10px;\n}\n.app-footer .copyright {\n  text-align: center;\n  padding: 35px 0;\n}\n.is-mobile .weixin-pop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(0,0,0,0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.is-mobile .weixin-pop img {\n  width: 60%;\n}\n.is-mobile .app-footer {\n  padding-top: 2.1875rem;\n}\n.is-mobile .app-footer .links {\n  padding-bottom: 0;\n  border: none;\n}\n.is-mobile .app-footer .links .cocern {\n  padding: 0;\n}\n.is-mobile .app-footer .links .col {\n  vertical-align: top;\n  display: inline-block;\n  float: inherit;\n  width: 9.6875rem;\n  margin-right: 0;\n  margin-bottom: 1.5625rem;\n}\n.is-mobile .app-footer .links .tel {\n  text-align: center;\n  width: 100%;\n  margin-left: -2.1875rem;\n  padding-top: 0.9375rem;\n}\n.is-mobile .app-footer .copyright {\n  padding: 0 0 0.9375rem;\n  font-size: 0.5625rem;\n}\n", ""]);

// exports


/***/ }),

/***/ "usSO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2s-info-b4.065741d.jpg";

/***/ }),

/***/ "uxuc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_news_vue__ = __webpack_require__("D2nS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b2b2df2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_news_vue__ = __webpack_require__("fNd4");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("vF9g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_news_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b2b2df2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_news_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src\\views\\news.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6b2b2df2", Component.options)
  } else {
    hotAPI.reload("data-v-6b2b2df2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vF9g":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("RlN6");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("bd366f7a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6b2b2df2\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./news.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6b2b2df2\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./news.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vcm0":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAABC1BMVEVMaXH/lo//nL3/nb//lJ3/mbT/nLn/nb3/nL7/mKn/nL7/nb//mI//lZH/lKr/l5b/nb3/nL7/l5f/ncD/mZ3/ncH/nb7/man/ncH/nb//lo3/mqz/maH/nL7/lIf/lo3/mab/nb7/ncH/lo7/mqz/nL7/mKX/l57/lpD/nr7/nbz/jp3/loz/maL/mZ7/maT8o4r/mJb/mJr/l5r/nb//nL/xuIT/m7H/mqb/nLL/maj/ncD/nLb/maX/m67/nLj/m7H/mqr/m7D/mqn/m7P/nLv/mqz/mqf/nLr/nb3/maL/maD/nb//mJ3/mZ//mJv/mJj/mJr/mJb/l5P/l5X/l5H/l4//lo3/ncNU8npJAAAAO3RSTlMAXNLcDBQjMFwasEkoYwTwmMVTKkGFkMtn+tLncvUgpcE8dL85u6Dy4Sd9/vPj+Ytve9e9pOpe+qXt2cW+71EAAAHJSURBVHja7dVZUxpREIbhj1lgBmYB2UEW2SQqRs2eg4BBkmhMJBIT/v8vSQ2xLCxZumcmd+e5OXVu3u67hiRJkiRJ0iovjFxcUVWlnTNiIVYPFLFEzYbTjibFM69DSDduxCpZBKOnxBpKGgHE3oi1iokA3aLYxHfZLIrNYvBHFVtUHPiRFFvF4UNMECTAl7ohUMG2d0VigCs+IUmBSat8pYmCxxgSHYAn2SeKg6dNDSvgKV8SjXRw6O9GVDFwRD+RZXjhARkvbF58pmqBwylfUJlgyY+JyuB5/4WoDp7dc6KX4DGp4RaY6tckPXDtfCPZBZ2WyzoAej8IjjUACQMkrwYi5638ncBb2JhfdkDRvR62FwNutzoDgPjVeAaKzFk+7b364e3050ZTa3F2PxyfgOXtdAsbC5oJppPDu01O4Zs9+7XW7BQBZNzZGvcRBGLW7ldqWvBLzxbg2Sn9fqZrw2MU4EN+OC/gX7r554lmxIGnMJ90wHd33k/iQTVSKx15zaNSzbbwIDUcu+CLdPMmlmhVy6pqWNLquTb+C0dDMNH0k5+OkCTEvIFHjXllD+H4OOhP8GjSH9URDtvdXzqZnX03AkmSJEn6C5TNfjfHxRXPAAAAAElFTkSuQmCC"

/***/ }),

/***/ "vffT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "robot-info robot2s" }, [
    _c("div", { attrs: { id: "info-b1" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB1Visible } }, [
          _vm._v("未来之选 尽显科技")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1", class: { fadeUp: _vm.isB1Visible } },
          [_vm._v("维拉2.0      ¥18,999元/套")]
        ),
        _c(
          "div",
          { staticClass: "p3 delay1", class: { fadeDown: _vm.isB1Visible } },
          [
            _c("img", {
              attrs: { src: __webpack_require__("ObJJ") }
            })
          ]
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b2" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB2Visible } }, [
          _vm._v("语音技能")
        ]),
        _c(
          "div",
          { staticClass: "list" },
          _vm._l(_vm.b2List, function(item, index) {
            return _c(
              "div",
              {
                staticClass: "item",
                class: [{ fadeDown: _vm.isB2Visible }, "delay" + (index + 1)]
              },
              [
                _c("h3", [_vm._v(_vm._s(item.text))]),
                _c("p", [_vm._v(_vm._s(item.tag))])
              ]
            )
          })
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b3" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB3Visible } }, [
          _vm._v("亲情陪伴")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1 mt10", class: { fadeUp: _vm.isB3Visible } },
          [
            _vm._v("免接听式视频通话"),
            _c("br"),
            _vm._v("即使不在家，随时查看家里任意角落")
          ]
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b4" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB4Visible } }, [
          _vm._v("智慧家庭")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1 mt10", class: { fadeUp: _vm.isB4Visible } },
          [
            _vm._v("家庭新成员，从此多了一位生活助手。"),
            !_vm.isMobile ? _c("br") : _vm._e(),
            _vm._v(
              " 全天无休的“保安”，发现问题可以前往确认，出门在外亦可不必担忧。"
            )
          ]
        ),
        _c(
          "div",
          { staticClass: "p3 delay2", class: { fadeDown: _vm.isB4Visible } },
          [
            _vm.isMobile
              ? _c("img", {
                  attrs: { src: __webpack_require__("9BV7") }
                })
              : _c("img", {
                  attrs: { src: __webpack_require__("HsVw") }
                })
          ]
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b5" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB5Visible } }, [
          _vm._v("智慧健康")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1 mt10", class: { fadeUp: _vm.isB5Visible } },
          [
            _vm._v("多了一个关心你的机器“人”"),
            _c("br"),
            _vm._v("少了一个需要你担心的人"),
            _c("br"),
            _c("br"),
            _vm._v(
              "家人各项健康数据，机器人可以全部掌握，并汇总分析后给出建议。"
            )
          ]
        ),
        _c(
          "div",
          {
            staticClass: "p3 delay2 mt20",
            class: { fadeDown: _vm.isB5Visible }
          },
          [
            _c("img", {
              attrs: { src: __webpack_require__("laUw") }
            })
          ]
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b6" } }, [
      _c("div", { staticClass: "w" }, [
        _c(
          "div",
          {
            staticClass: "msg blue delay1",
            class: { fadeUp: _vm.isB6Visible }
          },
          [_vm._v("主人，7点到了记得看新闻联播哦")]
        ),
        _c(
          "div",
          { staticClass: "msg2 delay2", class: { fadeUp: _vm.isB6Visible } },
          [_vm._v("维拉，7点提醒我看新闻联播")]
        ),
        _c(
          "div",
          { staticClass: "p1 delay3", class: { fadeUp: _vm.isB6Visible } },
          [_vm._v("智慧关爱")]
        ),
        _c(
          "div",
          { staticClass: "p3 delay4 mt10", class: { fadeUp: _vm.isB6Visible } },
          [
            _vm._v("任何小事，随口交代，机器人自会帮你记着。"),
            _c("br"),
            _vm._v(" 帮你语音提醒家人，关爱更进一步。")
          ]
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b7" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB7Visible } }, [
          _vm._v("运动自如")
        ]),
        _c(
          "div",
          { staticClass: "p3 delay1 mt10", class: { fadeUp: _vm.isB7Visible } },
          [
            _vm._v("工业级TPU橡胶，子午线轮胎。"),
            _c("br"),
            _vm._v("粉末冶金工艺，行星轮减速器。"),
            _c("br"),
            _vm._v("摇杆式操作，享受控制机器人运动的快感。")
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d356b33", esExports)
  }
}

/***/ }),

/***/ "vfxQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dialog1.4596904.png";

/***/ }),

/***/ "vo70":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-info-b2.daa5c5b.jpg";

/***/ }),

/***/ "wtzt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-img1.18d1103.png";

/***/ }),

/***/ "wufj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-platform-img1.667ee24.png";

/***/ }),

/***/ "xF3L":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAMAAAAVBLyFAAAAWlBMVEVMaXGFhZB/g5WAg5N+g5OGhoZ/hZJ+g5N+g5R/hJN/hJOEhJd/hJOAgpR/hJN/g5J/hJR9gZOHh5aJiZyCgpJ/gpKAgpSAhJN/g5R/gZJ+hJOAhJOBhJOAhJQJLS/cAAAAHXRSTlMAFzpeqQQp+vPYoBuQy33k3kcRDS+wc4XsasW3URpGy6kAAACgSURBVHjaTc43DgNBDENRTtSkzdk2739Na7GA4Veo+GyEP3NmPhbgEWLQu7om2TyhTxx1nryzUqBipopLXN3gfIJuiUo6PVdfdgJW+FMmu2eYgUzNLqG6jn3FXNHIru4D8wdho1wAEs+515wYYUkJd/LI77UkOnye5JmDL5cwGf2eGwAz0kcv7Ow0kkOFMp7ybq1o4GbwiMfrJM/XseL2BfKcDHhyD/OxAAAAAElFTkSuQmCC"

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_header_vue__ = __webpack_require__("ptHS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_footer_vue__ = __webpack_require__("MGI2");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_app_header_vue__["a" /* default */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components_app_footer_vue__["a" /* default */]
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "ySqE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3s-info-3.49a2dcc.png";

/***/ }),

/***/ "zAZ4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATYAAAABCAMAAABjanI6AAAABlBMVEU7wLz19/lZ+NuhAAAAGUlEQVR42r3BAQ0AAACCMOhf2hKOH3uc2RuM7ADnFw5QHwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "zfwD":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("jd1m");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("a16fbd68", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6b826b08\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6b826b08\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/stylus-loader/index.js?{\"paths\":\"D:\\\\workspace\\\\flyingwings\\\\zh-www\\\\flwweb\\\\flwweb\\\\src\\\\stylus\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ziMH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/server-weixin.3b7e523.png";

/***/ }),

/***/ "ztg+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/robot3.0c1891e.png";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.94d16dd1a473c7227e2c.js